export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  IsoDateTime: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  LimitedInt: { input: any; output: any; }
  /** ObjectId custom scalar type */
  ObjectId: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  Upload: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type AcceptRequestedPublicGroupInput = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export enum AccountRoles {
  Applicant = 'APPLICANT',
  Mentor = 'MENTOR',
  University = 'UNIVERSITY'
}

export type ActivateApplicantsMutation = {
  __typename?: 'ActivateApplicantsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivateMentorsMutation = {
  __typename?: 'ActivateMentorsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivityField = {
  __typename?: 'ActivityField';
  activitySource?: Maybe<ActivitySourceField>;
  app?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AnyUserField>;
};

export type ActivitySourceField = {
  __typename?: 'ActivitySourceField';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
};

export type AddAttributeOptionMutation = {
  __typename?: 'AddAttributeOptionMutation';
  university?: Maybe<UniversityField>;
};

export type AddBotToChatGroupMutation = {
  __typename?: 'AddBotToChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type AddCustomAttributeMutation = {
  __typename?: 'AddCustomAttributeMutation';
  university?: Maybe<UniversityField>;
};

export type AddDegreeLevelsMutation = {
  __typename?: 'AddDegreeLevelsMutation';
  degreeLevels?: Maybe<Array<Maybe<DegreeLevelField>>>;
};

export type AddDegreesMutation = {
  __typename?: 'AddDegreesMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type AddHobsonsConnectIntegration = {
  __typename?: 'AddHobsonsConnectIntegration';
  integration?: Maybe<CampusManagementConnectIntegrationField>;
};

export type AddLocalesToApp = {
  __typename?: 'AddLocalesToApp';
  appLocales?: Maybe<Array<Maybe<AppLocaleField>>>;
};

export type AddResearchTimeMutation = {
  __typename?: 'AddResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type AddYearOfStudyMutation = {
  __typename?: 'AddYearOfStudyMutation';
  yearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
};

export type AdminDeleteApplicantMutation = {
  __typename?: 'AdminDeleteApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type AdminRecommendation = {
  __typename?: 'AdminRecommendation';
  active: Scalars['Boolean']['output'];
  cohort?: Maybe<Cohort>;
  description: Scalars['String']['output'];
  forDecisionStage: DecisionStageEnum;
  id: Scalars['ObjectId']['output'];
  resourceType: RecommendationResourceType;
  title: Scalars['String']['output'];
  universityId: Scalars['ObjectId']['output'];
  url: Scalars['String']['output'];
};

export type AdminRecommendationCountPerDecisionStage = {
  __typename?: 'AdminRecommendationCountPerDecisionStage';
  forDecisionStage: DecisionStageEnum;
  recommendationCount: Scalars['Int']['output'];
};

export type AdminRecommendationInput = {
  cohort?: InputMaybe<CohortInput>;
  description: Scalars['String']['input'];
  forDecisionStage: DecisionStageEnum;
  resourceType: RecommendationResourceTypeEnum;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AdminUpdateMentorMutation = {
  __typename?: 'AdminUpdateMentorMutation';
  mentor?: Maybe<MentorField>;
};

export type AdminUserField = {
  __typename?: 'AdminUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AgeVerificationInfoField = {
  __typename?: 'AgeVerificationInfoField';
  age?: Maybe<Scalars['Int']['output']>;
  consentAgeForCountry?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  isMinor?: Maybe<Scalars['Boolean']['output']>;
};

export type AgeVerificationInfoInputField = {
  age?: InputMaybe<Scalars['Int']['input']>;
  consentAgeForCountry?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  isMinor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiConversationHistoryInput = {
  conversationId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type AiConversationHistoryOutput = {
  __typename?: 'AIConversationHistoryOutput';
  id: Scalars['String']['output'];
  lastLockedDate?: Maybe<Scalars['DateTime']['output']>;
  lastPromptUsed?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<AiConversationMessage>;
  summary?: Maybe<AiConversationMessage>;
  universityId: Scalars['String']['output'];
  userConversationId: Scalars['String']['output'];
};

export type AiConversationMessage = {
  __typename?: 'AIConversationMessage';
  content: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  functionCall?: Maybe<FunctionCall>;
  name?: Maybe<Scalars['String']['output']>;
  role: SenderRole;
  toolCallId?: Maybe<Scalars['String']['output']>;
  toolCalls?: Maybe<Array<ToolCall>>;
};

export type AlertField = {
  __typename?: 'AlertField';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};

export type AllPostsField = {
  __typename?: 'AllPostsField';
  blogPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  blogPostsAuthors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blogPostsCount?: Maybe<Scalars['Int']['output']>;
  blogPostsDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  blogPostsTopics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AmbassadorField = {
  __typename?: 'AmbassadorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
};

export type AmbassadorProfileInformation = {
  __typename?: 'AmbassadorProfileInformation';
  accountRole: Buddies;
  bio: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  degreeName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  universityId?: Maybe<Scalars['String']['output']>;
};

export type AmbassadorRecommendation = {
  __typename?: 'AmbassadorRecommendation';
  active: Scalars['Boolean']['output'];
  ambassadorId: Scalars['ObjectId']['output'];
  forDecisionStage?: Maybe<DecisionStageEnum>;
  id: Scalars['ObjectId']['output'];
  resourceType: AmbassadorRecommendationResourceType;
  resourceURL: Scalars['String']['output'];
  sharedWithUser: Scalars['ObjectId']['output'];
  universityId: Scalars['ObjectId']['output'];
};

export type AmbassadorRecommendationInput = {
  resourceType: AmbassadorRecommendationResourceTypeEnum;
  resourceURL: Scalars['String']['input'];
  sharedWithUser: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type AmbassadorRecommendationResourceType = {
  __typename?: 'AmbassadorRecommendationResourceType';
  displayName: Scalars['String']['output'];
  name: AmbassadorRecommendationResourceTypeEnum;
};

export enum AmbassadorRecommendationResourceTypeEnum {
  Ambassador = 'AMBASSADOR',
  Blog = 'BLOG'
}

export type Analytics = {
  __typename?: 'Analytics';
  attendees: Attendees;
  id: Scalars['ObjectId']['output'];
  messagesSent: Scalars['Float']['output'];
  signups: Scalars['Float']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type AnalyticsBuddyField = {
  __typename?: 'AnalyticsBuddyField';
  buddyId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GraphField>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDashboardAuthField = {
  __typename?: 'AnalyticsDashboardAuthField';
  key?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDashboardMetadata = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsMentorField = {
  __typename?: 'AnalyticsMentorField';
  data?: Maybe<GraphField>;
  degree?: Maybe<Scalars['String']['output']>;
  mentorId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AnyChatUserField = {
  __typename?: 'AnyChatUserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  chatIntroMessage?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  headlineInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboxInfoOne?: Maybe<Scalars['String']['output']>;
  inboxInfoTwo?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};


export type AnyChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnyUserField = {
  __typename?: 'AnyUserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<DegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  domesticRegion?: Maybe<DomesticRegionField>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserField>;
  university?: Maybe<UniversityField>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ApplicantBroadcastMessageMutation = {
  __typename?: 'ApplicantBroadcastMessageMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicantCollectionField = {
  __typename?: 'ApplicantCollectionField';
  fieldName?: Maybe<Scalars['String']['output']>;
  isCustomField?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ApplicantConversationField = {
  __typename?: 'ApplicantConversationField';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApplicantCountField = {
  __typename?: 'ApplicantCountField';
  applicantCount?: Maybe<Scalars['Int']['output']>;
};

export type ApplicantField = {
  __typename?: 'ApplicantField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  ageVerificationInfo?: Maybe<AgeVerificationInfoField>;
  applicantUniversities?: Maybe<Array<Maybe<ApplicantUniversityLinkField>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAcceptedMarketing?: Maybe<Scalars['Boolean']['output']>;
  hasAppliedToCurrentUniversity?: Maybe<Scalars['Boolean']['output']>;
  hasReadChatRules?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkWithUniversity?: Maybe<ApplicantUniversityLinkField>;
  localePreference?: Maybe<UserLocalePreference>;
  marketplaces?: Maybe<Array<Maybe<ApplicantMarketplaceObjectField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<ApplicantPreferencesField>;
  primaryApp?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<ApplicantSchoolHistory>;
  signUpLocation?: Maybe<Scalars['String']['output']>;
  unibuddyServicesConsentAccepted?: Maybe<Scalars['Boolean']['output']>;
  unibuddySignupMetadata?: Maybe<ApplicantUnibuddySignupMetadataField>;
  /** @deprecated Deprecated favoring applicant_universities */
  universitiesApplied?: Maybe<Array<Maybe<ApplicantUniversityLinkField>>>;
  universitiesInterested?: Maybe<Array<Maybe<UniversityField>>>;
};


export type ApplicantFieldLinkWithUniversityArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantInboxField = {
  __typename?: 'ApplicantInboxField';
  botChatGroup?: Maybe<ChatGroupField>;
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  universityClearingChatGroup?: Maybe<ChatGroupField>;
};

export type ApplicantInvite = {
  __typename?: 'ApplicantInvite';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantLabelField = {
  __typename?: 'ApplicantLabelField';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicantMarketplaceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  userData?: InputMaybe<MarketplaceApplicantData>;
};

export type ApplicantMarketplaceObjectField = {
  __typename?: 'ApplicantMarketplaceObjectField';
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<MarketplaceApplicantUserData>;
};

export type ApplicantPreferencesField = {
  __typename?: 'ApplicantPreferencesField';
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicantsAppliedStats = {
  __typename?: 'ApplicantsAppliedStats';
  applied?: Maybe<Scalars['Int']['output']>;
  notApplied?: Maybe<Scalars['Int']['output']>;
  notReplied?: Maybe<Scalars['Int']['output']>;
};

export type ApplicantSchoolHistory = {
  __typename?: 'ApplicantSchoolHistory';
  highSchool?: Maybe<HighSchoolField>;
};

export type ApplicantSignupStats = {
  __typename?: 'ApplicantSignupStats';
  xAxis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  yAxis?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ApplicantsMessagedCount = {
  __typename?: 'ApplicantsMessagedCount';
  messagedCount?: Maybe<Scalars['Int']['output']>;
};

export enum ApplicantUnibuddySignupClientType {
  App = 'APP',
  Embed = 'EMBED',
  Pwa = 'PWA',
  Web = 'WEB'
}

export type ApplicantUnibuddySignupMetadataField = {
  __typename?: 'ApplicantUnibuddySignupMetadataField';
  clientType?: Maybe<ApplicantUnibuddySignupClientType>;
  communityId?: Maybe<Scalars['String']['output']>;
  creationDateTime?: Maybe<Scalars['DateTime']['output']>;
  inviteId?: Maybe<Scalars['String']['output']>;
  marketplaceId?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<ApplicantUnibuddySignupSourceType>;
  universityId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUnibuddySignupMetadataInputField = {
  clientType: ApplicantUnibuddySignupClientType;
  communityId?: InputMaybe<Scalars['String']['input']>;
  creationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  sourceType: ApplicantUnibuddySignupSourceType;
  universityId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum ApplicantUnibuddySignupSourceType {
  ExternalBuddyCard = 'EXTERNAL_BUDDY_CARD',
  MarketplaceWidget = 'MARKETPLACE_WIDGET',
  MicrositeEvents = 'MICROSITE_EVENTS',
  Unibuddy = 'UNIBUDDY',
  UniversityWidget = 'UNIVERSITY_WIDGET',
  WebinarEvents = 'WEBINAR_EVENTS'
}

export type ApplicantUniversityLinkField = {
  __typename?: 'ApplicantUniversityLinkField';
  applied?: Maybe<Scalars['Boolean']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  delinked?: Maybe<Scalars['Boolean']['output']>;
  hasAcceptedMarketing?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  setupComplete?: Maybe<Scalars['Boolean']['output']>;
  university?: Maybe<UniversityField>;
};


export type ApplicantUniversityLinkFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicantUserField = ChatUserField & {
  __typename?: 'ApplicantUserField';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ApplicationField = {
  __typename?: 'ApplicationField';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationInsightModel = {
  __typename?: 'ApplicationInsightModel';
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['output'];
  id: Scalars['ObjectId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  totalApplied: Scalars['Int']['output'];
  university: UniversityField;
};

export type AppliedUsersCountInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type AppliedUsersCountModel = {
  __typename?: 'AppliedUsersCountModel';
  appliedUsersCount: Scalars['Int']['output'];
};

export type AppLocaleField = {
  __typename?: 'AppLocaleField';
  locales?: Maybe<Array<Maybe<Locale>>>;
  name?: Maybe<Scalars['String']['output']>;
  universityLocalePreferenceApplies?: Maybe<Scalars['Boolean']['output']>;
};

export type AppLocalesFieldInput = {
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AssistantConversationFeedback = {
  __typename?: 'AssistantConversationFeedback';
  /** When the feedback was created */
  createdAt: Scalars['DateTime']['output'];
  /** Rating from 1-5 on the quality of the conversation */
  rating: Scalars['Float']['output'];
  /** Optional free text for the conversation feedback */
  text?: Maybe<Scalars['String']['output']>;
  /** When the feedback was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AssistantConversationHistory = {
  __typename?: 'AssistantConversationHistory';
  feedback?: Maybe<AssistantConversationFeedback>;
  id: Scalars['String']['output'];
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<AssistantConversationMessage>;
  universityId: Scalars['String']['output'];
};

export type AssistantConversationHistoryWithToken = {
  __typename?: 'AssistantConversationHistoryWithToken';
  feedback?: Maybe<AssistantConversationFeedback>;
  id: Scalars['String']['output'];
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<AssistantConversationMessage>;
  token?: Maybe<Scalars['String']['output']>;
  universityId: Scalars['String']['output'];
};

export type AssistantConversationLead = {
  __typename?: 'AssistantConversationLead';
  conversationId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  marketingConsent?: Maybe<Scalars['Boolean']['output']>;
  ubConsent: Scalars['Boolean']['output'];
  universityId: Scalars['String']['output'];
};

export type AssistantConversationMessage = {
  __typename?: 'AssistantConversationMessage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<AssistantMessageFeedback>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<MessageMetadata>;
  sender: SenderRole;
  universityId: Scalars['String']['output'];
};

export type AssistantMessageFeedback = {
  __typename?: 'AssistantMessageFeedback';
  freeText?: Maybe<Scalars['String']['output']>;
  type: AssistantMessageFeedbackType;
};

export type AssistantMessageFeedbackInput = {
  freeText?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  type: AssistantMessageFeedbackType;
};

export enum AssistantMessageFeedbackType {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type Attachment = {
  __typename?: 'Attachment';
  fileName?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  type: AttachmentType;
};

export type AttachmentDto = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  type: AttachmentType;
};

export type AttachmentField = {
  __typename?: 'AttachmentField';
  payload?: Maybe<PayloadField>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentType {
  Pdf = 'PDF'
}

export type AttendeeAnalytics = {
  __typename?: 'AttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type AttendeeData = {
  accountRole: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ObjectId']['input'];
  virtualEventId: Scalars['ObjectId']['input'];
};

export type Attendees = {
  __typename?: 'Attendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type AuthField = {
  __typename?: 'AuthField';
  accessToken?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceField>;
  me?: Maybe<MeField>;
};

export type AuthorSnippetField = {
  __typename?: 'AuthorSnippetField';
  author?: Maybe<MentorField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type Badge = {
  __typename?: 'Badge';
  badgeId: BadgeId;
  group: BadgeGroup;
};

export enum BadgeGroup {
  Engagement = 'ENGAGEMENT',
  Onboarding = 'ONBOARDING'
}

export enum BadgeId {
  FirstCommunityJoined = 'FIRST_COMMUNITY_JOINED',
  FirstGroupJoined = 'FIRST_GROUP_JOINED',
  FirstMessageInDirectChat = 'FIRST_MESSAGE_IN_DIRECT_CHAT',
  FirstMessageInPublicGroup = 'FIRST_MESSAGE_IN_PUBLIC_GROUP',
  ProfileCompleted = 'PROFILE_COMPLETED'
}

export type BaseCustomAttributeField = CustomAttributeField & {
  __typename?: 'BaseCustomAttributeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BlockerField = {
  __typename?: 'BlockerField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BlockUserMutation = {
  __typename?: 'BlockUserMutation';
  objectsBlockedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockUserMutationV2 = {
  __typename?: 'BlockUserMutationV2';
  objectsBlockedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlogcardSnippetField = {
  __typename?: 'BlogcardSnippetField';
  authorSnippets?: Maybe<Array<Maybe<AuthorSnippetField>>>;
  description?: Maybe<DescriptionField>;
  topicSnippets?: Maybe<Array<Maybe<TopicSnippetField>>>;
};

export type BlogCommentField = {
  __typename?: 'BlogCommentField';
  author?: Maybe<AnyUserField>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BlogPostField = {
  __typename?: 'BlogPostField';
  approved?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  author?: Maybe<MentorField>;
  body?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<BlogCommentField>>>;
  coverImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  flaggedByUser?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<AnyUserField>;
  modified?: Maybe<Scalars['String']['output']>;
  numberOfViews?: Maybe<Scalars['Int']['output']>;
  ogShareUrl?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BlogStatus>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<BlogTopicField>;
  university?: Maybe<UniversityField>;
  videoContent?: Maybe<VideoContent>;
  wordCount?: Maybe<Scalars['Int']['output']>;
  youtubeVideo?: Maybe<Scalars['String']['output']>;
};


export type BlogPostFieldCoverImagesArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostFieldImageArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlogStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  ReadyToPublish = 'READY_TO_PUBLISH',
  Unpublished = 'UNPUBLISHED'
}

export type BlogTopicField = {
  __typename?: 'BlogTopicField';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BotUserField = {
  __typename?: 'BotUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export enum Buddies {
  Ambassador = 'AMBASSADOR',
  Staff = 'STAFF'
}

export type BuddiesField = {
  __typename?: 'BuddiesField';
  count?: Maybe<Scalars['Int']['output']>;
  randomizeListSeed?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<BuddyField>>>;
};

export type BuddiesFilterOptionsField = {
  __typename?: 'BuddiesFilterOptionsField';
  customAttributesFilters?: Maybe<Array<Maybe<CustomAttributesFilterField>>>;
  departments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BuddiesListFilterField = {
  __typename?: 'BuddiesListFilterField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BuddiesListFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BuddyApplicantChatGroupField = {
  __typename?: 'BuddyApplicantChatGroupField';
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  unanswered?: Maybe<Scalars['Boolean']['output']>;
};

export type BuddyApplicantChatGroupFieldV2 = {
  __typename?: 'BuddyApplicantChatGroupFieldV2';
  applicant?: Maybe<ApplicantField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageText?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  staff?: Maybe<StaffField>;
};

export type BuddyApplicantChatInterventionBuddyField = {
  __typename?: 'BuddyApplicantChatInterventionBuddyField';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
};


export type BuddyApplicantChatInterventionBuddyFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuddyField = {
  __typename?: 'BuddyField';
  active?: Maybe<Scalars['Boolean']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
  university?: Maybe<UniversityField>;
};


export type BuddyFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuddyFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuddyInviteField = {
  __typename?: 'BuddyInviteField';
  buddyInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BuddyInviteListField = {
  __typename?: 'BuddyInviteListField';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  accountWithEmailExists?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  notFound?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BulkApplicantField = {
  __typename?: 'BulkApplicantField';
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>;
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applied?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  blockedByUniversity?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributesField>>>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  domesticRegion?: Maybe<DomesticRegionField>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<ApplicantLabelField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryApp?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<ApplicantSchoolHistory>;
  signUpLocation?: Maybe<Scalars['String']['output']>;
  signupSource?: Maybe<Scalars['String']['output']>;
  sourceTrackingParams?: Maybe<SourceTrackingParamsField>;
  universitiesInterested?: Maybe<Array<Maybe<UniversityField>>>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkOptOutMarketplaceUniversityMarketingMutation = {
  __typename?: 'BulkOptOutMarketplaceUniversityMarketingMutation';
  me?: Maybe<MeField>;
};

export type ButtonField = {
  __typename?: 'ButtonField';
  inline?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CampusManagementConnectIntegrationField = {
  __typename?: 'CampusManagementConnectIntegrationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  crm?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  passKey?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  webServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type CanonicalQuestionField = {
  __typename?: 'CanonicalQuestionField';
  answers?: Maybe<Array<Maybe<FaqAnswerField>>>;
  id: Scalars['String']['output'];
  subTopic?: Maybe<SubTopicField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CarouselSnippetField = {
  __typename?: 'CarouselSnippetField';
  defaultSnippet?: Maybe<Scalars['String']['output']>;
  description?: Maybe<DescriptionField>;
};

export type ChatConversation = {
  __typename?: 'ChatConversation';
  communityChatDescription?: Maybe<Scalars['String']['output']>;
  communityChatDynamicLink?: Maybe<Scalars['String']['output']>;
  communityChatMembers?: Maybe<Array<UserField>>;
  communityChatTitle?: Maybe<Scalars['String']['output']>;
  communityId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserField>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  firstPublicConversationJoined?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  isNewsFeed: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isReplica?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Labels>>;
  lastMessage?: Maybe<ChatMessage>;
  members?: Maybe<Array<UserField>>;
  mutedBy: Array<Scalars['ID']['output']>;
  paginatedMessages?: Maybe<PaginatedChatMessages>;
  pinnedMessages: Array<ChatMessage>;
  pinnedMessagesCount: Scalars['Int']['output'];
  product: Product;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resolver?: Maybe<UserField>;
  sourceId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<ConversationTag>>;
  totalMemberCount?: Maybe<Scalars['Float']['output']>;
  university: UniversityField;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};


export type ChatConversationCommunityChatMembersArgs = {
  offsetPagination: OffsetPagination;
};


export type ChatConversationMembersArgs = {
  offsetPagination?: InputMaybe<OffsetPaginationDto>;
};


export type ChatConversationPaginatedMessagesArgs = {
  offsetIdPagination?: InputMaybe<OffsetIdPaginationDto>;
};

export type ChatConversationInboxInputDto = {
  product?: InputMaybe<Product>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatGroupAndMessages = {
  __typename?: 'ChatGroupAndMessages';
  chatGroup?: Maybe<ChatGroupField>;
  error?: Maybe<Scalars['String']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
  offsetId?: Maybe<Scalars['String']['output']>;
};

export type ChatGroupAuxiliaryField = {
  __typename?: 'ChatGroupAuxiliaryField';
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<ChatGroupLabelField>>>;
  willReply?: Maybe<WillReplyField>;
};

export type ChatGroupField = {
  __typename?: 'ChatGroupField';
  applicant?: Maybe<AnyChatUserField>;
  aux?: Maybe<ChatGroupAuxiliaryField>;
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  delinked?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<LastMessageField>;
  members?: Maybe<Array<Maybe<AnyUserField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
  messagesForModeration?: Maybe<Array<Maybe<MessageField>>>;
  opponent?: Maybe<AnyChatUserField>;
  pinnedMessages?: Maybe<Array<Maybe<PinnedMessageField>>>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  sendbirdChannelUrl?: Maybe<Scalars['String']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};


export type ChatGroupFieldMessagesArgs = {
  lastFetched?: InputMaybe<Scalars['String']['input']>;
  messagesToFetch?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatGroupFieldMessagesForModerationArgs = {
  lastFetched?: InputMaybe<Scalars['String']['input']>;
  messagesToFetch?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatGroupLabelField = {
  __typename?: 'ChatGroupLabelField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatInboxField = InboxItemInterface & {
  __typename?: 'ChatInboxField';
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFirstMessageInConversation?: Maybe<FirstMessageInfo>;
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  likes: Array<Scalars['ObjectId']['output']>;
  likesCount: Scalars['Int']['output'];
  reactions?: Maybe<Array<Reaction>>;
  resolved: Scalars['Boolean']['output'];
  richContent?: Maybe<RichMessageContent>;
  sender: UserField;
  text: Scalars['String']['output'];
};

export type ChatPermission = {
  __typename?: 'ChatPermission';
  id: Scalars['ID']['output'];
  isMember: Scalars['Boolean']['output'];
};

export type ChatReport = {
  __typename?: 'ChatReport';
  actionTaken?: Maybe<Scalars['String']['output']>;
  community: Community;
  conversation: ChatConversation;
  creationTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: ChatMessage;
  moderationTime?: Maybe<Scalars['DateTime']['output']>;
  moderator?: Maybe<UserField>;
  moderatorComment?: Maybe<Scalars['String']['output']>;
  modificationTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  reportee: UserField;
  reporter?: Maybe<UserField>;
  reporterComment: Scalars['String']['output'];
  reporterReason: Scalars['String']['output'];
  reportSource?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  university: UniversityField;
};

export type ChatReportModeratorInputDto = {
  actionTaken?: InputMaybe<Scalars['String']['input']>;
  chatReportId: Scalars['ObjectID']['input'];
  moderatorComment: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
};

export enum ChatReportSource {
  Bot = 'BOT',
  User = 'USER'
}

export type ChatReportUserInputDto = {
  conversationId: Scalars['ObjectID']['input'];
  messageId: Scalars['ObjectID']['input'];
  product: Product;
  reporteeId: Scalars['ObjectID']['input'];
  reporterComment: Scalars['String']['input'];
  reporterReason: Scalars['String']['input'];
  reportSource?: InputMaybe<ChatReportSource>;
  universityId: Scalars['ObjectID']['input'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  chatRoomAnalytics: ChatRoomAnalytics;
  conversation: ChatConversation;
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type ChatRoomAnalytics = {
  __typename?: 'ChatRoomAnalytics';
  chatRoomAttendees: ChatRoomAttendees;
  chatRoomId: Scalars['ObjectId']['output'];
  chatRoomMessagesSent: Scalars['Float']['output'];
  id: Scalars['ObjectId']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type ChatRoomAttendeeAnalytics = {
  __typename?: 'ChatRoomAttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  chatRoomId: Scalars['ObjectId']['output'];
  id: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type ChatRoomAttendeeData = {
  accountRole: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  chatRoomId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type ChatRoomAttendees = {
  __typename?: 'ChatRoomAttendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type ChatSummaryField = {
  __typename?: 'ChatSummaryField';
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatSummary?: Maybe<Scalars['String']['output']>;
  generatedOn?: Maybe<Scalars['DateTime']['output']>;
  prospectId?: Maybe<Scalars['String']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
};

export type ChatUserField = {
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CheckEmailMutation = {
  __typename?: 'CheckEmailMutation';
  emailExists?: Maybe<Scalars['Boolean']['output']>;
  passwordSetEmailSent?: Maybe<Scalars['Boolean']['output']>;
};

export type ChildOrganisationField = {
  __typename?: 'ChildOrganisationField';
  hasOrganisationAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClassificationField = {
  __typename?: 'ClassificationField';
  id?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  topSubTopic?: Maybe<TopSubTopicField>;
};

export type CloneLiveEventAndChannelsMutation = {
  __typename?: 'CloneLiveEventAndChannelsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type Cohort = {
  __typename?: 'Cohort';
  active?: Maybe<Scalars['Boolean']['output']>;
  areaOfStudies?: Maybe<Array<DegreeField>>;
  areaOfStudyIds?: Maybe<Array<Scalars['String']['output']>>;
  countries?: Maybe<Array<CountryField>>;
  countryIds?: Maybe<Array<Scalars['String']['output']>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  degreeLevelIds?: Maybe<Array<Scalars['String']['output']>>;
  degreeLevels?: Maybe<Array<DegreeLevelField>>;
  domesticRegionIds?: Maybe<Array<Scalars['String']['output']>>;
  domesticRegions?: Maybe<Array<DomesticRegionField>>;
  expectedEntryFrom?: Maybe<Scalars['DateTime']['output']>;
  expectedEntryTo?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  universityId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type CohortInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  areaOfStudyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  degreeLevelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  domesticRegionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedEntryFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expectedEntryTo?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentMutation = {
  __typename?: 'CommentMutation';
  comment?: Maybe<BlogCommentField>;
};

export type Community = {
  __typename?: 'Community';
  archived: Scalars['Boolean']['output'];
  blockedMembers?: Maybe<Array<UserField>>;
  communityChatGroups: Array<CommunityChatGroup>;
  communityMemberCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutions?: Maybe<Array<UniversityField>>;
  inviteLinks: Array<InviteLinkDto>;
  members?: Maybe<Array<UserField>>;
  newsFeedGroups?: Maybe<Array<NewsFeedGroup>>;
  requestedPublicGroups: Scalars['Int']['output'];
  settings?: Maybe<SettingsObjectType>;
  title?: Maybe<Scalars['String']['output']>;
  welcomeText?: Maybe<Scalars['String']['output']>;
};

export type CommunityChatGroup = {
  __typename?: 'CommunityChatGroup';
  communityId: Scalars['ID']['output'];
  conversation: ChatConversation;
  createdBy?: Maybe<UserField>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDirect: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Labels>>;
  members?: Maybe<Array<UserField>>;
  mutedBy: Array<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

/** The type of community chat group */
export enum CommunityChatGroupType {
  Direct = 'Direct',
  Private = 'Private',
  Public = 'Public'
}

export type CommunityField = {
  __typename?: 'CommunityField';
  id?: Maybe<Scalars['String']['output']>;
};

export type CommunityInviteResponse = {
  __typename?: 'CommunityInviteResponse';
  accepted: Scalars['Boolean']['output'];
  communityId: Scalars['String']['output'];
};

export type CommunityInvites = {
  __typename?: 'CommunityInvites';
  accepted: Scalars['Boolean']['output'];
  accountRole?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  invitedEmail: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  usedInviteLink: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommunityJoinResponse = {
  __typename?: 'CommunityJoinResponse';
  alreadyJoined?: Maybe<Scalars['Boolean']['output']>;
  community: Community;
  firstCommunityJoined?: Maybe<Scalars['Boolean']['output']>;
  joined: Scalars['Boolean']['output'];
};

export type CompletedEvent = {
  __typename?: 'CompletedEvent';
  activeAttendees?: Maybe<Scalars['Int']['output']>;
  attendees?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messagesSent?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newSignUps?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CompletedEventsOverview = {
  __typename?: 'CompletedEventsOverview';
  events?: Maybe<Array<Maybe<CompletedEvent>>>;
  eventsCount?: Maybe<Scalars['Int']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentBriefField = {
  __typename?: 'ContentBriefField';
  brief?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isValuable?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Int']['output']>;
  minDuration?: Maybe<Scalars['Int']['output']>;
  sourceMetrics?: Maybe<Array<Maybe<MetricDataPoint>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Context = {
  __typename?: 'Context';
  id: Scalars['String']['output'];
  type: ContextType;
};

export enum ContextType {
  IsDirectConversation = 'isDirectConversation',
  IsNewsFeedConversation = 'isNewsFeedConversation',
  Marketplace = 'marketplace',
  University = 'university'
}

export type ConversationContextChatGroupField = {
  __typename?: 'ConversationContextChatGroupField';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextField = {
  __typename?: 'ConversationContextField';
  ambassador?: Maybe<AmbassadorField>;
  applicantMsg?: Maybe<Scalars['String']['output']>;
  chatGroup?: Maybe<ConversationContextChatGroupField>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ConversationInbox = {
  __typename?: 'ConversationInbox';
  /** The contexts the conversations on this entity belong to. We should not try to resolve this from the FE as this should be set explicitly on the specific inbox resolvers. */
  contexts: Array<Context>;
  conversations: Array<ChatConversation>;
};

export type ConversationMetaDataDto = {
  communityId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  universityId: Scalars['ID']['input'];
};

export type ConversationTag = {
  __typename?: 'ConversationTag';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CookieConsentInputDto = {
  preferences: PreferencesInputType;
  uniqueId: Scalars['String']['input'];
};

export type CookieConsentOutputDto = {
  __typename?: 'CookieConsentOutputDTO';
  preferences: PreferencesOutputType;
  uniqueId: Scalars['String']['output'];
};

export type CountPerEpoch = {
  __typename?: 'CountPerEpoch';
  count?: Maybe<Scalars['Int']['output']>;
  epoch?: Maybe<Scalars['String']['output']>;
};

export type CountryAnalyticsValue = {
  __typename?: 'CountryAnalyticsValue';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type CountryField = {
  __typename?: 'CountryField';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  subRegion?: Maybe<Scalars['String']['output']>;
};

export type CountrySnippetField = {
  __typename?: 'CountrySnippetField';
  country?: Maybe<CountryField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type CountryStatField = {
  __typename?: 'CountryStatField';
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type CourseSnippetField = {
  __typename?: 'CourseSnippetField';
  degreeSnippets?: Maybe<Array<Maybe<DegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type CreateAlertMutation = {
  __typename?: 'CreateAlertMutation';
  alert?: Maybe<AlertField>;
};

export type CreateApplicantInsightInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  totalApplied: Scalars['Int']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type CreateApplicantMutation = {
  __typename?: 'CreateApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type CreateApplicantMutationV2 = {
  __typename?: 'CreateApplicantMutationV2';
  applicant?: Maybe<ApplicantField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateAssistantConversationInput = {
  universityId: Scalars['String']['input'];
};

export type CreateBlogTopicMutation = {
  __typename?: 'CreateBlogTopicMutation';
  blogTopic?: Maybe<BlogTopicField>;
};

export type CreateBuddyMutation = {
  __typename?: 'CreateBuddyMutation';
  error?: Maybe<Scalars['String']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  noInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCanonicalQuestion = {
  __typename?: 'CreateCanonicalQuestion';
  question?: Maybe<CanonicalQuestionField>;
};

export type CreateCommunityApplicantMutation = {
  __typename?: 'CreateCommunityApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type CreateCommunityApplicantMutationV2 = {
  __typename?: 'CreateCommunityApplicantMutationV2';
  applicant?: Maybe<ApplicantField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateCommunityChatGroupInput = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicLink?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type CreateCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type CreateCommunityDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  universityId: Scalars['ID']['input'];
};

export type CreateCrmServiceUniversityConfigMutation = {
  __typename?: 'CreateCrmServiceUniversityConfigMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityConfiguration?: Maybe<CrmServiceUniversityConfig>;
};

export type CreateExternalEventMutation = {
  __typename?: 'CreateExternalEventMutation';
  externalEvent?: Maybe<ExternalEventField>;
};

export type CreateFaqAnswer = {
  __typename?: 'CreateFaqAnswer';
  faqAnswer?: Maybe<FaqAnswerField>;
};

export type CreateFresherMutation = {
  __typename?: 'CreateFresherMutation';
  error?: Maybe<Scalars['String']['output']>;
  fresher?: Maybe<ApplicantField>;
};

export type CreateLiveEventDetailsMutation = {
  __typename?: 'CreateLiveEventDetailsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type CreateLiveEventFeedMutation = {
  __typename?: 'CreateLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
};

export type CreateLiveEventFeedSessionsMutation = {
  __typename?: 'CreateLiveEventFeedSessionsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLiveEventMutation = {
  __typename?: 'CreateLiveEventMutation';
  errors?: Maybe<Array<Maybe<FormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type CreateMarketplaceApplicantMutation = {
  __typename?: 'CreateMarketplaceApplicantMutation';
  authenticatedApplicant?: Maybe<AuthField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateMarketplaceMutation = {
  __typename?: 'CreateMarketplaceMutation';
  marketplace?: Maybe<MarketplaceField>;
};

export type CreateMentorMutation = {
  __typename?: 'CreateMentorMutation';
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  mentor?: Maybe<MentorField>;
  noInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpenDayMutation = {
  __typename?: 'CreateOpenDayMutation';
  openDay?: Maybe<OpenDayField>;
};

export type CreateOrganisationBuddyLinkMutation = {
  __typename?: 'CreateOrganisationBuddyLinkMutation';
  organisationBuddyLink?: Maybe<OrganisationBuddyLinkField>;
};

export type CreateOrganisationMutation = {
  __typename?: 'CreateOrganisationMutation';
  organisation?: Maybe<OrganisationField>;
};

export type CreatePostMutation = {
  __typename?: 'CreatePostMutation';
  error?: Maybe<Scalars['String']['output']>;
  post?: Maybe<BlogPostField>;
};

export type CreateRequestedPublicGroupInput = {
  communityId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSubTopicMutation = {
  __typename?: 'CreateSubTopicMutation';
  subTopic?: Maybe<SubTopicField>;
};

export type CreateTagMutation = {
  __typename?: 'CreateTagMutation';
  tag?: Maybe<TagField>;
};

export type CreateTodoInputDto = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  prevTopRank?: InputMaybe<Scalars['String']['input']>;
  status: TodoStatus;
  targetAudience: Array<TargetAudienceDto>;
  title: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type CreateTopicMutation = {
  __typename?: 'CreateTopicMutation';
  topic?: Maybe<TopicField>;
};

export type CreateUniversityBlockReportMutation = {
  __typename?: 'CreateUniversityBlockReportMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityBlockReport?: Maybe<UniversityBlockReportField>;
};

export type CreateUniversityMutation = {
  __typename?: 'CreateUniversityMutation';
  university?: Maybe<UniversityField>;
};

export type CreateUniversityUserMutation = {
  __typename?: 'CreateUniversityUserMutation';
  universityUser?: Maybe<UniversityUserField>;
};

export type CreateUserMutation = {
  __typename?: 'CreateUserMutation';
  user?: Maybe<UserField>;
};

export type CreateVirtualEventInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  /** the name of the event */
  title: Scalars['String']['input'];
};

export type CreationSource = {
  __typename?: 'CreationSource';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CrmApplicantField = {
  __typename?: 'CRMApplicantField';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CrmApplicantRecordField = {
  __typename?: 'CrmApplicantRecordField';
  applicant?: Maybe<CrmApplicantField>;
  crmApplicantId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSync?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmAttributeField = {
  __typename?: 'CrmAttributeField';
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmConnectionField = {
  __typename?: 'CrmConnectionField';
  connectionError?: Maybe<Scalars['String']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmDataField = {
  __typename?: 'CrmDataField';
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  isCustomField?: Maybe<Scalars['Boolean']['output']>;
  sampleValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CrmField = {
  __typename?: 'CRMField';
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  crmMetaData?: Maybe<CrmMetaDataField>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CrmFieldInputType = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  isCustomField?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CrmFieldSyncStatus = {
  __typename?: 'CrmFieldSyncStatus';
  fieldName?: Maybe<Scalars['String']['output']>;
  isSyncActive?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmIntegrationField = {
  __typename?: 'CRMIntegrationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  connection?: Maybe<CrmConnectionField>;
  crm?: Maybe<CrmField>;
  crmApplicantRecords?: Maybe<Array<Maybe<CrmApplicantRecordField>>>;
  crmIdentifier?: Maybe<Scalars['String']['output']>;
  fieldMapping?: Maybe<Array<Maybe<FieldMappingField>>>;
  id?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<Array<Maybe<CrmSyncJobField>>>;
  lastSyncJob?: Maybe<CrmSyncJobField>;
  syncErrorCount?: Maybe<Scalars['Int']['output']>;
  syncSuccessCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};


export type CrmIntegrationFieldCrmApplicantRecordsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CrmMetaDataField = {
  __typename?: 'CRMMetaDataField';
  additionalInfoLink?: Maybe<Scalars['String']['output']>;
  additionalInfoText?: Maybe<Scalars['String']['output']>;
  logoData?: Maybe<Array<Maybe<LogoDataField>>>;
};

export type CrmServiceUniversityConfig = {
  __typename?: 'CrmServiceUniversityConfig';
  allFields?: Maybe<Array<Maybe<CrmDataField>>>;
  connectorEndpoint?: Maybe<Scalars['String']['output']>;
  connectorName?: Maybe<Scalars['String']['output']>;
  dataFormatConfigs?: Maybe<Array<Maybe<DataFormatConfig>>>;
  error?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<CrmDataField>>>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncActive?: Maybe<Scalars['Boolean']['output']>;
  universityId?: Maybe<Scalars['String']['output']>;
  universitySlug?: Maybe<Scalars['String']['output']>;
  zapierWebhook?: Maybe<Scalars['String']['output']>;
};

export type CrmSyncJobField = {
  __typename?: 'CrmSyncJobField';
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  synced?: Maybe<Scalars['Int']['output']>;
  toSync?: Maybe<Scalars['Int']['output']>;
};

export type CsvUploadAmbassadorFieldsMutation = {
  __typename?: 'CSVUploadAmbassadorFieldsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CsvUploadApplicantsMutation = {
  __typename?: 'CSVUploadApplicantsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrentDecisionStageOutput = {
  __typename?: 'CurrentDecisionStageOutput';
  decisionStage?: Maybe<DecisionStageEnum>;
  decisionStageLocation?: Maybe<DecisionStageLocationEnum>;
  notInterestedReason?: Maybe<NotInterestedReasonEnum>;
  universityId: Scalars['ObjectId']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ObjectId']['output'];
};

export type CurrentUserDecisionStageQueryInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type CustomAttributeField = {
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomAttributeOptionField = {
  __typename?: 'CustomAttributeOptionField';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributesField = {
  __typename?: 'CustomAttributesField';
  attribute?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributesFilterField = {
  __typename?: 'CustomAttributesFilterField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributesFilterOptionField>>>;
};

export type CustomAttributesFilterInputField = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributesFilterOptionField = {
  __typename?: 'CustomAttributesFilterOptionField';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeValueField = {
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeValueInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DataFormatConfig = {
  __typename?: 'DataFormatConfig';
  dataFormatConfigName?: Maybe<Scalars['String']['output']>;
  dataFormatConfigValue?: Maybe<Scalars['String']['output']>;
};

export type DataFormatConfigInputType = {
  dataFormatConfigName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigValue?: InputMaybe<Scalars['String']['input']>;
};

export type DateValueField = CustomAttributeValueField & {
  __typename?: 'DateValueField';
  attribute?: Maybe<CustomAttributeField>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeactivateApplicantsMutation = {
  __typename?: 'DeactivateApplicantsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type DeactivateMentorsMutation = {
  __typename?: 'DeactivateMentorsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type DebugApplicantPayloadField = {
  __typename?: 'DebugApplicantPayloadField';
  applicantId?: Maybe<Scalars['String']['output']>;
  mongoDataFieldsToSync?: Maybe<Scalars['JSONString']['output']>;
  mongoSourceData?: Maybe<Scalars['JSONString']['output']>;
  mongoUniversityTransformData?: Maybe<Scalars['JSONString']['output']>;
  snowflakeDataFieldsToSync?: Maybe<Scalars['JSONString']['output']>;
  snowflakeSourceData?: Maybe<Scalars['JSONString']['output']>;
  snowflakeUniversityTransformData?: Maybe<Scalars['JSONString']['output']>;
  universityId?: Maybe<Scalars['String']['output']>;
};

export enum DecisionStageEnum {
  Admitted = 'ADMITTED',
  Applied = 'APPLIED',
  Comparing = 'COMPARING',
  Enrolled = 'ENROLLED',
  GatheringInfo = 'GATHERING_INFO',
  Narrowed = 'NARROWED',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  NotInterested = 'NOT_INTERESTED',
  Preparing = 'PREPARING'
}

export enum DecisionStageLocationEnum {
  ApplicantInsightsPage = 'APPLICANT_INSIGHTS_PAGE',
  CommunityPopUp = 'COMMUNITY_POP_UP',
  EnrolledInsightsPage = 'ENROLLED_INSIGHTS_PAGE',
  WidgetChat = 'WIDGET_CHAT',
  WidgetDecisionPage = 'WIDGET_DECISION_PAGE',
  WidgetForYou = 'WIDGET_FOR_YOU',
  WidgetInbox = 'WIDGET_INBOX',
  WidgetNotInterestedPage = 'WIDGET_NOT_INTERESTED_PAGE',
  WidgetSignup = 'WIDGET_SIGNUP'
}

export type DefaultQuestionsField = {
  __typename?: 'DefaultQuestionsField';
  id?: Maybe<Scalars['String']['output']>;
  subTopic?: Maybe<SubTopicField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DegreeCategoriesAnalyticsValue = {
  __typename?: 'DegreeCategoriesAnalyticsValue';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type DegreeCategoryField = {
  __typename?: 'DegreeCategoryField';
  categoryType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchyRank?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parents?: Maybe<Array<Maybe<DegreeCategoryParentField>>>;
  relatedKeywords?: Maybe<Scalars['String']['output']>;
};

export type DegreeCategoryParentField = {
  __typename?: 'DegreeCategoryParentField';
  categoryType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  hierarchyRank?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeChatUserField = {
  __typename?: 'DegreeChatUserField';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeField = {
  __typename?: 'DegreeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<DegreeCategoryField>>>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreeType?: Maybe<Array<Maybe<DegreeType>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeLevelField = {
  __typename?: 'DegreeLevelField';
  archived?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
  yearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
};


export type DegreeLevelFieldYearOfStudyArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DegreeSnippetField = {
  __typename?: 'DegreeSnippetField';
  degree?: Maybe<DegreeField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type DegreeStatField = {
  __typename?: 'DegreeStatField';
  count?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
};

export enum DegreeType {
  Bachelor = 'BACHELOR',
  Certification = 'CERTIFICATION',
  Concentration = 'CONCENTRATION',
  Faculty = 'FACULTY',
  Honors = 'HONORS',
  JointHonors = 'JOINT_HONORS',
  Major = 'MAJOR',
  Master = 'MASTER',
  Minor = 'MINOR',
  Phd = 'PHD',
  Program = 'PROGRAM',
  SpecialProgramme = 'SPECIAL_PROGRAMME',
  Specialisation = 'SPECIALISATION'
}

export type DegreeTypeOrderField = {
  __typename?: 'DegreeTypeOrderField';
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DegreeType>;
};

export type DegreeTypeOrderInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DegreeType>;
};

export type DeleteApplicantMutation = {
  __typename?: 'DeleteApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type DeleteAssistantConversationInput = {
  conversationId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type DeleteAssistantConversationOutput = {
  __typename?: 'DeleteAssistantConversationOutput';
  conversationId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
};

export type DeleteAttributeOptionsMutation = {
  __typename?: 'DeleteAttributeOptionsMutation';
  university?: Maybe<UniversityField>;
};

export type DeleteCanonicalQuestion = {
  __typename?: 'DeleteCanonicalQuestion';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};

export type DeleteCustomAttributesMutation = {
  __typename?: 'DeleteCustomAttributesMutation';
  university?: Maybe<UniversityField>;
};

export type DeleteDegreeLevelMutation = {
  __typename?: 'DeleteDegreeLevelMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type DeleteFaqAnswer = {
  __typename?: 'DeleteFaqAnswer';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteKnowledgeBaseEntriesByPatternMatchInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  pattern: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type DeleteKnowledgeBaseEntriesByPatternMismatchInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  pattern: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type DeleteKnowledgeBaseEntriesByUrlListInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  universityId: Scalars['String']['input'];
  urlsToDelete: Array<Scalars['String']['input']>;
};

export type DeleteKnowledgeBaseEntriesOutput = {
  __typename?: 'DeleteKnowledgeBaseEntriesOutput';
  totalCount: Scalars['Float']['output'];
  universityId: Scalars['String']['output'];
  urls: Array<Scalars['String']['output']>;
};

export type DeleteLiveEventFeedMutation = {
  __typename?: 'DeleteLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLiveEventMessageMutation = {
  __typename?: 'DeleteLiveEventMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLiveEventMutation = {
  __typename?: 'DeleteLiveEventMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type DeletePostMutation = {
  __typename?: 'DeletePostMutation';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRecordingResponse = {
  __typename?: 'DeleteRecordingResponse';
  message: Scalars['String']['output'];
  recordingId: Scalars['ObjectId']['output'];
};

export type DeleteResearchTimeMutation = {
  __typename?: 'DeleteResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSubTopicMutation = {
  __typename?: 'DeleteSubTopicMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTopicMutation = {
  __typename?: 'DeleteTopicMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUniversityUserMutation = {
  __typename?: 'DeleteUniversityUserMutation';
  universityUser?: Maybe<UniversityUserField>;
};

export type DeleteUserMutation = {
  __typename?: 'DeleteUserMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteYearOfStudyMutation = {
  __typename?: 'DeleteYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type DepartmentSnippetField = {
  __typename?: 'DepartmentSnippetField';
  department?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type DescriptionField = {
  __typename?: 'DescriptionField';
  descriptionTag?: Maybe<Scalars['String']['output']>;
  instructionTag?: Maybe<Scalars['String']['output']>;
};

export type DeviceField = {
  __typename?: 'DeviceField';
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DeviceMutation = {
  __typename?: 'DeviceMutation';
  device?: Maybe<DeviceField>;
};

export type DeviceToken = {
  __typename?: 'DeviceToken';
  active: Scalars['Boolean']['output'];
  deviceToken: Scalars['String']['output'];
  system: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type DirectConversationDto = {
  communityId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  userToConverseWith: Scalars['String']['input'];
};

export type DirectMessagingApplicant = {
  __typename?: 'DirectMessagingApplicant';
  applicant?: Maybe<ApplicantField>;
  chatGroup?: Maybe<ChatGroupField>;
};

export type DirectMessagingEnquiryTeam = {
  __typename?: 'DirectMessagingEnquiryTeam';
  chatGroup?: Maybe<ChatGroupField>;
  university?: Maybe<UniversityField>;
};

export type DirectMessagingMentor = {
  __typename?: 'DirectMessagingMentor';
  chatGroup?: Maybe<ChatGroupField>;
  mentor?: Maybe<PublicMentorField>;
};

export type DirectMessagingStaffMember = {
  __typename?: 'DirectMessagingStaffMember';
  chatGroup?: Maybe<ChatGroupField>;
  staffMember?: Maybe<BuddyField>;
};

export type Display = {
  __typename?: 'Display';
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DomesticOrInternational {
  Domestic = 'domestic',
  International = 'international'
}

export type DomesticRegionField = {
  __typename?: 'DomesticRegionField';
  country?: Maybe<CountryField>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DynamicMessageTemplate = {
  __typename?: 'DynamicMessageTemplate';
  templateId: Scalars['String']['output'];
  templateMetaData?: Maybe<TemplateDataUnion>;
};

export type EditAlertMutation = {
  __typename?: 'EditAlertMutation';
  alert?: Maybe<AlertField>;
};

export type EditAttributeOptionMutation = {
  __typename?: 'EditAttributeOptionMutation';
  university?: Maybe<UniversityField>;
};

export type EditBlogTopicMutation = {
  __typename?: 'EditBlogTopicMutation';
  blogTopic?: Maybe<BlogTopicField>;
};

export type EditCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type EditCommunityDto = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingsDto>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditCustomAttributeMutation = {
  __typename?: 'EditCustomAttributeMutation';
  customAttribute?: Maybe<CustomAttributeField>;
};

export type EditCustomAttributesMutation = {
  __typename?: 'EditCustomAttributesMutation';
  customAttributes?: Maybe<Array<Maybe<CustomAttributeField>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type EditCustomWelcomeMessageMutation = {
  __typename?: 'EditCustomWelcomeMessageMutation';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type EditDegreeLevelMutation = {
  __typename?: 'EditDegreeLevelMutation';
  degreeLevel?: Maybe<DegreeLevelField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type EditDegreeNameMutation = {
  __typename?: 'EditDegreeNameMutation';
  degree?: Maybe<DegreeField>;
};

export type EditDegreesMutation = {
  __typename?: 'EditDegreesMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type EditExternalEventMutation = {
  __typename?: 'EditExternalEventMutation';
  externalEvent?: Maybe<ExternalEventField>;
};

export type EditLiveEventDetailsMutation = {
  __typename?: 'EditLiveEventDetailsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type EditLiveEventFeedMutation = {
  __typename?: 'EditLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
};

export type EditLiveEventMutation = {
  __typename?: 'EditLiveEventMutation';
  errors?: Maybe<Array<Maybe<FormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type EditLiveEventsLandingPageMutation = {
  __typename?: 'EditLiveEventsLandingPageMutation';
  liveEventLandingPage?: Maybe<LiveEventLandingPageField>;
};

export type EditOpenDayMutation = {
  __typename?: 'EditOpenDayMutation';
  openDay?: Maybe<OpenDayField>;
};

export type EditOrganisationMutation = {
  __typename?: 'EditOrganisationMutation';
  organisation?: Maybe<OrganisationField>;
};

export type EditPostMutation = {
  __typename?: 'EditPostMutation';
  error?: Maybe<Scalars['String']['output']>;
  post?: Maybe<BlogPostField>;
};

export type EditUniversityMutation = {
  __typename?: 'EditUniversityMutation';
  university?: Maybe<UniversityField>;
};

export type EditYearOfStudyMutation = {
  __typename?: 'EditYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
  yearOfStudy?: Maybe<YearOfStudyField>;
};

export type EmbeddedEventField = {
  __typename?: 'EmbeddedEventField';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type EmbeddedEventSnippetField = {
  __typename?: 'EmbeddedEventSnippetField';
  description?: Maybe<DescriptionField>;
  embeddedEvents?: Maybe<Array<Maybe<EmbeddedEventField>>>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type EnableCustomWelcomeMessageMutation = {
  __typename?: 'EnableCustomWelcomeMessageMutation';
  university?: Maybe<UniversityField>;
};

export type EnableCustomWelcomeMessageStaffMutation = {
  __typename?: 'EnableCustomWelcomeMessageStaffMutation';
  university?: Maybe<UniversityField>;
};

export type EnableFeaturesMutation = {
  __typename?: 'EnableFeaturesMutation';
  university?: Maybe<UniversityField>;
};

export type EnrolledInsightResponse = {
  __typename?: 'EnrolledInsightResponse';
  community: CommunityField;
  id: Scalars['ObjectId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  totalApplicants: Scalars['Float']['output'];
  totalEnrolled: Scalars['Float']['output'];
  university: UniversityField;
};

export type EnrolledInsightsInput = {
  communityId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type EnterpriseAddOns = {
  __typename?: 'EnterpriseAddOns';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseMentorField = {
  __typename?: 'EnterpriseMentorField';
  active?: Maybe<Scalars['Boolean']['output']>;
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<DegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedToOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  sourceOrganisation?: Maybe<OrganisationField>;
  year?: Maybe<Scalars['String']['output']>;
};

export type EntriesField = {
  __typename?: 'EntriesField';
  active?: Maybe<Scalars['Boolean']['output']>;
  entryMonths?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type EntriesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  entryMonths?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type EventPage = {
  __typename?: 'EventPage';
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  /** the name of the page */
  name: Scalars['String']['output'];
  pageImageUrl: Scalars['String']['output'];
};

export type EventPageData = {
  description: Scalars['String']['input'];
  /** the name of the page */
  name: Scalars['String']['input'];
  pageImageUrl: Scalars['String']['input'];
};

export type EventPagesDisplayedOn = {
  __typename?: 'EventPagesDisplayedOn';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type ExportAnalyticsCsvMutation = {
  __typename?: 'ExportAnalyticsCsvMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type ExportedReportField = {
  __typename?: 'ExportedReportField';
  created?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExportTimeSheetDataField = {
  __typename?: 'ExportTimeSheetDataField';
  usersTimesheetData?: Maybe<Array<Maybe<UserTimeSheetExportField>>>;
};

export type ExternalContent = {
  __typename?: 'ExternalContent';
  description: Scalars['String']['output'];
  eventPagesDisplayedOn: Array<EventPagesDisplayedOn>;
  eventPagesIds: Array<Scalars['ObjectId']['output']>;
  externalContentImageUrl: Scalars['String']['output'];
  externalContentUrl: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  /** the name of the external content */
  name: Scalars['String']['output'];
  showOnHomepage: Scalars['Boolean']['output'];
};

export type ExternalContentData = {
  description: Scalars['String']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  externalContentImageUrl: Scalars['String']['input'];
  externalContentUrl: Scalars['String']['input'];
  /** the name of the external content */
  name: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalEventField = {
  __typename?: 'ExternalEventField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FaqAnswerField = {
  __typename?: 'FaqAnswerField';
  id: Scalars['String']['output'];
  mentor: MentorField;
  text: Scalars['String']['output'];
};

export type FeatureField = {
  __typename?: 'FeatureField';
  description?: Maybe<Scalars['String']['output']>;
  descriptionClickablePart?: Maybe<Scalars['String']['output']>;
  descriptionLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureInputField = {
  enabledByUnibuddy: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  universityCanToggleFeature: Scalars['Boolean']['input'];
};

export type FeatureNotificationRequestDto = {
  applicableRoles: Array<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  featureFlag: Scalars['String']['input'];
  title: Scalars['String']['input'];
  universityIds: Array<Scalars['String']['input']>;
};

export type FeatureRulesDto = {
  __typename?: 'FeatureRulesDTO';
  roles?: Maybe<Array<Scalars['String']['output']>>;
  universities?: Maybe<Array<UniversityOutput>>;
};

export type FeatureToggleInputField = {
  enabledByUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FieldMappingField = {
  __typename?: 'FieldMappingField';
  applicationField?: Maybe<Scalars['String']['output']>;
  crmId?: Maybe<Scalars['String']['output']>;
  crmName?: Maybe<Scalars['String']['output']>;
};

export type FieldMappingInput = {
  applicationField?: InputMaybe<Scalars['String']['input']>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  crmName?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersDto = {
  product?: InputMaybe<Product>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUsersDto = {
  areaOfStudy?: InputMaybe<Array<Scalars['String']['input']>>;
  communityId: Scalars['String']['input'];
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  hideSelf?: InputMaybe<Scalars['Boolean']['input']>;
  housingTypes?: InputMaybe<Array<HousingInput>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FirstMessageInfo = {
  __typename?: 'FirstMessageInfo';
  type?: Maybe<CommunityChatGroupType>;
  value: Scalars['Boolean']['output'];
};

export type FlagField = {
  __typename?: 'FlagField';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FormFieldValidationError = {
  __typename?: 'FormFieldValidationError';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ForwardApplicantToUniversity = {
  __typename?: 'ForwardApplicantToUniversity';
  chatGroup?: Maybe<ChatGroupField>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
};

export type FunctionCall = {
  __typename?: 'FunctionCall';
  arguments: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GeckoUniversityData = {
  __typename?: 'GeckoUniversityData';
  categoryId?: Maybe<Scalars['String']['output']>;
  formUuid?: Maybe<Scalars['String']['output']>;
  geckoUniversityId?: Maybe<Scalars['String']['output']>;
  geckoUniversityName?: Maybe<Scalars['String']['output']>;
};

export type GenerateAnalyticsDashboardTokenMutation = {
  __typename?: 'GenerateAnalyticsDashboardTokenMutation';
  analyticsAuth?: Maybe<AnalyticsDashboardAuthField>;
};

export type GenerateLiveEventReport = {
  __typename?: 'GenerateLiveEventReport';
  liveEvent?: Maybe<LiveEventField>;
};

export type GenerateRecommendationsInput = {
  areaOfStudyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  batchSize: Scalars['Int']['input'];
  countryId?: InputMaybe<Scalars['ObjectId']['input']>;
  degreeLevelId?: InputMaybe<Scalars['ObjectId']['input']>;
  domesticRegionId?: InputMaybe<Scalars['ObjectId']['input']>;
  expectedEntry?: InputMaybe<Scalars['DateTime']['input']>;
  universityId: Scalars['ObjectId']['input'];
};

export type GenerateSummaryInput = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
};

export type GenerateSummaryResponse = {
  __typename?: 'GenerateSummaryResponse';
  summary: Scalars['String']['output'];
  summaryId?: Maybe<Scalars['String']['output']>;
};

export type GetAssistantConversationInput = {
  id: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type GetChatReportsDto = {
  product: Product;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityId: Scalars['ObjectID']['input'];
};

export type GetCommunityConversationsFilterDto = {
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetDownloadableUrlMutation = {
  __typename?: 'GetDownloadableURLMutation';
  url?: Maybe<Scalars['String']['output']>;
};

export type GetInvitesForEmailDto = {
  __typename?: 'GetInvitesForEmailDTO';
  community: Community;
  id: Scalars['ID']['output'];
};

export type GetMarketplaceApplicantMutation = {
  __typename?: 'GetMarketplaceApplicantMutation';
  authenticatedApplicant?: Maybe<AuthField>;
};

export type GetMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offsetId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type GetNotificationPreferencesInput = {
  /** A list of products to filter preferences by. */
  products?: InputMaybe<Array<NotificationProduct>>;
};

export type GetOrCreateApiKeyMutation = {
  __typename?: 'GetOrCreateApiKeyMutation';
  apiKey?: Maybe<Scalars['String']['output']>;
};

export type GetRandomAmbassadorsInput = {
  count: Scalars['Float']['input'];
  universityId: Scalars['String']['input'];
};

export type GetRecordingFailureIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type GetRecordingFailureIdsResponse = {
  __typename?: 'GetRecordingFailureIdsResponse';
  failedIds: Array<RecordingFailureId>;
};

export type GetSignedS3PostFieldsMutation = {
  __typename?: 'GetSignedS3PostFieldsMutation';
  postFieldsObject?: Maybe<SignedS3PostFields>;
};

export type GetSignedS3UrlMutation = {
  __typename?: 'GetSignedS3UrlMutation';
  signedObject?: Maybe<SignedS3UrlField>;
};

export type GetTodosFilterDto = {
  region?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserReportsDto = {
  product: Product;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityId: Scalars['ObjectID']['input'];
};

export type GifDto = {
  aspectRatio: Scalars['Float']['input'];
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  type: GifType;
  width: Scalars['Int']['input'];
};

export enum GifType {
  Gif = 'Gif',
  Sticker = 'Sticker'
}

export type Giphy = {
  __typename?: 'Giphy';
  aspectRatio: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: GifType;
  width: Scalars['Int']['output'];
};

export type GraphField = {
  __typename?: 'GraphField';
  xAxis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  yAxis?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  yWeights?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GraphQlOffsetPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type GroupField = {
  __typename?: 'GroupField';
  type?: Maybe<Scalars['String']['output']>;
};

export type HideMentorInMarketplaceMutation = {
  __typename?: 'HideMentorInMarketplaceMutation';
  mentor?: Maybe<MentorField>;
};

export type HighSchoolField = {
  __typename?: 'HighSchoolField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HighSchoolTypeField = {
  __typename?: 'HighSchoolTypeField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum HousingCategory {
  Na = 'NA',
  Private = 'PRIVATE',
  University = 'UNIVERSITY'
}

export type HousingInput = {
  category: HousingCategory;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HousingObject = {
  __typename?: 'HousingObject';
  category: HousingCategory;
  name?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['String']['output'];
};

export type ImageDto = {
  url: Scalars['String']['input'];
};

export type InboxItemInterface = {
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type InboxItemLastMessageField = {
  __typename?: 'InboxItemLastMessageField';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFromUser?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type InboxItemUnion = ChatInboxField | UniversityChatInboxField;

export type InboxPromptAnswer = {
  __typename?: 'InboxPromptAnswer';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type InboxPromptAnswerInput = {
  answers: Array<InboxPromptAnswerInputItem>;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type InboxPromptAnswerInputItem = {
  id: Scalars['ObjectId']['input'];
  text: Scalars['String']['input'];
};

export type InboxPromptInput = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  universityId: Scalars['ObjectId']['input'];
};

export type InboxPromptOption = {
  __typename?: 'InboxPromptOption';
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type InboxPromptQuestion = {
  __typename?: 'InboxPromptQuestion';
  active: Scalars['Boolean']['output'];
  answers: Array<InboxPromptAnswer>;
  id: Scalars['ObjectId']['output'];
  options: Array<InboxPromptOption>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};


export type InboxPromptQuestionAnswersArgs = {
  inboxPromptInput: InboxPromptInput;
};

export type InboxUniversityField = {
  __typename?: 'InboxUniversityField';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  squareLogo?: Maybe<Scalars['String']['output']>;
};

export type InitialiseRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type InitialiseRecordingResponse = {
  __typename?: 'InitialiseRecordingResponse';
  channelId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  layoutMode: Scalars['Float']['output'];
  layoutStatus: Scalars['String']['output'];
  recordingStatus: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type InputField = {
  __typename?: 'InputField';
  action?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Insights = {
  __typename?: 'Insights';
  communityId: Scalars['ID']['output'];
  totalApplicantsInCommunity: Scalars['Float']['output'];
  totalEnrolled: Scalars['Float']['output'];
};

export type InsightsField = {
  __typename?: 'InsightsField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<TopicStatisticField>>>;
};

export type Interest = {
  __typename?: 'Interest';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type InterestInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InterestObject = {
  __typename?: 'InterestObject';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InterventionMessageField = {
  __typename?: 'InterventionMessageField';
  message?: Maybe<MessageField>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Invite = {
  __typename?: 'Invite';
  communityId: Scalars['String']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedEmail: Scalars['String']['output'];
  reminderStatus?: Maybe<Scalars['String']['output']>;
  sendUnibuddyEmail?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteApplicantsMutation = {
  __typename?: 'InviteApplicantsMutation';
  alreadyExistingInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successfulInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InviteBuddiesMutation = {
  __typename?: 'InviteBuddiesMutation';
  failedInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successfulInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
};

export type InviteFilter = {
  accountRole?: InputMaybe<Array<AccountRoles>>;
  inviteMethod?: InputMaybe<Array<InviteMethods>>;
  status?: InputMaybe<Array<InviteStatus>>;
};

export type InviteInformation = {
  __typename?: 'InviteInformation';
  community: Community;
  id: Scalars['ID']['output'];
  invite?: Maybe<Invite>;
  /** Whether the user is a member of the community. Requires authentication. Returns "null" if user is not authenticated, "false" if user is authenticated but not a member, and "true" if user is authenticated and a member. */
  isPartOfCommunity?: Maybe<Scalars['Boolean']['output']>;
  university: UniversityField;
};

export type InviteInformationInput = {
  inviteId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteLinkDto = {
  __typename?: 'InviteLinkDto';
  active: Scalars['Boolean']['output'];
  communityId: Scalars['String']['output'];
  expiringAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
};

export type InviteLinkInfoDto = {
  __typename?: 'InviteLinkInfoDto';
  communityId: Scalars['String']['output'];
  communityTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  universityName: Scalars['String']['output'];
  universitySlug: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type InviteLinkInput = {
  active: Scalars['Boolean']['input'];
  communityId: Scalars['ID']['input'];
  labels: Array<Scalars['String']['input']>;
};

export type InviteMentorsMutation = {
  __typename?: 'InviteMentorsMutation';
  successfulInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
};

export enum InviteMethods {
  Email = 'EMAIL',
  Invitelink = 'INVITELINK'
}

export enum InviteStatus {
  Invited = 'INVITED',
  Joined = 'JOINED'
}

export type JoinChatGroupMutation = {
  __typename?: 'JoinChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type KnowledgeBaseDeleteEntryInput = {
  id: Scalars['String']['input'];
};

export type KnowledgeBaseDeleteEntryOutput = {
  __typename?: 'KnowledgeBaseDeleteEntryOutput';
  ok: Scalars['Boolean']['output'];
};

export type KnowledgeBaseEmbedding = {
  __typename?: 'KnowledgeBaseEmbedding';
  createdAt: Scalars['DateTime']['output'];
  ids: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseSourceQueryInput = {
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
  universityId: Scalars['String']['input'];
};

export type KnowledgeBaseSourcesByUrl = {
  __typename?: 'KnowledgeBaseSourcesByUrl';
  ids: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseSourcesListInput = {
  universityId: Scalars['String']['input'];
  urlSearchPattern: Scalars['String']['input'];
};

export type LabellingField = {
  __typename?: 'LabellingField';
  chatGroupId?: Maybe<Scalars['String']['output']>;
  classifiedSentenceId?: Maybe<Scalars['String']['output']>;
  embeddedSubTopic?: Maybe<TopSubTopicField>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  subTopicExternalId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topicExternalId?: Maybe<Scalars['String']['output']>;
};

export type LabellingSentenceCandidate = {
  __typename?: 'LabellingSentenceCandidate';
  classifiedSentenceId?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topSubTopics?: Maybe<Array<Maybe<TopSubTopicField>>>;
};

export type Labels = {
  __typename?: 'Labels';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LabelSentenceMutation = {
  __typename?: 'LabelSentenceMutation';
  labelSentence: LabellingField;
};

export type LanguageField = {
  __typename?: 'LanguageField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LastMessageField = {
  __typename?: 'LastMessageField';
  created?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notVisibleTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sender?: Maybe<AnyUserField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LastRead = {
  __typename?: 'LastRead';
  conversationId: Scalars['String']['output'];
  messageId: Scalars['ObjectId']['output'];
  userId: Scalars['String']['output'];
};

export type LeaveChatGroupMutation = {
  __typename?: 'LeaveChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type LevelSnippetField = {
  __typename?: 'LevelSnippetField';
  level?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type LikeMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type LikeMessageMutation = {
  __typename?: 'LikeMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LinkOrganisationsMutation = {
  __typename?: 'LinkOrganisationsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListAdminRecommendationInput = {
  forDecisionStage: DecisionStageEnum;
};

export type ListBuddyApplicantConversationsField = {
  __typename?: 'ListBuddyApplicantConversationsField';
  conversations?: Maybe<Array<Maybe<BuddyApplicantChatGroupFieldV2>>>;
  totalConversations?: Maybe<Scalars['Int']['output']>;
};

export type ListMentorApplicantConversationsField = {
  __typename?: 'ListMentorApplicantConversationsField';
  conversations?: Maybe<Array<Maybe<MentorApplicantChatGroupField>>>;
  totalConversations?: Maybe<Scalars['Int']['output']>;
};

export type ListUniversityAssistantConversationsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  universityId: Scalars['String']['input'];
};

export type ListUniversityAssistantConversationsOutput = {
  __typename?: 'ListUniversityAssistantConversationsOutput';
  conversationCount: Scalars['Float']['output'];
  conversations: Array<UniversityAssistantConversation>;
  universityId: Scalars['String']['output'];
};

export type LiveEventChatGroupField = {
  __typename?: 'LiveEventChatGroupField';
  applicantCount?: Maybe<Scalars['Int']['output']>;
  applicants?: Maybe<Array<Maybe<ApplicantField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  description?: Maybe<Scalars['String']['output']>;
  hasEnquiryTeam?: Maybe<Scalars['Boolean']['output']>;
  hostIdsVideoSessions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  name?: Maybe<Scalars['String']['output']>;
  recordingEnabled?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Array<Maybe<UserField>>>;
  university?: Maybe<UniversityField>;
  universityUsers?: Maybe<Array<Maybe<UniversityUserField>>>;
  videoEnabled?: Maybe<Scalars['Boolean']['output']>;
  videoSessions?: Maybe<Array<Maybe<VideoSessionField>>>;
};

export type LiveEventChatGroupsInputField = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};

export type LiveEventDetailedReport = {
  __typename?: 'LiveEventDetailedReport';
  applicantCountries?: Maybe<Array<Maybe<LiveEventDetailedReportCountryStats>>>;
  liveEventId?: Maybe<Scalars['String']['output']>;
  messagesPerChannel?: Maybe<Array<Maybe<LiveEventDetailedReportChannelStats>>>;
  prospectInLiveEvent?: Maybe<Scalars['Int']['output']>;
  prospectLoggedIn?: Maybe<Scalars['Int']['output']>;
  prospectSignUps?: Maybe<Scalars['Int']['output']>;
  prospectsInLiveEventChatGroups?: Maybe<Scalars['Int']['output']>;
  prospectsSendDirectMessage?: Maybe<Scalars['Int']['output']>;
  prospectsSendMessage?: Maybe<Scalars['Int']['output']>;
};

export type LiveEventDetailedReportChannelStats = {
  __typename?: 'LiveEventDetailedReportChannelStats';
  applicants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  len?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDetailedReportCountryStats = {
  __typename?: 'LiveEventDetailedReportCountryStats';
  count?: Maybe<Scalars['Int']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDetailsField = {
  __typename?: 'LiveEventDetailsField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isUserRegistered?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDirectMessaging = {
  __typename?: 'LiveEventDirectMessaging';
  applicants?: Maybe<Array<Maybe<DirectMessagingApplicant>>>;
  enquiryTeam?: Maybe<DirectMessagingEnquiryTeam>;
  mentors?: Maybe<Array<Maybe<DirectMessagingMentor>>>;
  staff?: Maybe<Array<Maybe<DirectMessagingStaffMember>>>;
};

export type LiveEventFeedbackFormMutation = {
  __typename?: 'LiveEventFeedbackFormMutation';
  feedBackForm?: Maybe<LiveEventProspectFeedbackFormField>;
};

export type LiveEventField = {
  __typename?: 'LiveEventField';
  allMentors?: Maybe<Array<Maybe<MentorField>>>;
  allStaff?: Maybe<Array<Maybe<BuddyField>>>;
  applicants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  createdByUniversity?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailedReport?: Maybe<LiveEventDetailedReport>;
  directMessagingMentors?: Maybe<Array<Maybe<MentorField>>>;
  directMessagingStaff?: Maybe<Array<Maybe<BuddyField>>>;
  directMessagingUniversity?: Maybe<Scalars['Boolean']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inbox?: Maybe<LiveEventInboxField>;
  liveFeeds?: Maybe<Array<Maybe<LiveEventChatGroupField>>>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  setupCompleted?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};


export type LiveEventFieldInboxArgs = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveEventInboxField = {
  __typename?: 'LiveEventInboxField';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<InboxItemUnion>>>;
};

export type LiveEventLandingPageField = {
  __typename?: 'LiveEventLandingPageField';
  description?: Maybe<Scalars['String']['output']>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LiveEventProspectFeedbackFormField = {
  __typename?: 'LiveEventProspectFeedbackFormField';
  accountRole?: Maybe<Scalars['String']['output']>;
  eventExperience?: Maybe<Scalars['Int']['output']>;
  eventFeedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<LiveEventField>;
  university?: Maybe<UniversityField>;
  user?: Maybe<UserField>;
};

export type LiveEventsFormFieldValidationError = {
  __typename?: 'LiveEventsFormFieldValidationError';
  code?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LiveSession = {
  __typename?: 'LiveSession';
  conversation: ChatConversation;
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  eventPagesDisplayedOn: Array<EventPagesDisplayedOn>;
  eventPagesIds: Array<Scalars['ObjectId']['output']>;
  id: Scalars['ObjectId']['output'];
  isSavedByMe: Scalars['Boolean']['output'];
  /** the name of the event */
  name: Scalars['String']['output'];
  presenters: Array<UserField>;
  recordingEnabled: Scalars['Boolean']['output'];
  sessionAnalytics: SessionAnalytics;
  sessionImageUrl: Scalars['String']['output'];
  showOnHomepage: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LocaleField = {
  __typename?: 'LocaleField';
  androidCode?: Maybe<Scalars['String']['output']>;
  dialectOf?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  osxCode?: Maybe<Scalars['String']['output']>;
  osxLocale?: Maybe<Scalars['String']['output']>;
  textDirection?: Maybe<Scalars['String']['output']>;
  threeLettersCode?: Maybe<Scalars['String']['output']>;
  twoLettersCode?: Maybe<Scalars['String']['output']>;
};

export type LogoDataField = {
  __typename?: 'LogoDataField';
  logoText?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type LogoutMutation = {
  __typename?: 'LogoutMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ManageOrganisationAccessMutation = {
  __typename?: 'ManageOrganisationAccessMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ManuallyClassifyMutation = {
  __typename?: 'ManuallyClassifyMutation';
  classification: ClassificationField;
};

export type MarkAssistantConversationAsViewedInput = {
  conversationId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type MarketplaceApplicantCountries = {
  __typename?: 'MarketplaceApplicantCountries';
  countries?: Maybe<Array<Maybe<CountryAnalyticsValue>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceApplicantData = {
  custom?: InputMaybe<Scalars['JSONString']['input']>;
  degreeCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  personalDataCollectionAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfEntry?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceApplicantDegreeCategories = {
  __typename?: 'MarketplaceApplicantDegreeCategories';
  categories?: Maybe<Array<Maybe<DegreeCategoriesAnalyticsValue>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceApplicantUserData = {
  __typename?: 'MarketplaceApplicantUserData';
  custom?: Maybe<Scalars['GenericScalar']['output']>;
  degreeCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  marketingConsentAccepted?: Maybe<Scalars['Boolean']['output']>;
  personalDataCollectionAccepted?: Maybe<Scalars['Boolean']['output']>;
  yearOfEntry?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceField = {
  __typename?: 'MarketplaceField';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowUniversityProspectDataAccess?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  customBuddyWord?: Maybe<Scalars['String']['output']>;
  customFilters?: Maybe<Array<Maybe<MarketplaceFilters>>>;
  disableExternalNotification?: Maybe<Scalars['Boolean']['output']>;
  faAppId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketplaceMarketingConsentCollectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketplaceMarketingConsentMessage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personalDataApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  unibuddyMarketingConsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  universityMarketingConsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  widgetDescription?: Maybe<Scalars['String']['output']>;
  widgetTitle?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceFilterInput = {
  filterSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceFilters = {
  __typename?: 'MarketplaceFilters';
  filterSlug?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceInboxField = {
  __typename?: 'MarketplaceInboxField';
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
};

export type MarketplaceMentorList = {
  __typename?: 'MarketplaceMentorList';
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  mentorSeed?: Maybe<Scalars['Int']['output']>;
  totalMentors?: Maybe<Scalars['Int']['output']>;
  universitySeed?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceSnippetField = {
  __typename?: 'MarketplaceSnippetField';
  error?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type MarkReadMessageDto = {
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type MatchedUser = {
  __typename?: 'MatchedUser';
  matchingCriteria: Array<Scalars['String']['output']>;
  matchingPercentage: Scalars['Float']['output'];
  user: UserField;
};

/** Types of matching criteria */
export enum MatchingCriteriaEnum {
  AreaOfStudy = 'AreaOfStudy',
  Nationality = 'Nationality'
}

export type MeField = {
  __typename?: 'MeField';
  admin?: Maybe<AdminUserField>;
  anyUser?: Maybe<AnyUserField>;
  applicant?: Maybe<ApplicantField>;
  mentor?: Maybe<MentorField>;
  staff?: Maybe<UserField>;
  universityUser?: Maybe<UniversityUserField>;
};

export type MentorApplicantChatGroupField = {
  __typename?: 'MentorApplicantChatGroupField';
  applicant?: Maybe<ApplicantField>;
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageText?: Maybe<Scalars['String']['output']>;
  mentor?: Maybe<MentorField>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorBroadcastMessageMutation = {
  __typename?: 'MentorBroadcastMessageMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorcardSnippetField = {
  __typename?: 'MentorcardSnippetField';
  countrySnippets?: Maybe<Array<Maybe<CountrySnippetField>>>;
  degreeSnippets?: Maybe<Array<Maybe<DegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
  mentorSnippets?: Maybe<Array<Maybe<MentorSnippetField>>>;
};

export type MentorChatUserField = ChatUserField & {
  __typename?: 'MentorChatUserField';
  degree?: Maybe<DegreeChatUserField>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
};


export type MentorChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MentorDegreeField = {
  __typename?: 'MentorDegreeField';
  degree?: Maybe<DegreeField>;
  degreeType?: Maybe<DegreeType>;
};

export type MentorDegreeFieldInput = {
  degree: Scalars['String']['input'];
  degreeType: DegreeType;
};

export type MentorDegreeHistory = {
  __typename?: 'MentorDegreeHistory';
  degree?: Maybe<DegreeField>;
  university?: Maybe<UniversityField>;
};

export type MentorEngagementMetricsField = {
  __typename?: 'MentorEngagementMetricsField';
  mentor?: Maybe<MentorField>;
  unresolvedChatGroupCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorField = {
  __typename?: 'MentorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  cardComplete?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  degree?: Maybe<DegreeField>;
  degreeHistory?: Maybe<MentorDegreeHistory>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  email?: Maybe<Scalars['String']['output']>;
  favouriteModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasUnansweredConversation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Array<Maybe<MentorInterestField>>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  mentorFields?: Maybe<MentorFields>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  pastQualification?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<MentorPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  resolvedUnansweredConversations?: Maybe<Scalars['Boolean']['output']>;
  schoolHistory?: Maybe<MentorSchoolHistoryField>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  showIn?: Maybe<Array<Maybe<Display>>>;
  societies?: Maybe<Array<Maybe<MentorSocietyField>>>;
  stageOneComplete?: Maybe<Scalars['Boolean']['output']>;
  stageTwoComplete?: Maybe<Scalars['Boolean']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};


export type MentorFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MentorFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MentorFieldCustomLabel = {
  __typename?: 'MentorFieldCustomLabel';
  customLabel?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type MentorFieldCustomLabelInput = {
  customLabel?: InputMaybe<Scalars['String']['input']>;
  key: MentorFieldKeyEnum;
};

export enum MentorFieldKeyEnum {
  Country = 'COUNTRY',
  Degree = 'DEGREE',
  DegreeLevel = 'DEGREE_LEVEL',
  DegreeTypeKey = 'DEGREE_TYPE_KEY'
}

export type MentorFieldOrderField = {
  __typename?: 'MentorFieldOrderField';
  field?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type MentorFieldOrderInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type MentorFields = {
  __typename?: 'MentorFields';
  primaryFlag?: Maybe<FlagField>;
  secondaryFlag?: Maybe<FlagField>;
};

export type MentorFilterField = {
  __typename?: 'MentorFilterField';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<MentorFilterOptionField>>>;
};

export type MentorFilterInputField = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MentorFilterOptionField = {
  __typename?: 'MentorFilterOptionField';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type MentorInboxField = {
  __typename?: 'MentorInboxField';
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  chatGroupsCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorInterestField = {
  __typename?: 'MentorInterestField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MentorInterventionQueryField = {
  __typename?: 'MentorInterventionQueryField';
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorIntroMessageField = {
  __typename?: 'MentorIntroMessageField';
  introMessage?: Maybe<MessageField>;
};

export type MentorInviteCountField = {
  __typename?: 'MentorInviteCountField';
  mentorInviteCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorInviteField = {
  __typename?: 'MentorInviteField';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notFound?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorListField = {
  __typename?: 'MentorListField';
  countries?: Maybe<Array<Maybe<CountryField>>>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  validCombination?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorListFilterChoice = {
  __typename?: 'MentorListFilterChoice';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type MentorListFilterChoiceInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MentorModuleField = {
  __typename?: 'MentorModuleField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MentorOrderCriteria = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MentorPreferencesField = {
  __typename?: 'MentorPreferencesField';
  id?: Maybe<Scalars['String']['output']>;
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MentorSchoolHistoryField = {
  __typename?: 'MentorSchoolHistoryField';
  highSchool?: Maybe<HighSchoolField>;
  highSchoolType?: Maybe<HighSchoolTypeField>;
};

export type MentorSnippetField = {
  __typename?: 'MentorSnippetField';
  mentor?: Maybe<MentorField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type MentorSocietyField = {
  __typename?: 'MentorSocietyField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  richContent?: InputMaybe<RichContentDto>;
  text: Scalars['String']['input'];
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageField = {
  __typename?: 'MessageField';
  attachment?: Maybe<AttachmentField>;
  chatGroupId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  input?: Maybe<InputField>;
  instantAction?: Maybe<Scalars['String']['output']>;
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ownMessage?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  richContent?: Maybe<RichContentOutputField>;
  sender?: Maybe<AnyUserField>;
  text?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type MessageMetadata = {
  __typename?: 'MessageMetadata';
  ambassadorProfile?: Maybe<AmbassadorProfileInformation>;
  staffProfile?: Maybe<StaffProfileInformation>;
};

export type MessagePublicBotMutation = {
  __typename?: 'MessagePublicBotMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
};

export type Metadata = {
  qssMetadata?: InputMaybe<QssMetadata>;
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptRequestedPublicGroup: RequestedPublicGroup;
  activateApplicants?: Maybe<ActivateApplicantsMutation>;
  activateMentors?: Maybe<ActivateMentorsMutation>;
  addAttendees?: Maybe<AttendeeAnalytics>;
  addBotToChatGroup?: Maybe<AddBotToChatGroupMutation>;
  addChatRoomAttendees?: Maybe<ChatRoomAttendeeAnalytics>;
  addCustomAttribute?: Maybe<AddCustomAttributeMutation>;
  addCustomAttributeOption?: Maybe<AddAttributeOptionMutation>;
  addDegreeLevels?: Maybe<AddDegreeLevelsMutation>;
  addDegrees?: Maybe<AddDegreesMutation>;
  addDevice?: Maybe<DeviceMutation>;
  addHobsonsConnectIntegration?: Maybe<AddHobsonsConnectIntegration>;
  addLocalesToApp?: Maybe<AddLocalesToApp>;
  addMatchingCriteria: UpdatedResults;
  addReactionToMessage: ChatMessage;
  addResearchTime?: Maybe<AddResearchTimeMutation>;
  addSessionAttendees?: Maybe<SessionAttendeeAnalytics>;
  addToFeatureExperiment: Scalars['Boolean']['output'];
  addUserToCommunityConversation: ChatConversation;
  addVote: Poll;
  addYearOfStudy?: Maybe<AddYearOfStudyMutation>;
  adminDeleteApplicant?: Maybe<AdminDeleteApplicantMutation>;
  adminDeleteBuddy?: Maybe<DeleteUserMutation>;
  adminUpdateMentor?: Maybe<AdminUpdateMentorMutation>;
  applicantBroadcastMessage?: Maybe<ApplicantBroadcastMessageMutation>;
  awardProfileCompleteBadge: Badge;
  bulkOptOutMarketplaceUniversityMarketing?: Maybe<BulkOptOutMarketplaceUniversityMarketingMutation>;
  checkEmail?: Maybe<CheckEmailMutation>;
  cloneCommunity: Community;
  cloneLiveEventAndChannels?: Maybe<CloneLiveEventAndChannelsMutation>;
  createAlert?: Maybe<CreateAlertMutation>;
  createApplicant?: Maybe<CreateApplicantMutation>;
  createApplicantV2?: Maybe<CreateApplicantMutationV2>;
  createApplicationInsight: ApplicationInsightModel;
  createAssistantConversation: AssistantConversationHistoryWithToken;
  createAssistantMessageFeedback: Scalars['Boolean']['output'];
  createBlogTopic?: Maybe<CreateBlogTopicMutation>;
  createBuddy?: Maybe<CreateBuddyMutation>;
  createCanonicalQuestion?: Maybe<CreateCanonicalQuestion>;
  /** Create a chat report. This mutation is available to all user types. */
  createChatReport: ChatReport;
  createChatRoom: ChatRoom;
  createComment?: Maybe<CommentMutation>;
  createCommunity: Community;
  createCommunityApplicant?: Maybe<CreateCommunityApplicantMutation>;
  createCommunityApplicantV2?: Maybe<CreateCommunityApplicantMutationV2>;
  /** @deprecated Deprecated, please use createCommunityConversation */
  createCommunityChatGroup: CommunityChatGroup;
  createCommunityConversation: ChatConversation;
  createCommunityFromTemplate: Community;
  createCrmServiceUniversityConfig?: Maybe<CreateCrmServiceUniversityConfigMutation>;
  createDirectConversation: ChatConversation;
  createEventPage: EventPage;
  createExternalContent: ExternalContent;
  createExternalEvent?: Maybe<CreateExternalEventMutation>;
  createFaqAnswer?: Maybe<CreateFaqAnswer>;
  createFresher?: Maybe<CreateFresherMutation>;
  createInviteLink: InviteLinkDto;
  createLiveEvent?: Maybe<CreateLiveEventMutation>;
  createLiveEventDetails?: Maybe<CreateLiveEventDetailsMutation>;
  createLiveEventFeed?: Maybe<CreateLiveEventFeedMutation>;
  createLiveEventFeedSessions?: Maybe<CreateLiveEventFeedSessionsMutation>;
  createLiveSession: LiveSession;
  createMarketplace?: Maybe<CreateMarketplaceMutation>;
  createMarketplaceApplicant?: Maybe<CreateMarketplaceApplicantMutation>;
  createMentor?: Maybe<CreateMentorMutation>;
  createOpenDay?: Maybe<CreateOpenDayMutation>;
  createOrganisation?: Maybe<CreateOrganisationMutation>;
  createOrganisationBuddyLink?: Maybe<CreateOrganisationBuddyLinkMutation>;
  createOrUpdateUniversityAssistantPromptContext: UniversityAssistantConfigurationPromptContextOutput;
  createOrUpdateUniversityAssistantScrapeIgnoreUrls: UniversityAssistantConfigurationScrapeIgnoreUrlsOutput;
  createPost?: Maybe<CreatePostMutation>;
  createStaffContact: StaffContactOutput;
  createSubTopic?: Maybe<CreateSubTopicMutation>;
  createTag?: Maybe<CreateTagMutation>;
  createTodo: TodosEntity;
  createTopic?: Maybe<CreateTopicMutation>;
  createUniversity?: Maybe<CreateUniversityMutation>;
  createUniversityAssistantEventLink: UniversityAssistantConfigurationEventOutput;
  createUniversityBlockReport?: Maybe<CreateUniversityBlockReportMutation>;
  createUniversityScrape: UniversityScrapeOutput;
  createUniversityScrapeBatch: UniversityScrapeOutput;
  createUniversityScrapeOne: UniversityScrapeOutput;
  createUniversityUser?: Maybe<CreateUniversityUserMutation>;
  createUserMutation?: Maybe<CreateUserMutation>;
  /** Create a user report. This mutation is available to all user types. */
  createUserReport: UserReport;
  createVideoUploadLink: VideoUploadLink;
  createVirtualEvent: VirtualEvent;
  createVirtualEventProspectReport?: Maybe<ReportAnalytics>;
  csvUploadAmbassadorFields?: Maybe<CsvUploadAmbassadorFieldsMutation>;
  csvUploadApplicants?: Maybe<CsvUploadApplicantsMutation>;
  deactivateApplicants?: Maybe<DeactivateApplicantsMutation>;
  deactivateMentors?: Maybe<DeactivateMentorsMutation>;
  deleteAdminRecommendation: AdminRecommendation;
  deleteApplicant?: Maybe<DeleteApplicantMutation>;
  deleteAssistantConversation: DeleteAssistantConversationOutput;
  deleteBlogPost?: Maybe<DeletePostMutation>;
  deleteCanonicalQuestion?: Maybe<DeleteCanonicalQuestion>;
  deleteChatRoom: Scalars['Boolean']['output'];
  deleteCommunityConversation: ChatConversation;
  deleteConversationMessage: ChatMessage;
  deleteCustomAttributeOptions?: Maybe<DeleteAttributeOptionsMutation>;
  deleteCustomAttributes?: Maybe<DeleteCustomAttributesMutation>;
  deleteDegreeLevel?: Maybe<DeleteDegreeLevelMutation>;
  deleteEventPage: Scalars['Boolean']['output'];
  deleteExternalContent: Scalars['Boolean']['output'];
  deleteFaqAnswer?: Maybe<DeleteFaqAnswer>;
  deleteLiveEvent?: Maybe<DeleteLiveEventMutation>;
  deleteLiveEventFeed?: Maybe<DeleteLiveEventFeedMutation>;
  deleteLiveEventMessageMutation?: Maybe<DeleteLiveEventMessageMutation>;
  deleteLiveSession: Scalars['Boolean']['output'];
  deleteRecording: DeleteRecordingResponse;
  deleteResearchTime?: Maybe<DeleteResearchTimeMutation>;
  deleteSubTopic?: Maybe<DeleteSubTopicMutation>;
  deleteTopic?: Maybe<DeleteTopicMutation>;
  deleteUniversityKnowledgeBaseSourceById: KnowledgeBaseDeleteEntryOutput;
  deleteUniversityKnowledgeBaseSourceByPatternMatch: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityKnowledgeBaseSourceByPatternMismatch: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityKnowledgeBaseSourceByUrlList: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityUser?: Maybe<DeleteUniversityUserMutation>;
  deleteVirtualEvent: Scalars['Boolean']['output'];
  deleteYearOfStudy?: Maybe<DeleteYearOfStudyMutation>;
  editAdminRecommendation: AdminRecommendation;
  editAlert?: Maybe<EditAlertMutation>;
  editBlogPost?: Maybe<EditPostMutation>;
  editBlogTopic?: Maybe<EditBlogTopicMutation>;
  editCommunity: Community;
  editCommunityConversation: ChatConversation;
  editCookieConsentPreferences: CookieConsentOutputDto;
  editCustomAttribute?: Maybe<EditCustomAttributeMutation>;
  editCustomAttributeOption?: Maybe<EditAttributeOptionMutation>;
  editCustomAttributes?: Maybe<EditCustomAttributesMutation>;
  editCustomWelcomeMessage?: Maybe<EditCustomWelcomeMessageMutation>;
  editDegreeLevel?: Maybe<EditDegreeLevelMutation>;
  editDegreeName?: Maybe<EditDegreeNameMutation>;
  editDegrees?: Maybe<EditDegreesMutation>;
  editExternalEvent?: Maybe<EditExternalEventMutation>;
  editLiveEvent?: Maybe<EditLiveEventMutation>;
  editLiveEventDetails?: Maybe<EditLiveEventDetailsMutation>;
  editLiveEventFeed?: Maybe<EditLiveEventFeedMutation>;
  editLiveEventsLandingPage?: Maybe<EditLiveEventsLandingPageMutation>;
  editOpenDay?: Maybe<EditOpenDayMutation>;
  editOrganisation?: Maybe<EditOrganisationMutation>;
  editTodo: TodosEntity;
  editUniversity?: Maybe<EditUniversityMutation>;
  editYearOfStudy?: Maybe<EditYearOfStudyMutation>;
  emailInvitesDataForCommunity: Scalars['Boolean']['output'];
  enableCustomWelcomeMessage?: Maybe<EnableCustomWelcomeMessageMutation>;
  enableCustomWelcomeMessageStaff?: Maybe<EnableCustomWelcomeMessageStaffMutation>;
  enableFeatures?: Maybe<EnableFeaturesMutation>;
  exportAnalyticsCsv?: Maybe<ExportAnalyticsCsvMutation>;
  forwardApplicantToUniversity?: Maybe<ForwardApplicantToUniversity>;
  generateAnalyticsDashboardToken?: Maybe<GenerateAnalyticsDashboardTokenMutation>;
  generateDownloadUrl?: Maybe<GetDownloadableUrlMutation>;
  generateLiveEventReport?: Maybe<GenerateLiveEventReport>;
  generateRecommendations: Array<Recommendation>;
  generateSummary: GenerateSummaryResponse;
  getMarketplaceApplicant?: Maybe<GetMarketplaceApplicantMutation>;
  getOrCreateApiKey?: Maybe<GetOrCreateApiKeyMutation>;
  getOrCreateWidgetConversation: ChatConversation;
  getSignedS3PostFields?: Maybe<GetSignedS3PostFieldsMutation>;
  getSignedS3Url?: Maybe<GetSignedS3UrlMutation>;
  hideMentorInMarketplace?: Maybe<HideMentorInMarketplaceMutation>;
  initialiseRecording: InitialiseRecordingResponse;
  initiateUserDeletion: Scalars['Boolean']['output'];
  inviteApplicants?: Maybe<InviteApplicantsMutation>;
  inviteBuddies?: Maybe<InviteBuddiesMutation>;
  inviteEmailsToCommunity: CommunityInviteResponse;
  inviteMentors?: Maybe<InviteMentorsMutation>;
  joinChatGroup?: Maybe<JoinChatGroupMutation>;
  joinCommunity: CommunityJoinResponse;
  joinCommunityByInviteLink: CommunityJoinResponse;
  joinCommunityConversation: ChatConversation;
  joinCommunityForAdmins: CommunityJoinResponse;
  labelSentence?: Maybe<LabelSentenceMutation>;
  leaveChatGroup?: Maybe<LeaveChatGroupMutation>;
  leaveCommunityChatGroup: ChatConversation;
  likeConversationMessage: ChatMessage;
  likeMessage?: Maybe<LikeMessageMutation>;
  linkOrganisations?: Maybe<LinkOrganisationsMutation>;
  liveEventFeedbackForm?: Maybe<LiveEventFeedbackFormMutation>;
  logout?: Maybe<LogoutMutation>;
  manageOrganisationAccess?: Maybe<ManageOrganisationAccessMutation>;
  manuallyClassify?: Maybe<ManuallyClassifyMutation>;
  markAssistantConversationAsViewed: AssistantConversationHistory;
  mentorBroadcastMessage?: Maybe<MentorBroadcastMessageMutation>;
  messagePublicBot?: Maybe<MessagePublicBotMutation>;
  /** Moderate a chat report. This mutation is available only to university users and admins. */
  moderateChatReport: ChatReport;
  /** Moderate a user report. This mutation is available only to university users and admins. */
  moderateUserReport: UserReport;
  pinMessage?: Maybe<PinMessageMutation>;
  pinMessageInConversation: ChatConversation;
  readChat?: Maybe<ReadChatMutation>;
  recordConsent: RecordingConsent;
  recordFailure: RecordingFailureResponse;
  recordLastMessageReadByUser: LastRead;
  recordUserActivity?: Maybe<RecordUserActivityMutation>;
  registerToLiveEvent?: Maybe<RegisterToLiveEvent>;
  rejectRequestedPublicGroup: RequestedPublicGroup;
  removeApplicationInsight: Scalars['Boolean']['output'];
  removeBuddyInvites?: Maybe<RemoveBuddyInvitesMutation>;
  removeDevice?: Maybe<RemoveDeviceMutation>;
  removeMembersFromCommunity: Scalars['Boolean']['output'];
  removeMentorInvites?: Maybe<RemoveMentorInvitesMutation>;
  removeReactionFromMessage: ChatMessage;
  removeUserFromCommunityChatGroup: Scalars['Boolean']['output'];
  removeVote: Poll;
  reorderTodoRank: TodosEntity;
  requestAnalyticsExport?: Maybe<RequestAnalyticsExportMutation>;
  requestPasswordReset?: Maybe<RequestPasswordResetMutation>;
  requestPasswordSet?: Maybe<RequestPasswordSetMutation>;
  requestPublicGroup: RequestedPublicGroup;
  requestResetPassword?: Maybe<ResetPasswordMobileMutation>;
  requestResetPasswordMobile?: Maybe<PasswordResetMobileMutation>;
  requestResetPasswordMobileV2?: Maybe<PasswordResetMobileMutationV2>;
  requestToChangeEmailAddress?: Maybe<RequestToChangeEmailAddressMutation>;
  requestToDeleteAccount?: Maybe<RequestToDeleteAccountMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  resetPasswordEmail?: Maybe<SendResetPasswordEmail>;
  resetPasswordV2?: Maybe<ResetPasswordMutationV2>;
  resolveChats?: Maybe<ResolveUniversityChatsMutation>;
  resolveConversationMessage: ChatMessage;
  runManageCommand?: Maybe<RunManageCommandMutation>;
  saveAdminRecommendation: AdminRecommendation;
  saveAmbassadorRecommendation: AmbassadorRecommendation;
  saveAppliedUsers: SaveAppliedUsersModel;
  saveAssistantConversationEmailLead: AssistantConversationLead;
  saveAssistantConversationFeedback: AssistantConversationFeedback;
  saveCookieConsentPreferences: CookieConsentOutputDto;
  saveInboxPromptAnswer: Array<InboxPromptAnswer>;
  saveInsightsByCommunity: Insights;
  saveNotInterestedStage: UserDecisionStageOutput;
  saveSatisfactionSurvey: SatisfactionSurveyEntity;
  saveUniversityInterested: UniversityInterestedEntity;
  saveUniversityQuestionAnswer: Array<UniversityQuestionAnswer>;
  saveUserDecisionStage: UserDecisionStageOutput;
  saveVisitedRecommendation: Recommendation;
  sendAssistantMessage: AssistantConversationMessage;
  sendCommunityVerificationCode?: Maybe<SendCommunityVerificationCode>;
  sendConversationMessage: ChatMessage;
  /** sends feature push notification to all users with applicable roles in given university list. */
  sendFeatureNotification: Scalars['Boolean']['output'];
  sendFeedMessage?: Maybe<SendFeedMessageMutation>;
  sendLiveEventMessage?: Maybe<SendLiveEventMessageMutation>;
  sendMessage?: Maybe<SendMessageMutation>;
  sendOpenDayProspectReport?: Maybe<SendOpenDayProspectReport>;
  sendVerificationCode?: Maybe<SendVerificationCode>;
  setActiveBlogTopics?: Maybe<SetActiveBlogTopicsMutation>;
  setAllNotificationsRead?: Maybe<SetAllNotificationsReadMutation>;
  setArchivedContentBrief?: Maybe<SetArchivedContentBriefMutation>;
  setArchivedDegreeLevel?: Maybe<SetArchivedDegreeLevelMutation>;
  setArchivedYearOfStudy?: Maybe<SetArchivedYearOfStudyMutation>;
  setBlockUser?: Maybe<BlockUserMutation>;
  setBlockUserV2?: Maybe<BlockUserMutationV2>;
  setBlogPostStatus?: Maybe<UpdatePostStatusMutation>;
  setBuddiesListFilters?: Maybe<SetBuddiesListFilters>;
  setChatGroupLabels?: Maybe<SetChatGroupLabelsMutation>;
  setDeviceToken: DeviceToken;
  setInterestsForUser: Array<UserInterest>;
  setMentorFieldLabel?: Maybe<SetMentorFieldLabelMutation>;
  setMentorFieldOrder?: Maybe<SetMentorFieldOrderMutation>;
  setMentorListFilterSelection?: Maybe<SetMentorListFilterSelection>;
  setOnline?: Maybe<SetOnlineMutation>;
  setResolveChatGroup?: Maybe<SetResolveChatGroupMutation>;
  setUniversityUnblockUsers?: Maybe<UniversityBlockUsersMutation>;
  setUserProfile: UserProfile;
  setWillReply?: Maybe<SetWillReplyMutation>;
  showMentorInMarketplace?: Maybe<ShowMentorInMarketplaceMutation>;
  startRecordingVideo?: Maybe<RecordingResponse>;
  stopRecordingVideo?: Maybe<RecordingResponse>;
  stopUniversityCrawl?: Maybe<UniversityScrapeStopOutput>;
  toggleCommunityChatGroupMute: ChatConversation;
  toggleConversationResolution: ChatConversation;
  toggleCrmIntegrationSync?: Maybe<ToggleCrmIntegrationSync>;
  toggleCustomAttributeCrmSync?: Maybe<ToggleCustomAttributeCrmSyncMutation>;
  toggleDegreesActive?: Maybe<ToggleDegreesActiveMutation>;
  toggleFeatureAvailability?: Maybe<ToggleFeatureAvailabilityMutation>;
  trackLiveEvent?: Maybe<TrackLiveEventMutation>;
  trackOpenDay?: Maybe<TrackOpenDayMutation>;
  transferApplicantChat?: Maybe<TransferApplicantChat>;
  transferConversation: Scalars['String']['output'];
  unlikeConversationMessage: ChatMessage;
  unpinMessage?: Maybe<UnpinMessageMutation>;
  unpinMessageInConversation: ChatConversation;
  unresolveConversationMessage: ChatMessage;
  updateApplicant?: Maybe<UpdateApplicantMutation>;
  updateApplicantPreferences?: Maybe<UpdateApplicantPreferencesMutation>;
  updateCanonicalQuestion?: Maybe<UpdateCanonicalQuestion>;
  updateChatRoom: ChatRoom;
  updateCommunityApplicantSignupsource?: Maybe<UpdateCommunityApplicantSignupSourceMutation>;
  updateCrmServiceUniversityConfig?: Maybe<UpdateUniversityConfigMutation>;
  updateDirectMessagingMembersForLiveEvent?: Maybe<UpdateDirectMessagingMembersForLiveEventMutation>;
  updateEventPage: EventPage;
  updateExternalContent: ExternalContent;
  updateFaqAnswer?: Maybe<UpdateFaqAnswer>;
  updateHobsonsConnectIntegration?: Maybe<UpdateHobsonsConnectIntegration>;
  updateIntegrationFieldMapping?: Maybe<UpdateIntegrationFieldMapping>;
  updateLiveEventFeedSessionData?: Maybe<UpdateLiveEventFeedSessionDataMutation>;
  updateLiveSession: LiveSession;
  updateLiveSessionAnyUser: LiveSession;
  updateManyUserMutation?: Maybe<UpdateManyUserMutation>;
  updateMarketplace?: Maybe<UpdateMarketplaceMutation>;
  updateMarketplaceApplicant?: Maybe<UpdateMarketplaceApplicantMutation>;
  updateMarketplaceApplicantUniversityLink?: Maybe<UpdateMarketplaceApplicantUniversityLinkMutation>;
  updateMentor?: Maybe<UpdateMentorMutation>;
  updateMentorPreferences?: Maybe<UpdateMentorPreferences>;
  updateMyUniversityLink?: Maybe<UpdateMyUniversityLinkMutation>;
  /** Saves the given notification preference for the user. */
  updateNotificationPreference: NotificationPreference;
  updateRecordingLayout?: Maybe<RecordingResponse>;
  updateResearchTime?: Maybe<UpdateResearchTimeMutation>;
  updateStaff?: Maybe<UpdateStaffMutation>;
  updateStaffContact: StaffContactOutput;
  updateSubTopic?: Maybe<UpdateSubTopicMutation>;
  updateTag?: Maybe<UpdateTagMutation>;
  updateTodoAction: Scalars['String']['output'];
  updateTodoStatus: TodosEntity;
  updateTopic?: Maybe<UpdateTopicMutation>;
  updateUniversityAssistantScrapeStartingPoint: UniversityAssistantConfigurationScrapeStartPointOutput;
  updateUniversityBlockReport?: Maybe<UpdateUniversityBlockReportMutation>;
  updateUniversityUser?: Maybe<UpdateUniversityUserMutation>;
  updateUniversityUserPreferences?: Maybe<UpdateUniversityUserPreferencesMutation>;
  updateUserMutation?: Maybe<UpdateUserMutation>;
  updateUserPreferencesMutation?: Maybe<UpdateUserPreferences>;
  updateVirtualEvent: VirtualEvent;
  verifyAccount?: Maybe<VerifyAccount>;
  viewBlog?: Maybe<ViewBlogMutation>;
};


export type MutationAcceptRequestedPublicGroupArgs = {
  acceptRequestedPublicGroupInput: AcceptRequestedPublicGroupInput;
};


export type MutationActivateApplicantsArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationActivateMentorsArgs = {
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAddAttendeesArgs = {
  attendeeData: AttendeeData;
};


export type MutationAddBotToChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddChatRoomAttendeesArgs = {
  chatRoomAttendeeData: ChatRoomAttendeeData;
};


export type MutationAddCustomAttributeArgs = {
  attributeValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destination?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCustomAttributeOptionArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDegreeLevelsArgs = {
  degreeLevelNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDegreesArgs = {
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  degreeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeTypes?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDeviceArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddHobsonsConnectIntegrationArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  passKey?: InputMaybe<Scalars['String']['input']>;
  webServiceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddLocalesToAppArgs = {
  appLocales: Array<InputMaybe<AppLocalesFieldInput>>;
};


export type MutationAddReactionToMessageArgs = {
  reactionDto: ReactionDto;
};


export type MutationAddResearchTimeArgs = {
  researchTimeData: ResearchTimeInput;
};


export type MutationAddSessionAttendeesArgs = {
  sessionAttendeeData: SessionAttendeeData;
};


export type MutationAddToFeatureExperimentArgs = {
  experimentName: Scalars['String']['input'];
  metadata: Scalars['String']['input'];
};


export type MutationAddUserToCommunityConversationArgs = {
  conversationId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type MutationAddVoteArgs = {
  chatMessageId: Scalars['ObjectId']['input'];
  option: Scalars['String']['input'];
};


export type MutationAddYearOfStudyArgs = {
  degreeLevelName: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyNames: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationAdminDeleteApplicantArgs = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminDeleteBuddyArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminUpdateMentorArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApplicantBroadcastMessageArgs = {
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkOptOutMarketplaceUniversityMarketingArgs = {
  marketplaceSlug: Scalars['String']['input'];
  universitySlugs: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationCheckEmailArgs = {
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloneCommunityArgs = {
  sourceCommmunityId: Scalars['String']['input'];
};


export type MutationCloneLiveEventAndChannelsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAlertArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicantArgs = {
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  primaryApp?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicantV2Args = {
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  captureToken?: InputMaybe<Scalars['String']['input']>;
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  primaryApp?: InputMaybe<Scalars['String']['input']>;
  unibuddySignupMetadata?: InputMaybe<ApplicantUnibuddySignupMetadataInputField>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicationInsightArgs = {
  createApplicantInsightInput: CreateApplicantInsightInput;
};


export type MutationCreateAssistantConversationArgs = {
  createAssistantConversationInput: CreateAssistantConversationInput;
};


export type MutationCreateAssistantMessageFeedbackArgs = {
  assistantMessageFeedbackInput: AssistantMessageFeedbackInput;
};


export type MutationCreateBlogTopicArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBuddyArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCanonicalQuestionArgs = {
  defaultQuestion?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  subTopic: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateChatReportArgs = {
  chatReportUserInputDTO: ChatReportUserInputDto;
};


export type MutationCreateChatRoomArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateCommentArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityArgs = {
  CreateCommunityDTO: CreateCommunityDto;
};


export type MutationCreateCommunityApplicantArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityApplicantV2Args = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityChatGroupArgs = {
  createCommunityChatGroupInput: CreateCommunityChatGroupInput;
};


export type MutationCreateCommunityConversationArgs = {
  CreateCommunityConversationDTO: CreateCommunityConversationDto;
};


export type MutationCreateCommunityFromTemplateArgs = {
  communityUseCase: Scalars['String']['input'];
  CreateCommunityDTO: CreateCommunityDto;
};


export type MutationCreateCrmServiceUniversityConfigArgs = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  connectorEndpoint?: InputMaybe<Scalars['String']['input']>;
  connectorName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigs?: InputMaybe<Array<InputMaybe<DataFormatConfigInputType>>>;
  fields?: InputMaybe<Array<InputMaybe<CrmFieldInputType>>>;
  isSyncActive?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  zapierWebhook?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDirectConversationArgs = {
  DirectConversationDTO: DirectConversationDto;
};


export type MutationCreateEventPageArgs = {
  eventPageData: EventPageData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateExternalContentArgs = {
  externalContentData: ExternalContentData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateExternalEventArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFaqAnswerArgs = {
  answer: Scalars['String']['input'];
  canonicalQuestion: Scalars['String']['input'];
};


export type MutationCreateFresherArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInviteLinkArgs = {
  inviteLinkInput: InviteLinkInput;
};


export type MutationCreateLiveEventArgs = {
  chatGroups?: InputMaybe<Array<InputMaybe<LiveEventChatGroupsInputField>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLiveEventDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLiveEventFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};


export type MutationCreateLiveEventFeedSessionsArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};


export type MutationCreateLiveSessionArgs = {
  sessionData: SessionData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateMarketplaceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowUniversityProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  customBuddyWord?: InputMaybe<Scalars['String']['input']>;
  customFilters?: InputMaybe<Array<InputMaybe<MarketplaceFilterInput>>>;
  disableExternalNotification?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentCollectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentMessage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  personalDataApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  unibuddyMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  universityMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
  widgetDescription?: InputMaybe<Scalars['String']['input']>;
  widgetTitle?: InputMaybe<Scalars['String']['input']>;
  widgetUrl: Scalars['String']['input'];
};


export type MutationCreateMarketplaceApplicantArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  marketplace: ApplicantMarketplaceInput;
  password: Scalars['String']['input'];
  unibuddyServicesConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMentorArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOpenDayArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isStaffCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentsCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  navigateTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};


export type MutationCreateOrganisationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedInstanceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationType: OrganisationType;
  parentOrganisationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrganisationBuddyLinkArgs = {
  organisation: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  user: Scalars['String']['input'];
};


export type MutationCreateOrUpdateUniversityAssistantPromptContextArgs = {
  universityAssistantConfigurationPromptContextInput: UniversityAssistantConfigurationPromptContextInput;
};


export type MutationCreateOrUpdateUniversityAssistantScrapeIgnoreUrlsArgs = {
  universityAssistantConfigurationScrapeIgnoreUrlsInput: UniversityAssistantConfigurationScrapeIgnoreUrlsInput;
};


export type MutationCreatePostArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  coverImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  youtubeVideo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateStaffContactArgs = {
  staffContactInput: StaffContactInput;
};


export type MutationCreateSubTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTodoArgs = {
  CreateTodoInputDto: CreateTodoInputDto;
};


export type MutationCreateTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUniversityArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUniversityAssistantEventLinkArgs = {
  universityAssistantConfigurationEventInput: UniversityAssistantConfigurationEventInput;
};


export type MutationCreateUniversityBlockReportArgs = {
  blocked?: InputMaybe<Scalars['String']['input']>;
  chatGroup?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conversation?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  triggeredFrom?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUniversityScrapeArgs = {
  universityScrapeInput: UniversityScrapeInput;
};


export type MutationCreateUniversityScrapeBatchArgs = {
  universityScrapeManualInput: UniversityScrapeManualInput;
};


export type MutationCreateUniversityScrapeOneArgs = {
  universityScrapeInput: UniversityScrapeInput;
};


export type MutationCreateUniversityUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserReportArgs = {
  userReportUserInputDTO: UserReportUserInputDto;
};


export type MutationCreateVideoUploadLinkArgs = {
  videoUploadLinkInput: VideoUploadLinkInput;
};


export type MutationCreateVirtualEventArgs = {
  createVirtualEventInput: CreateVirtualEventInput;
  universityId: Scalars['ObjectId']['input'];
};


export type MutationCreateVirtualEventProspectReportArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCsvUploadAmbassadorFieldsArgs = {
  file: Scalars['Upload']['input'];
  uniSlug: Scalars['String']['input'];
};


export type MutationCsvUploadApplicantsArgs = {
  file: Scalars['Upload']['input'];
  password: Scalars['String']['input'];
  uniSlug: Scalars['String']['input'];
};


export type MutationDeactivateApplicantsArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeactivateMentorsArgs = {
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteAdminRecommendationArgs = {
  recommendationId: Scalars['String']['input'];
};


export type MutationDeleteAssistantConversationArgs = {
  deleteAssistantConversationInput: DeleteAssistantConversationInput;
};


export type MutationDeleteBlogPostArgs = {
  blogPostId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCanonicalQuestionArgs = {
  question: Scalars['String']['input'];
};


export type MutationDeleteChatRoomArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
};


export type MutationDeleteCommunityConversationArgs = {
  DeleteCommunityConversationDTO: DeleteCommunityConversationDto;
};


export type MutationDeleteConversationMessageArgs = {
  deleteMessageDto: DeleteMessageDto;
};


export type MutationDeleteCustomAttributeOptionsArgs = {
  optionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteCustomAttributesArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteDegreeLevelArgs = {
  degreeLevelId: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationDeleteEventPageArgs = {
  eventPageId: Scalars['ObjectId']['input'];
};


export type MutationDeleteExternalContentArgs = {
  externalContentId: Scalars['ObjectId']['input'];
};


export type MutationDeleteFaqAnswerArgs = {
  answer: Scalars['String']['input'];
};


export type MutationDeleteLiveEventArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveEventFeedArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveEventMessageMutationArgs = {
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveSessionArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
};


export type MutationDeleteRecordingArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  sid: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type MutationDeleteResearchTimeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSubTopicArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTopicArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUniversityKnowledgeBaseSourceByIdArgs = {
  knowledgeBaseDeleteEntryInput: KnowledgeBaseDeleteEntryInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByPatternMatchArgs = {
  deleteKnowledgeBaseEntriesByPatternMatchInput: DeleteKnowledgeBaseEntriesByPatternMatchInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByPatternMismatchArgs = {
  deleteKnowledgeBaseEntriesByPatternMismatchInput: DeleteKnowledgeBaseEntriesByPatternMismatchInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByUrlListArgs = {
  deleteKnowledgeBaseEntriesByUrlListInput: DeleteKnowledgeBaseEntriesByUrlListInput;
};


export type MutationDeleteUniversityUserArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteVirtualEventArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationDeleteYearOfStudyArgs = {
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationEditAdminRecommendationArgs = {
  adminRecommendationInput: AdminRecommendationInput;
  recommendationId: Scalars['String']['input'];
};


export type MutationEditAlertArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditBlogPostArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  coverImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  youtubeVideo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditBlogTopicArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCommunityArgs = {
  EditCommunityDTO: EditCommunityDto;
};


export type MutationEditCommunityConversationArgs = {
  EditCommunityConversationDTO: EditCommunityConversationDto;
};


export type MutationEditCookieConsentPreferencesArgs = {
  CookieConsentInputDTO: CookieConsentInputDto;
};


export type MutationEditCustomAttributeArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditCustomAttributeOptionArgs = {
  newValue?: InputMaybe<Scalars['String']['input']>;
  optionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCustomAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
};


export type MutationEditCustomWelcomeMessageArgs = {
  defaultProspectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreeLevelArgs = {
  degreeLevelId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreeNameArgs = {
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  newDegreeName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreesArgs = {
  degreeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  degreeTypes?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditExternalEventArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventArgs = {
  chatGroups?: InputMaybe<Array<InputMaybe<LiveEventChatGroupsInputField>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventsLandingPageArgs = {
  description: Scalars['String']['input'];
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditOpenDayArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isStaffCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentsCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  navigateTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openDayId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};


export type MutationEditOrganisationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};


export type MutationEditTodoArgs = {
  id: Scalars['String']['input'];
  input: CreateTodoInputDto;
};


export type MutationEditUniversityArgs = {
  churned?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  customChatBubbleTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  customMarketingConsentText?: InputMaybe<Scalars['String']['input']>;
  customMarketingConsentTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  customPreSignupText?: InputMaybe<Scalars['String']['input']>;
  customPreSignupTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  degreeTypeOrder?: InputMaybe<Array<InputMaybe<DegreeTypeOrderInput>>>;
  domesticRegions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entries?: InputMaybe<EntriesInput>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  marketplaces?: InputMaybe<Array<InputMaybe<UniversityMarketplaceInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  squareLogo?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  whiteLogo?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetUrls?: InputMaybe<Array<InputMaybe<WidgetUrlsInput>>>;
};


export type MutationEditYearOfStudyArgs = {
  degreeLevelName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationEmailInvitesDataForCommunityArgs = {
  communityId: Scalars['String']['input'];
  filters: InviteFilter;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableCustomWelcomeMessageArgs = {
  allowWelcomeMessageCustomization?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableCustomWelcomeMessageStaffArgs = {
  allowWelcomeMessageCustomizationStaff?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableFeaturesArgs = {
  features?: InputMaybe<Array<InputMaybe<FeatureInputField>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportAnalyticsCsvArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForwardApplicantToUniversityArgs = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateAnalyticsDashboardTokenArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<AnalyticsDashboardMetadata>>>;
};


export type MutationGenerateDownloadUrlArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateLiveEventReportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateRecommendationsArgs = {
  generateRecommendationsInput: GenerateRecommendationsInput;
};


export type MutationGenerateSummaryArgs = {
  generateSummaryInput: GenerateSummaryInput;
};


export type MutationGetMarketplaceApplicantArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  marketplaceUser?: InputMaybe<Scalars['JSONString']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetOrCreateApiKeyArgs = {
  integration: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type MutationGetOrCreateWidgetConversationArgs = {
  widgetConversationDto: WidgetConversationDto;
};


export type MutationGetSignedS3PostFieldsArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetSignedS3UrlArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHideMentorInMarketplaceArgs = {
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorId: Scalars['String']['input'];
};


export type MutationInitialiseRecordingArgs = {
  data: InitialiseRecordingArgs;
};


export type MutationInviteApplicantsArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteBuddiesArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteEmailsToCommunityArgs = {
  communityId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteMentorsArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationJoinChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinCommunityArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationJoinCommunityByInviteLinkArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationJoinCommunityConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationJoinCommunityForAdminsArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationLabelSentenceArgs = {
  chatGroupId: Scalars['String']['input'];
  classifiedSentenceId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  subTopicExternalId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  topicExternalId: Scalars['String']['input'];
};


export type MutationLeaveChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLeaveCommunityChatGroupArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationLikeConversationMessageArgs = {
  likeMessageDto: LikeMessageDto;
};


export type MutationLikeMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkOrganisationsArgs = {
  childOrganisationId: Scalars['String']['input'];
  parentOrganisationId: Scalars['String']['input'];
};


export type MutationLiveEventFeedbackFormArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  eventExperience?: InputMaybe<Scalars['Int']['input']>;
  eventFeedback?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationManageOrganisationAccessArgs = {
  access: Scalars['Boolean']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationManuallyClassifyArgs = {
  classificationId: Scalars['String']['input'];
  subTopicExternalId?: InputMaybe<Scalars['String']['input']>;
  subTopicId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkAssistantConversationAsViewedArgs = {
  markAssistantConversationAsViewedInput: MarkAssistantConversationAsViewedInput;
};


export type MutationMentorBroadcastMessageArgs = {
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMessagePublicBotArgs = {
  botAction?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationModerateChatReportArgs = {
  chatReportModeratorInputDTO: ChatReportModeratorInputDto;
};


export type MutationModerateUserReportArgs = {
  userReportModeratorInputDTO: UserReportModeratorInputDto;
};


export type MutationPinMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPinMessageInConversationArgs = {
  pinMessageDTO: PinMessageDto;
};


export type MutationReadChatArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordConsentArgs = {
  channelId: Scalars['ObjectId']['input'];
  time: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};


export type MutationRecordFailureArgs = {
  data: RecordingFailureArgs;
};


export type MutationRecordLastMessageReadByUserArgs = {
  markReadMessageDto: MarkReadMessageDto;
};


export type MutationRecordUserActivityArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activitySource?: InputMaybe<Scalars['JSONString']['input']>;
  app?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterToLiveEventArgs = {
  liveEventSlug: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationRejectRequestedPublicGroupArgs = {
  rejectRequestedPublicGroupInput: RejectRequestedPublicGroupInput;
};


export type MutationRemoveApplicationInsightArgs = {
  removeApplicantInsightInput: RemoveApplicantInsightInput;
};


export type MutationRemoveBuddyInvitesArgs = {
  inviteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveDeviceArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMembersFromCommunityArgs = {
  removeMembersDTO: RemoveMembersFromCommunityInputDto;
};


export type MutationRemoveMentorInvitesArgs = {
  inviteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRemoveReactionFromMessageArgs = {
  reactionDto: ReactionDto;
};


export type MutationRemoveUserFromCommunityChatGroupArgs = {
  conversationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveVoteArgs = {
  chatMessageId: Scalars['ObjectId']['input'];
  option: Scalars['String']['input'];
};


export type MutationReorderTodoRankArgs = {
  id: Scalars['String']['input'];
  rankAfter?: InputMaybe<Scalars['String']['input']>;
  rankBefore?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestAnalyticsExportArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<RootUrlEnum>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordSetArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<RootUrlEnum>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPublicGroupArgs = {
  requestPublicGroupInput: CreateRequestedPublicGroupInput;
};


export type MutationRequestResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestResetPasswordMobileArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestResetPasswordMobileV2Args = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestToChangeEmailAddressArgs = {
  inviteId: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};


export type MutationRequestToDeleteAccountArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordEmailArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordV2Args = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveChatsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveConversationMessageArgs = {
  resolveMessageDto: ResolveMessageDto;
};


export type MutationRunManageCommandArgs = {
  command?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveAdminRecommendationArgs = {
  adminRecommendationInput: AdminRecommendationInput;
};


export type MutationSaveAmbassadorRecommendationArgs = {
  ambassadorRecommendationInput: AmbassadorRecommendationInput;
};


export type MutationSaveAppliedUsersArgs = {
  saveAppliedUsersInput: SaveAppliedUsersInput;
};


export type MutationSaveAssistantConversationEmailLeadArgs = {
  saveAssistantConversationEmailLeadInput: SaveAssistantConversationEmailLeadInput;
};


export type MutationSaveAssistantConversationFeedbackArgs = {
  saveAssistantConversationFeedbackInput: SaveAssistantConversationFeedbackInput;
};


export type MutationSaveCookieConsentPreferencesArgs = {
  CookieConsentInputDTO: CookieConsentInputDto;
};


export type MutationSaveInboxPromptAnswerArgs = {
  inboxPromptAnswerInput: InboxPromptAnswerInput;
};


export type MutationSaveInsightsByCommunityArgs = {
  communityId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveNotInterestedStageArgs = {
  notInterestedStageInput: UserNotInterestedStageInput;
};


export type MutationSaveSatisfactionSurveyArgs = {
  SatisfactionSurveyDTO: SatisfactionSurveyDto;
};


export type MutationSaveUniversityInterestedArgs = {
  UniversityInterestedDTO: UniversityInterestedDto;
};


export type MutationSaveUniversityQuestionAnswerArgs = {
  saveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
};


export type MutationSaveUserDecisionStageArgs = {
  decisionStageInput: UserDecisionStageInput;
};


export type MutationSaveVisitedRecommendationArgs = {
  saveVisitedRecommendationInput: SaveVisitedRecommendationInput;
};


export type MutationSendAssistantMessageArgs = {
  sendAssistantMessageInput: SendAssistantMessageInput;
};


export type MutationSendCommunityVerificationCodeArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendConversationMessageArgs = {
  messageDto: MessageDto;
};


export type MutationSendFeatureNotificationArgs = {
  FeatureNotificationRequestDTO: FeatureNotificationRequestDto;
};


export type MutationSendFeedMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  richContent?: InputMaybe<RichContentInputField>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendLiveEventMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  richContent?: InputMaybe<RichContentInputField>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendMessageArgs = {
  botAction?: InputMaybe<Scalars['String']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  origin?: InputMaybe<OriginField>;
  richContent?: InputMaybe<RichContentInputField>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendOpenDayProspectReportArgs = {
  openDayId: Scalars['String']['input'];
};


export type MutationSendVerificationCodeArgs = {
  captureToken?: InputMaybe<Scalars['String']['input']>;
  source: SourceInputField;
};


export type MutationSetActiveBlogTopicsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blogTopicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetArchivedContentBriefArgs = {
  archived: Scalars['Boolean']['input'];
  contentBriefId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
  valuable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetArchivedDegreeLevelArgs = {
  archived: Scalars['Boolean']['input'];
  degreeLevelId: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationSetArchivedYearOfStudyArgs = {
  archived: Scalars['Boolean']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationSetBlockUserArgs = {
  setBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetBlockUserV2Args = {
  setBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetBlogPostStatusArgs = {
  blogPostId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogStatus>;
};


export type MutationSetBuddiesListFiltersArgs = {
  filters?: InputMaybe<Array<InputMaybe<BuddiesListFilterInput>>>;
};


export type MutationSetChatGroupLabelsArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetDeviceTokenArgs = {
  SetDeviceTokenDTO: SetDeviceTokenDto;
};


export type MutationSetInterestsForUserArgs = {
  setUserInterestsInput: SetUserInterestsInput;
};


export type MutationSetMentorFieldLabelArgs = {
  customLabelMentorFields?: InputMaybe<Array<InputMaybe<MentorFieldCustomLabelInput>>>;
};


export type MutationSetMentorFieldOrderArgs = {
  order?: InputMaybe<Array<InputMaybe<MentorFieldOrderInput>>>;
};


export type MutationSetMentorListFilterSelectionArgs = {
  choices?: InputMaybe<Array<InputMaybe<MentorListFilterChoiceInput>>>;
};


export type MutationSetOnlineArgs = {
  online?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetResolveChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetUniversityUnblockUsersArgs = {
  setUnblocked?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetUserProfileArgs = {
  data: UpdateUserProfile;
};


export type MutationSetWillReplyArgs = {
  applicant?: InputMaybe<Scalars['String']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  mobileAdded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationShowMentorInMarketplaceArgs = {
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorId: Scalars['String']['input'];
};


export type MutationStartRecordingVideoArgs = {
  data: StartRecordingArgs;
};


export type MutationStopRecordingVideoArgs = {
  data: StopRecordingArgs;
};


export type MutationStopUniversityCrawlArgs = {
  universityStopCrawlInput: UniversityStopCrawlInput;
};


export type MutationToggleCommunityChatGroupMuteArgs = {
  conversationId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationToggleConversationResolutionArgs = {
  conversationId: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
};


export type MutationToggleCrmIntegrationSyncArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleCustomAttributeCrmSyncArgs = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleDegreesActiveArgs = {
  degreeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleFeatureAvailabilityArgs = {
  features?: InputMaybe<Array<InputMaybe<FeatureToggleInputField>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackLiveEventArgs = {
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackOpenDayArgs = {
  name: Scalars['String']['input'];
  openDayId: Scalars['String']['input'];
  product: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationTransferApplicantChatArgs = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
  contextText?: InputMaybe<Scalars['String']['input']>;
  transferTarget?: InputMaybe<TransferTarget>;
};


export type MutationTransferConversationArgs = {
  contextText: Scalars['String']['input'];
  transfereeId: Scalars['String']['input'];
  transferTarget: TransferTargetDto;
  universityId: Scalars['String']['input'];
};


export type MutationUnlikeConversationMessageArgs = {
  likeMessageDto: LikeMessageDto;
};


export type MutationUnpinMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpinMessageInConversationArgs = {
  unpinMessageDTO: UnpinMessageDto;
};


export type MutationUnresolveConversationMessageArgs = {
  resolveMessageDto: ResolveMessageDto;
};


export type MutationUpdateApplicantArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  captureToken?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasReadChatRules?: InputMaybe<Scalars['Boolean']['input']>;
  highSchool?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<UserLocalePreferenceInput>;
  pastUniversity?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApplicantPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateCanonicalQuestionArgs = {
  question?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  subTopic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateChatRoomArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
  updateChatRoomInput: UpdateChatRoomInput;
};


export type MutationUpdateCommunityApplicantSignupsourceArgs = {
  communityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCrmServiceUniversityConfigArgs = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  connectorEndpoint?: InputMaybe<Scalars['String']['input']>;
  connectorName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigs?: InputMaybe<Array<InputMaybe<DataFormatConfigInputType>>>;
  fields?: InputMaybe<Array<InputMaybe<CrmFieldInputType>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSyncActive?: InputMaybe<Scalars['Boolean']['input']>;
  sendSampleData?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  zapierWebhook?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDirectMessagingMembersForLiveEventArgs = {
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventPageArgs = {
  eventPageId: Scalars['ObjectId']['input'];
  updateEventPageInput: UpdateEventPageInput;
};


export type MutationUpdateExternalContentArgs = {
  externalContentId: Scalars['ObjectId']['input'];
  updateExternalContentInput: UpdateExternalContentInput;
};


export type MutationUpdateFaqAnswerArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  answerId: Scalars['String']['input'];
  canonicalQuestion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHobsonsConnectIntegrationArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  passKey?: InputMaybe<Scalars['String']['input']>;
  webServiceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateIntegrationFieldMappingArgs = {
  fieldMapping?: InputMaybe<Array<InputMaybe<FieldMappingInput>>>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLiveEventFeedSessionDataArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSessionToUpdateField>>>;
};


export type MutationUpdateLiveSessionArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
  updateLiveSessionInput: UpdateLiveSessionInput;
};


export type MutationUpdateLiveSessionAnyUserArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
  updateLiveSessionInput: UpdateLiveSessionAnyUserInput;
};


export type MutationUpdateManyUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMarketplaceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowUniversityProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  customBuddyWord?: InputMaybe<Scalars['String']['input']>;
  customFilters?: InputMaybe<Array<InputMaybe<MarketplaceFilterInput>>>;
  disableExternalNotification?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  marketplaceMarketingConsentCollectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentMessage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personalDataApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  unibuddyMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  universityMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
  widgetDescription?: InputMaybe<Scalars['String']['input']>;
  widgetTitle?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMarketplaceApplicantArgs = {
  marketplace: ApplicantMarketplaceInput;
};


export type MutationUpdateMarketplaceApplicantUniversityLinkArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSlug: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationUpdateMentorArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  chatIntro?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  degree?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<MentorDegreeFieldInput>>>;
  favouriteModules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  pastQualification?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  primaryFlag?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  secondaryFlag?: InputMaybe<Scalars['String']['input']>;
  societies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMentorPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateMyUniversityLinkArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  applied?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  dateOfEntry?: InputMaybe<Scalars['Date']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreesInterested?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<UserLocalePreferenceInput>;
  sourceMetadata?: InputMaybe<SourceMetadataField>;
  sourceTrackingParams?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationUpdateRecordingLayoutArgs = {
  data: UpdateRecordingLayoutArgs;
};


export type MutationUpdateResearchTimeArgs = {
  researchTimeData: ResearchTimeInput;
};


export type MutationUpdateStaffArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  department?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStaffContactArgs = {
  updateStaffContactInput: UpdateStaffContactInput;
};


export type MutationUpdateSubTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTagArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTodoActionArgs = {
  action: TodoAction;
  id: Scalars['String']['input'];
};


export type MutationUpdateTodoStatusArgs = {
  id: Scalars['String']['input'];
  status: TodoStatus;
};


export type MutationUpdateTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityAssistantScrapeStartingPointArgs = {
  universityAssistantConfigurationScrapeStartPointInput: UniversityAssistantConfigurationScrapeStartPointInput;
};


export type MutationUpdateUniversityBlockReportArgs = {
  blockedUser?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityBlockReportId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityUserPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserPreferencesMutationArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateVirtualEventArgs = {
  updateVirtualEventInput: UpdateVirtualEventInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationVerifyAccountArgs = {
  code: Scalars['String']['input'];
};


export type MutationViewBlogArgs = {
  blogId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NewsFeedGroup = {
  __typename?: 'NewsFeedGroup';
  conversationId: Scalars['String']['output'];
};

export type NotificationField = {
  __typename?: 'NotificationField';
  id?: Maybe<Scalars['String']['output']>;
};

/** The available methods for sending a notification. */
export enum NotificationMethod {
  Email = 'EMAIL',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  /** The default display text for the UI. */
  defaultDisplayText: Scalars['String']['output'];
  /** The default help text for the UI. */
  defaultHelpText: Scalars['String']['output'];
  /** Whether the notification is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The delivery method. */
  method: NotificationMethod;
  /** The unique slug for the preference. */
  preferenceSlug: Scalars['String']['output'];
  /** The product area for the preference. */
  product: NotificationProduct;
};

/** The product areas for which notifications can be configured. */
export enum NotificationProduct {
  Chat = 'CHAT',
  Community = 'COMMUNITY'
}

export enum NotInterestedReasonEnum {
  NotInterestedInApplyingToUni = 'NOT_INTERESTED_IN_APPLYING_TO_UNI',
  NotInterestedInUpdatesFromUni = 'NOT_INTERESTED_IN_UPDATES_FROM_UNI',
  NotInterestedOther = 'NOT_INTERESTED_OTHER'
}

export type OffsetIdPaginationDto = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offsetId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type OffsetPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OffsetPaginationDto = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenDayField = {
  __typename?: 'OpenDayField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isStaffCarouselEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStudentsCarouselEnabled?: Maybe<Scalars['Boolean']['output']>;
  liveEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  navigateOpenDays?: Maybe<Array<Maybe<OpenDayField>>>;
  navigateTags?: Maybe<Array<Maybe<TagField>>>;
  prospectLogins?: Maybe<OpenDaysLoginField>;
  prospectsAttending?: Maybe<Scalars['Int']['output']>;
  prospectSignups?: Maybe<OpenDaysSignupField>;
  start?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<TagField>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OpenDaysLoginField = {
  __typename?: 'OpenDaysLoginField';
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<Scalars['Int']['output']>;
  openDay?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  widget?: Maybe<Scalars['Int']['output']>;
};

export type OpenDaysSignupField = {
  __typename?: 'OpenDaysSignupField';
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<Scalars['Int']['output']>;
  openDay?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  widget?: Maybe<Scalars['Int']['output']>;
};

export type OpenTextFieldValueField = CustomAttributeValueField & {
  __typename?: 'OpenTextFieldValueField';
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OrderByLiveSessionsInput = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganisationBuddyLinkField = {
  __typename?: 'OrganisationBuddyLinkField';
  organisation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type OrganisationField = {
  __typename?: 'OrganisationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  childOrganisations?: Maybe<Array<Maybe<ChildOrganisationField>>>;
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkedInstance?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationType: Scalars['String']['output'];
  parentOrganisation?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export enum OrganisationType {
  Enterprise = 'ENTERPRISE',
  University = 'UNIVERSITY'
}

export type OriginField = {
  slug?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type OutboxChatGroupField = {
  __typename?: 'OutboxChatGroupField';
  aux?: Maybe<ChatGroupAuxiliaryField>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<LastMessageField>;
  members?: Maybe<Array<Maybe<AnyUserField>>>;
  opponent?: Maybe<AnyChatUserField>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  sendbirdChannelUrl?: Maybe<Scalars['String']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type OutputField = {
  __typename?: 'OutputField';
  returncode?: Maybe<Scalars['Int']['output']>;
  stderr?: Maybe<Scalars['String']['output']>;
  stdout?: Maybe<Scalars['String']['output']>;
};

export type PageMentorField = {
  __typename?: 'PageMentorField';
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAdminRecommendation = {
  __typename?: 'PaginatedAdminRecommendation';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AdminRecommendation>;
};

export type PaginatedApplicantInsightInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type PaginatedApplicantInvite = {
  __typename?: 'PaginatedApplicantInvite';
  data?: Maybe<Array<Maybe<ApplicantInvite>>>;
  totalNum?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedApplicationInsightModel = {
  __typename?: 'PaginatedApplicationInsightModel';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ApplicationInsightModel>;
};

export type PaginatedChatMessages = {
  __typename?: 'PaginatedChatMessages';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
};

export type PaginatedChatRooms = {
  __typename?: 'PaginatedChatRooms';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ChatRoom>;
};

export type PaginatedEventPages = {
  __typename?: 'PaginatedEventPages';
  hasMore: Scalars['Boolean']['output'];
  items: Array<EventPage>;
};

export type PaginatedExternalContents = {
  __typename?: 'PaginatedExternalContents';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ExternalContent>;
};

export type PaginatedLiveSessions = {
  __typename?: 'PaginatedLiveSessions';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LiveSession>;
};

export type PaginatedVirtualEvents = {
  __typename?: 'PaginatedVirtualEvents';
  hasMore: Scalars['Boolean']['output'];
  items: Array<VirtualEvent>;
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PasswordResetMobileMutation = {
  __typename?: 'PasswordResetMobileMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PasswordResetMobileMutationV2 = {
  __typename?: 'PasswordResetMobileMutationV2';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PayloadField = {
  __typename?: 'PayloadField';
  buttons?: Maybe<Array<Maybe<ButtonField>>>;
  relativePath?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PinMessageDto = {
  conversationId: Scalars['String']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type PinMessageMutation = {
  __typename?: 'PinMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PinnedMessageField = {
  __typename?: 'PinnedMessageField';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<PinnedMessageSenderField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PinnedMessageSenderField = {
  __typename?: 'PinnedMessageSenderField';
  accountRole?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type Poll = {
  __typename?: 'Poll';
  allowMultipleAnswers: Scalars['Boolean']['output'];
  options: Array<PollOption>;
  question: Scalars['String']['output'];
};

export type PollDto = {
  allowMultipleAnswers: Scalars['Boolean']['input'];
  options: Array<PollOptionDto>;
  question: Scalars['String']['input'];
};

export type PollOption = {
  __typename?: 'PollOption';
  option: Scalars['String']['output'];
  votes: Array<Scalars['ObjectId']['output']>;
};

export type PollOptionDto = {
  option: Scalars['String']['input'];
  votes?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type PopCardDegreeSnippetField = {
  __typename?: 'PopCardDegreeSnippetField';
  description?: Maybe<Scalars['String']['output']>;
  getSnippet?: Maybe<Array<Maybe<DegreeSnippetField>>>;
};

export type PopCardLevelSnippetField = {
  __typename?: 'PopCardLevelSnippetField';
  description?: Maybe<Scalars['String']['output']>;
  getSnippet?: Maybe<Array<Maybe<LevelSnippetField>>>;
};

export type PopcardSnippetField = {
  __typename?: 'PopcardSnippetField';
  defaultSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
  degreeSnippets?: Maybe<Array<Maybe<PopCardDegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
  internationalSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
  levelSnippets?: Maybe<Array<Maybe<PopCardLevelSnippetField>>>;
  nationalSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
};

export type PopCardWidgetField = {
  __typename?: 'PopCardWidgetField';
  description?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type PostFields = {
  __typename?: 'PostFields';
  acl?: Maybe<Scalars['String']['output']>;
  awsAccessKeyId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  xAmzSecurityToken?: Maybe<Scalars['String']['output']>;
};

export type PreferencesInputType = {
  analyticsCookies: Scalars['Boolean']['input'];
  strictCookies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreferencesObjectType = {
  __typename?: 'PreferencesObjectType';
  analyticsCookies: Scalars['Boolean']['output'];
  strictCookies: Scalars['Boolean']['output'];
};

export type PreferencesOutputType = {
  __typename?: 'PreferencesOutputType';
  analyticsCookies: Scalars['Boolean']['output'];
  strictCookies: Scalars['Boolean']['output'];
};

export enum Product {
  Community = 'community',
  VirtualEvent = 'virtualEvent',
  Widget = 'widget'
}

export type ProspectStageStatField = {
  __typename?: 'ProspectStageStatField';
  changeComparedToLastPeriod?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type ProspectStageSummaryField = {
  __typename?: 'ProspectStageSummaryField';
  summary?: Maybe<Array<Maybe<ProspectStageStatField>>>;
};

export enum PublicGroupStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type PublicMentorField = {
  __typename?: 'PublicMentorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  degree?: Maybe<DegreeField>;
  degreeHistory?: Maybe<MentorDegreeHistory>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  favouriteModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Array<Maybe<MentorInterestField>>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  matchCriteria?: Maybe<Scalars['String']['output']>;
  mentorFields?: Maybe<MentorFields>;
  pastQualification?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<MentorSchoolHistoryField>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  slowSocieties?: Maybe<Array<Maybe<MentorSocietyField>>>;
  societies?: Maybe<Array<Maybe<MentorSocietyField>>>;
  university?: Maybe<UniversityField>;
  year?: Maybe<Scalars['String']['output']>;
};


export type PublicMentorFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PublicMentorFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PublicMentorFieldShareUrlArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};

export type PublicUserField = {
  __typename?: 'PublicUserField';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type QssMetadata = {
  allQuestions?: InputMaybe<Array<InputMaybe<QssQuestion>>>;
  originalQuestionText?: InputMaybe<Scalars['String']['input']>;
  questionModified?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  userChoseQss?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QssQuestion = {
  questionId?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activeUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  adminMentor?: Maybe<MentorField>;
  adminRecommendationCountPerDecisionStage: Array<AdminRecommendationCountPerDecisionStage>;
  adminSearchMentors?: Maybe<Array<Maybe<MentorField>>>;
  agenda: PaginatedLiveSessions;
  alert?: Maybe<AlertField>;
  allAdminApplicants?: Maybe<Array<Maybe<BulkApplicantField>>>;
  allApplicantConversations?: Maybe<Array<Maybe<ApplicantConversationField>>>;
  allApplicantCount?: Maybe<ApplicantCountField>;
  allApplicants?: Maybe<Array<Maybe<BulkApplicantField>>>;
  allApplicantSignUps?: Maybe<Array<Maybe<CountPerEpoch>>>;
  allAppLocales?: Maybe<Array<Maybe<AppLocaleField>>>;
  allBuddyInvites?: Maybe<BuddyInviteField>;
  allChatGroupCount?: Maybe<Array<Maybe<CountPerEpoch>>>;
  allChatGroupsByDay?: Maybe<Array<Maybe<ChatGroupField>>>;
  allContentBriefs?: Maybe<Array<Maybe<ContentBriefField>>>;
  allCountries?: Maybe<Array<Maybe<CountryField>>>;
  allCrmIntegrations?: Maybe<Array<Maybe<CrmIntegrationField>>>;
  allCrms?: Maybe<Array<Maybe<CrmField>>>;
  allDegreeLevels?: Maybe<Array<Maybe<DegreeLevelField>>>;
  allDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  allDegreeTypes?: Maybe<Array<Maybe<DegreeType>>>;
  allHighSchools?: Maybe<Array<Maybe<HighSchoolField>>>;
  allHighSchoolTypes?: Maybe<Array<Maybe<HighSchoolTypeField>>>;
  allLanguages?: Maybe<Array<Maybe<LanguageField>>>;
  allLocales?: Maybe<Array<Maybe<LocaleField>>>;
  allMentorInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
  allMentors?: Maybe<Array<Maybe<MentorField>>>;
  allMentorsOfEnterprise?: Maybe<Array<Maybe<EnterpriseMentorField>>>;
  allMentorsTimeSpent?: Maybe<UsersTimeSpentData>;
  allPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  allPostsInfo?: Maybe<AllPostsField>;
  allStaff?: Maybe<StaffUserListField>;
  allSubCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  allSubRegions?: Maybe<Array<Maybe<TopRegionField>>>;
  allTopCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  allTopDegrees?: Maybe<Array<Maybe<TopDegreeField>>>;
  allTopRegions?: Maybe<Array<Maybe<TopRegionField>>>;
  allUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  allUserIds?: Maybe<UserIdsListField>;
  allUsers?: Maybe<UserListField>;
  allYearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
  analytics: Analytics;
  applicant?: Maybe<ApplicantField>;
  applicantCollectionFields?: Maybe<Array<Maybe<ApplicantCollectionField>>>;
  applicantCount?: Maybe<ApplicantCountField>;
  applicantCountryCount?: Maybe<Scalars['Int']['output']>;
  applicantDegreeCount?: Maybe<Scalars['Int']['output']>;
  applicantDomesticRegionCount?: Maybe<Scalars['Int']['output']>;
  applicantInbox?: Maybe<ApplicantInboxField>;
  applicantInvites?: Maybe<Array<Maybe<ApplicantInvite>>>;
  applicantsApplied?: Maybe<ApplicantsAppliedStats>;
  applicantSignUps?: Maybe<Array<Maybe<CountPerEpoch>>>;
  applicantsMessaged?: Maybe<ApplicantsMessagedCount>;
  applicationInsights: PaginatedApplicationInsightModel;
  appliedUsersCount: AppliedUsersCountModel;
  appLocales?: Maybe<AppLocaleField>;
  askQuestion?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  availableDegreeTypes?: Maybe<Array<Maybe<DegreeType>>>;
  blockedUsersByMe?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  botUser?: Maybe<BotUserField>;
  buddies?: Maybe<BuddiesField>;
  buddiesFilterOptions?: Maybe<BuddiesFilterOptionsField>;
  buddy?: Maybe<BuddyField>;
  buddyApplicantChatGroupCount?: Maybe<Scalars['Int']['output']>;
  buddyApplicantChatGroups?: Maybe<Array<Maybe<BuddyApplicantChatGroupField>>>;
  buddyApplicantChatIntervention?: Maybe<Array<Maybe<BuddyApplicantChatInterventionBuddyField>>>;
  buddyApplicantChatInterventionTotalCount?: Maybe<Scalars['Int']['output']>;
  buddyInvite?: Maybe<BuddyInviteListField>;
  buddyResponseTime?: Maybe<Array<Maybe<AnalyticsBuddyField>>>;
  canonicalQuestions?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  chatGroupAux?: Maybe<ChatGroupAuxiliaryField>;
  chatGroupById?: Maybe<ChatGroupField>;
  chatGroupCount?: Maybe<Array<Maybe<CountPerEpoch>>>;
  chatGroupLabellingCandidates?: Maybe<Array<Maybe<LabellingSentenceCandidate>>>;
  chatGroupLabels?: Maybe<Array<Maybe<ChatGroupLabelField>>>;
  chatGroupsByDay?: Maybe<Array<Maybe<ChatGroupField>>>;
  chatGroupSuggestions?: Maybe<Array<Maybe<SuggestionField>>>;
  chatInterventionMentors?: Maybe<MentorInterventionQueryField>;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomAnalytics?: Maybe<ChatRoomAnalytics>;
  chatRooms: PaginatedChatRooms;
  /** @deprecated Deprecated, please use communityUserSearch which has totalUsers count */
  communityUserDirectory: Array<UserField>;
  communityUserSearch: UserDirectoryResult;
  completedEvents?: Maybe<CompletedEventsOverview>;
  conversationContext?: Maybe<Array<Maybe<ConversationContextField>>>;
  /** @deprecated Do not use query. See implementation for more details. */
  conversationInboxDoNotUse: Array<ConversationInbox>;
  conversationStats?: Maybe<Array<Maybe<TrendingTopicsField>>>;
  country?: Maybe<CountryField>;
  crmApplicationFields?: Maybe<Array<Maybe<ApplicationField>>>;
  crmAttributes?: Maybe<Array<Maybe<CrmAttributeField>>>;
  crmDateFormats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  crmIntegration?: Maybe<CrmIntegrationField>;
  crmServiceUniversityConfig?: Maybe<CrmServiceUniversityConfig>;
  crmSyncJob?: Maybe<CrmSyncJobField>;
  currentUserDecisionStage: CurrentDecisionStageOutput;
  debugApplicantPayloads?: Maybe<Array<Maybe<DebugApplicantPayloadField>>>;
  degreeCategories?: Maybe<Array<Maybe<DegreeCategoryField>>>;
  degreeCategoriesCount?: Maybe<Scalars['Int']['output']>;
  degreeCategory?: Maybe<DegreeCategoryField>;
  discoverableUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  domesticRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  enrolledInsightsByCommunity: EnrolledInsightResponse;
  enterpriseAddOns?: Maybe<Array<Maybe<EnterpriseAddOns>>>;
  enterpriseDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  enterpriseMentorCount?: Maybe<Scalars['Int']['output']>;
  eventAnalytics: Analytics;
  eventPage?: Maybe<EventPage>;
  eventPages: PaginatedEventPages;
  exampleGraphQLQuery: Scalars['Boolean']['output'];
  exportTimesheetReport?: Maybe<ExportTimeSheetDataField>;
  externalContent?: Maybe<ExternalContent>;
  externalContents: PaginatedExternalContents;
  externalEvent?: Maybe<ExternalEventField>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  filterUsersEnterprise?: Maybe<Array<Maybe<UserCustomAttributesFilterField>>>;
  getAIConversationHistory?: Maybe<AiConversationHistoryOutput>;
  getAssistantConversation?: Maybe<AssistantConversationHistory>;
  getBadges: Array<Badge>;
  getChatConversation: ChatConversation;
  getChatConversationCountForUser: Scalars['Int']['output'];
  getChatConversationFromLegacyId?: Maybe<ChatConversation>;
  getChatConversationInbox: Array<ChatConversation>;
  getChatConversationMessages: PaginatedChatMessages;
  getChatConversationsForUser: Array<ChatConversation>;
  /** @deprecated Deprecated, please use getCommunityConversations */
  getChatGroupsForCommunity: Array<CommunityChatGroup>;
  /** Get chat reports for a university based on product (currently supports community and virtualEvent). The query is available to only university users and admins. */
  getChatReports: Array<ChatReport>;
  /** Paginated query to get community chat members */
  getCommunityChatMembers: Array<UserField>;
  /** This differs from the getChatConversation resolver in that it checks for the ReadCommunity permissions instead of ReadConversation permissions. */
  getCommunityConversation: ChatConversation;
  getCommunityConversations: Array<ChatConversation>;
  getCommunityForUniOrAdmin: Community;
  getCommunityForUser: Community;
  getCommunityInvites: Array<CommunityInvites>;
  getCommunityMemberInvites: Array<CommunityInvites>;
  getCommunityMembers: Array<UserField>;
  getCommunityTemplates: Array<Array<Scalars['String']['output']>>;
  getConversationPermission: ChatPermission;
  getConversationWithAmbassador?: Maybe<ChatConversation>;
  getExperimentalTodos: Scalars['String']['output'];
  getGeckoUniversityId?: Maybe<GeckoUniversityData>;
  getIdpToken?: Maybe<AuthField>;
  getInterests: Array<Interest>;
  getInterestsForUser: Array<UserInterest>;
  getInviteFromId: Invite;
  getInviteInformation: InviteInformation;
  getInviteLinkInfo: InviteLinkInfoDto;
  getInvitesForCommunity: Array<CommunityInvites>;
  getInvitesForEmail: Array<GetInvitesForEmailDto>;
  getLabels: Array<Labels>;
  getLiveEventsById?: Maybe<Array<Maybe<LiveEventField>>>;
  /** @deprecated This query has now been deprecated, please use getChatConversationMessages */
  getMessagesForChatConversation: Array<ChatMessage>;
  /** Retrieves the notification preferences for the user. */
  getNotificationPreferences: Array<NotificationPreference>;
  getOrCreateBotChatGroup?: Maybe<ChatGroupField>;
  getOrCreateChatGroup?: Maybe<ChatGroupField>;
  getOrCreateCommunitiesForInstitution: Array<Community>;
  getOrCreateUniversityChatGroup?: Maybe<ChatGroupAndMessages>;
  getRandomAmbassadors?: Maybe<Array<AmbassadorProfileInformation>>;
  getRecommendedConversations: Array<ChatConversation>;
  getRecommendedUsers: UserRecommendation;
  getRecording?: Maybe<RecordingDownloadResponse>;
  getRecordingFailuresByChannelId: GetRecordingFailureIdsResponse;
  getRecordingFailuresByEventId: GetRecordingFailureIdsResponse;
  getRecordingList?: Maybe<RecordingListResponse>;
  getRecordingUploadingCount: RecordingUploadingResponse;
  getTodoById: TodosEntity;
  getTodosForUniversity: Array<TodosEntity>;
  getTodosForUser: Array<TodosEntity>;
  getToken?: Maybe<AuthField>;
  getTokenForEnterpriseView?: Maybe<AuthField>;
  /** Gets all universities which pass the feature flag check via launch darkly based on universitySlug. */
  getUniversitiesByFeatureFlag: FeatureRulesDto;
  getUniversityAssistantConfig?: Maybe<UniversityAssistantConfiguration>;
  getUser?: Maybe<UserField>;
  getUserByEmail?: Maybe<UserField>;
  getUserByIds?: Maybe<Array<Maybe<UserField>>>;
  getUserProfile: UserProfile;
  /** Get user reports for a university based on product (currently supports community and virtualEvent). The query is available to only university users and admins. */
  getUserReports: Array<UserReport>;
  getUsersCommunityConversations: Array<ChatConversation>;
  getUsersCommunityPrivateConversations: Array<ChatConversation>;
  getVideoContent: VideoContent;
  globalAlerts?: Maybe<Array<Maybe<AlertField>>>;
  hasContent: UniversityContent;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  helloCommunityService: Scalars['String']['output'];
  hobsonsConnectIntegration?: Maybe<CampusManagementConnectIntegrationField>;
  inboxPromptQuestionByQuestionId: InboxPromptQuestion;
  inboxPromptQuestions: Array<InboxPromptQuestion>;
  interventionMessageList?: Maybe<Array<Maybe<InterventionMessageField>>>;
  /** Health check resolver for intelligence service */
  isIntelligenceHealthy: Scalars['Boolean']['output'];
  /** Health check resolver for moderation-service */
  isModerationHealthy: Scalars['Boolean']['output'];
  isProspectGuidanceHealthy: Scalars['Boolean']['output'];
  isUserInDirectMessages?: Maybe<Scalars['Boolean']['output']>;
  isUserProfilingHealthy: Scalars['Boolean']['output'];
  isVideoContentHealthy: Scalars['Boolean']['output'];
  latestExportedReport?: Maybe<ExportedReportField>;
  listAdminRecommendationResourceTypes: Array<RecommendationResourceType>;
  listAdminRecommendations: PaginatedAdminRecommendation;
  listArchivedCommunitiesForAnInstitution: Array<Community>;
  listBuddyApplicantConversations?: Maybe<ListBuddyApplicantConversationsField>;
  listCommunitiesForAnInstitution: Array<Community>;
  listMentorApplicantConversations?: Maybe<ListMentorApplicantConversationsField>;
  listUniversityAssistantConversations?: Maybe<ListUniversityAssistantConversationsOutput>;
  listUniversityKnowledgeBaseSources: Array<KnowledgeBaseEmbedding>;
  listUniversityKnowledgeBaseSourcesByUrlPattern: Array<KnowledgeBaseSourcesByUrl>;
  liveEvent?: Maybe<LiveEventField>;
  liveEventLandingPage?: Maybe<LiveEventLandingPageField>;
  liveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  liveFeed?: Maybe<LiveEventChatGroupField>;
  liveSession?: Maybe<LiveSession>;
  liveSessions: PaginatedLiveSessions;
  marketplace?: Maybe<MarketplaceField>;
  marketplaceApplicantChatGroupsCount?: Maybe<Scalars['Int']['output']>;
  marketplaceApplicantCountries?: Maybe<MarketplaceApplicantCountries>;
  marketplaceApplicantDegreeCategories?: Maybe<MarketplaceApplicantDegreeCategories>;
  marketplaceApplicantsCount?: Maybe<Scalars['Int']['output']>;
  marketplaceInbox?: Maybe<MarketplaceInboxField>;
  marketplaceMentorCountries?: Maybe<Array<Maybe<CountryField>>>;
  marketplaceMentorDegreeCategories?: Maybe<Array<Maybe<UniversityField>>>;
  marketplaceMentorList?: Maybe<MarketplaceMentorList>;
  marketplaceMentorRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  marketplaceMentorUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  marketplaces?: Maybe<Array<Maybe<MarketplaceField>>>;
  marketplacesCount?: Maybe<Scalars['Int']['output']>;
  marketplaceSnippets?: Maybe<MarketplaceSnippetField>;
  marketplaceUniversitiesSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketplaceUniversityCountries?: Maybe<Array<Maybe<CountryField>>>;
  marketplaceUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  me?: Maybe<MeField>;
  memberOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  mentorApplicantChatGroupCount?: Maybe<Scalars['Int']['output']>;
  mentorApplicantChatGroups?: Maybe<Array<Maybe<MentorApplicantChatGroupField>>>;
  mentorCount?: Maybe<Scalars['Int']['output']>;
  mentorEngagementMetrics?: Maybe<MentorEngagementMetricsField>;
  mentorInbox?: Maybe<MentorInboxField>;
  mentorInterests?: Maybe<Array<Maybe<MentorInterestField>>>;
  mentorIntroMessage?: Maybe<MentorIntroMessageField>;
  mentorInvite?: Maybe<MentorInviteField>;
  mentorInviteCount?: Maybe<MentorInviteCountField>;
  mentorList?: Maybe<MentorListField>;
  mentorModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  mentorPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  mentorResponseTime?: Maybe<Array<Maybe<AnalyticsMentorField>>>;
  mentorSocieties?: Maybe<Array<Maybe<MentorSocietyField>>>;
  mentorTimeSpent?: Maybe<Array<Maybe<AnalyticsMentorField>>>;
  messages?: Maybe<ChatGroupAndMessages>;
  myAgenda: PaginatedLiveSessions;
  myBlogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  myLiveEventDirectMessaging?: Maybe<LiveEventDirectMessaging>;
  myLiveEventFeeds?: Maybe<Array<Maybe<LiveEventChatGroupField>>>;
  myRegisteredEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  myUniversityDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  myUniversityLink?: Maybe<ApplicantUniversityLinkField>;
  offsetId?: Maybe<Scalars['String']['output']>;
  openDay?: Maybe<OpenDayField>;
  openDays?: Maybe<Array<Maybe<OpenDayField>>>;
  openDaysWithViewFilter?: Maybe<Array<Maybe<OpenDayField>>>;
  organisation?: Maybe<OrganisationField>;
  organisations?: Maybe<Array<Maybe<OrganisationField>>>;
  outbox?: Maybe<Array<Maybe<OutboxChatGroupField>>>;
  outboxCount?: Maybe<Scalars['Int']['output']>;
  pageMentors?: Maybe<PageMentorField>;
  paginatedApplicantInvites?: Maybe<PaginatedApplicantInvite>;
  pingUserDirectory: Scalars['String']['output'];
  popularSession?: Maybe<SessionAnalytics>;
  post?: Maybe<BlogPostField>;
  prospectChatSummary?: Maybe<ChatSummaryField>;
  prospectChatSummaryV2?: Maybe<ChatSummaryField>;
  prospectStageStats?: Maybe<ProspectStageSummaryField>;
  publicLiveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  publicMentor?: Maybe<PublicMentorField>;
  publicMentorIntroMessage?: Maybe<MentorIntroMessageField>;
  publicStaffCount?: Maybe<Scalars['Int']['output']>;
  publicUser?: Maybe<PublicUserField>;
  qssQuestions?: Maybe<Array<Maybe<QuestionField>>>;
  queryRecording: QueryRecordingResponse;
  queryUniversityIndexing?: Maybe<UniversityScrapeIndexingOutput>;
  randomBuddy?: Maybe<BuddyField>;
  randomDefaultQuestions?: Maybe<Array<Maybe<DefaultQuestionsField>>>;
  randomMentor?: Maybe<PublicMentorField>;
  randomMentorsList?: Maybe<RandomMentorsListField>;
  requestedPublicGroups: Array<RequestedPublicGroup>;
  researchTime?: Maybe<ResearchTimeResult>;
  researchTimeLog?: Maybe<Array<Maybe<ResearchTimeLogResult>>>;
  searchUniversityKnowledgeBase: Array<SearchResult>;
  sequenceFilterMentorList?: Maybe<SequenceFilterMentorListField>;
  serverTime?: Maybe<Scalars['String']['output']>;
  sharableConversationLink: Scalars['String']['output'];
  signupsOverTime?: Maybe<ApplicantSignupStats>;
  singleInstanceOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  staffContactByUniversityId?: Maybe<StaffContactOutput>;
  subTopic?: Maybe<SubTopicField>;
  subTopics?: Maybe<Array<Maybe<SubTopicField>>>;
  switchUniversities?: Maybe<SwitchUniversitiesField>;
  tag?: Maybe<TagField>;
  tags?: Maybe<Array<Maybe<TagField>>>;
  timeTaken?: Maybe<TimeTakenField>;
  topCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  topDegrees?: Maybe<Array<Maybe<TopDegreeField>>>;
  topDomesticRegions?: Maybe<Array<Maybe<TopDomesticRegionField>>>;
  topic?: Maybe<TopicField>;
  topics?: Maybe<Array<Maybe<TopicField>>>;
  topicStatistics?: Maybe<Array<Maybe<InsightsField>>>;
  topSignupsByCountry?: Maybe<Array<Maybe<CountryStatField>>>;
  topSignupsByDegree?: Maybe<Array<Maybe<DegreeStatField>>>;
  topSignupsByState?: Maybe<Array<Maybe<StateStatField>>>;
  totalSignups?: Maybe<SignUpsCount>;
  triggerDegreeExport?: Maybe<Scalars['String']['output']>;
  triggerMentorExport?: Maybe<Scalars['String']['output']>;
  triggerProspectExportEmail?: Maybe<Scalars['String']['output']>;
  triggerReportExport?: Maybe<Scalars['String']['output']>;
  triggerTopicStatisticsExport?: Maybe<Scalars['String']['output']>;
  uniApplicantSignUps?: Maybe<GraphField>;
  uniApplicantSignUpsBenchmark?: Maybe<GraphField>;
  uniChatGroups?: Maybe<GraphField>;
  uniChatGroupsBenchmark?: Maybe<GraphField>;
  uniConversionRate?: Maybe<GraphField>;
  uniConversionRateBenchmark?: Maybe<GraphField>;
  uniMessages?: Maybe<ChatGroupAndMessages>;
  uniMessagesPerChatGroup?: Maybe<GraphField>;
  uniResponseTime?: Maybe<GraphField>;
  uniResponseTimeBenchmark?: Maybe<GraphField>;
  uniSentences?: Maybe<GraphField>;
  uniSentencesBenchmark?: Maybe<GraphField>;
  uniSentencesPerChatGroup?: Maybe<GraphField>;
  uniSentencesPerChatGroupBenchmark?: Maybe<GraphField>;
  uniTimeSpent?: Maybe<GraphField>;
  uniTimeSpentBenchmark?: Maybe<GraphField>;
  uniUniqueVisits?: Maybe<GraphField>;
  uniUniqueVisitsBenchmark?: Maybe<GraphField>;
  university?: Maybe<UniversityField>;
  universityAdmins?: Maybe<Array<Maybe<UniversityUserField>>>;
  universityAlerts?: Maybe<Array<Maybe<AlertField>>>;
  universityBlockReports?: Maybe<Array<Maybe<UniversityBlockReportField>>>;
  universityBlockReportsCount?: Maybe<Scalars['Int']['output']>;
  universityBlogPosts?: Maybe<UniversityBlogPostsField>;
  universityBlogPostsCount?: Maybe<Scalars['Int']['output']>;
  universityBlogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  universityInbox?: Maybe<UniversityInboxField>;
  universityMentor?: Maybe<MentorField>;
  universityQuestionById: UniversityQuestion;
  universityQuestions: Array<UniversityQuestion>;
  universitySnippets?: Maybe<UniversitySnippetField>;
  universityUsers?: Maybe<Array<Maybe<UniversityUserField>>>;
  unreadCount?: Maybe<UnreadCountField>;
  upcomingExternalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  upcomingLiveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  userChatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  userPartialSearch?: Maybe<Array<Maybe<UserCustomAttributesFilterField>>>;
  userPartialSearchMultipleFields?: Maybe<Array<Maybe<UserPartialSearchFields>>>;
  userPermissions?: Maybe<UserPermissionsListField>;
  userTimeSpentBreakdown?: Maybe<UserTimeSpentBreakdown>;
  userUnreadMessageCount?: Maybe<UnreadMessageCountField>;
  verifyCode?: Maybe<VerifyCodeField>;
  virtualEvent?: Maybe<VirtualEvent>;
  virtualEventAttendees: Array<UserField>;
  virtualEventProspectReport?: Maybe<ReportAnalytics>;
  virtualEvents: PaginatedVirtualEvents;
  virtualEventsByUniversityIds: PaginatedVirtualEvents;
};


export type QueryAdminMentorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminRecommendationCountPerDecisionStageArgs = {
  universityId: Scalars['ObjectId']['input'];
};


export type QueryAdminSearchMentorsArgs = {
  propName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgendaArgs = {
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  pagination: PaginationInput;
  rangeDate?: InputMaybe<RangeDateInput>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryAlertArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAdminApplicantsArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantConversationsArgs = {
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantCountArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantsArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllApplicantSignUpsArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllBuddyInvitesArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  roleSelected?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllChatGroupCountArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllChatGroupsByDayArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllContentBriefsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDegreeLevelsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDegreesArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeType?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllHighSchoolsArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorInvitesArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMentorsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorsOfEnterpriseArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorsTimeSpentArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPostsArgs = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPostsInfoArgs = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  randomise?: InputMaybe<Scalars['Boolean']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStaffArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSubCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  inputRegion?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSubRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  inputRegion?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopDegreesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUniversitiesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUserIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUsersWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUsersWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllYearOfStudyArgs = {
  degreeLevelId?: InputMaybe<Scalars['String']['input']>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryApplicantArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantCollectionFieldsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantCountArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryApplicantInboxArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantInvitesArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryApplicantsAppliedArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApplicantSignUpsArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantsMessagedArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApplicationInsightsArgs = {
  paginatedApplicantInsightInput: PaginatedApplicantInsightInput;
  pagination: GraphQlOffsetPaginationInput;
};


export type QueryAppliedUsersCountArgs = {
  appliedUsersCountInput: AppliedUsersCountInput;
};


export type QueryAppLocalesArgs = {
  appName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAskQuestionArgs = {
  question: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type QueryAvailableDegreeTypesArgs = {
  universitySlug: Scalars['String']['input'];
};


export type QueryBlogTopicsArgs = {
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBotUserArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddiesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customAttributesFilters?: InputMaybe<Array<InputMaybe<CustomAttributesFilterInputField>>>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  randomizeListSeed?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  useRandomizeStaffFeature?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddiesFilterOptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<InputMaybe<BuddiesListFilterInput>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddyArgs = {
  id: Scalars['String']['input'];
};


export type QueryBuddyApplicantChatGroupCountArgs = {
  buddyId?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatGroupsArgs = {
  buddyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatInterventionArgs = {
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatInterventionTotalCountArgs = {
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyInviteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddyResponseTimeArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanonicalQuestionsArgs = {
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  opponentId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupAuxArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupByIdArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupCountArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupLabellingCandidatesArgs = {
  chatGroupId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  topicLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatGroupsByDayArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupSuggestionsArgs = {
  chatGroupId: Scalars['String']['input'];
};


export type QueryChatInterventionMentorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatRoomArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryChatRoomAnalyticsArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
};


export type QueryChatRoomsArgs = {
  pagination: PaginationInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryCommunityUserDirectoryArgs = {
  filterUsersDTO: FilterUsersDto;
  pagination: OffsetPagination;
};


export type QueryCommunityUserSearchArgs = {
  filterUsersDTO: FilterUsersDto;
  pagination: OffsetPagination;
};


export type QueryCompletedEventsArgs = {
  endDate: Scalars['DateTime']['input'];
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryConversationContextArgs = {
  endDate: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  subGroupById?: InputMaybe<Scalars['String']['input']>;
  subTopic: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type QueryConversationStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountryArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmAttributesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmIntegrationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmServiceUniversityConfigArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmSyncJobArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentUserDecisionStageArgs = {
  currentUserDecisionStageQueryInput: CurrentUserDecisionStageQueryInput;
};


export type QueryDebugApplicantPayloadsArgs = {
  applicantId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type QueryDegreeCategoriesArgs = {
  categoryType?: InputMaybe<Scalars['String']['input']>;
  hierarchyRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDegreeCategoriesCountArgs = {
  categoryType?: InputMaybe<Scalars['String']['input']>;
  hierarchyRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDegreeCategoryArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscoverableUniversitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  randomizeSeed?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDomesticRegionsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrolledInsightsByCommunityArgs = {
  enrolledInsightsInput: EnrolledInsightsInput;
};


export type QueryEnterpriseDegreesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnterpriseMentorCountArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventAnalyticsArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryEventPageArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryEventPagesArgs = {
  pagination: PaginationInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryExportTimesheetReportArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalContentArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryExternalContentsArgs = {
  eventPageId?: InputMaybe<Scalars['ObjectId']['input']>;
  pagination: PaginationInput;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryExternalEventArgs = {
  externalEventId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalEventsArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterUsersEnterpriseArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAiConversationHistoryArgs = {
  AIConversationHistoryInput: AiConversationHistoryInput;
};


export type QueryGetAssistantConversationArgs = {
  getAssistantConversationInput: GetAssistantConversationInput;
};


export type QueryGetChatConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetChatConversationCountForUserArgs = {
  filters?: InputMaybe<FiltersDto>;
};


export type QueryGetChatConversationFromLegacyIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetChatConversationInboxArgs = {
  ChatConversationInboxInputDto: ChatConversationInboxInputDto;
};


export type QueryGetChatConversationMessagesArgs = {
  getMessageDto: GetMessageDto;
};


export type QueryGetChatConversationsForUserArgs = {
  filters?: InputMaybe<FiltersDto>;
  offsetPagination?: InputMaybe<OffsetPaginationDto>;
};


export type QueryGetChatGroupsForCommunityArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetChatReportsArgs = {
  getChatReportsDTO: GetChatReportsDto;
};


export type QueryGetCommunityChatMembersArgs = {
  conversationId: Scalars['String']['input'];
  offsetPagination: OffsetPagination;
};


export type QueryGetCommunityConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCommunityConversationsArgs = {
  communityId: Scalars['String']['input'];
  filters?: InputMaybe<GetCommunityConversationsFilterDto>;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityForUniOrAdminArgs = {
  communityId: Scalars['String']['input'];
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityForUserArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetCommunityInvitesArgs = {
  communityId: Scalars['String']['input'];
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityMemberInvitesArgs = {
  communityId: Scalars['String']['input'];
  filters: InviteFilter;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityMembersArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetConversationPermissionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetConversationWithAmbassadorArgs = {
  ambassadorId: Scalars['String']['input'];
};


export type QueryGetGeckoUniversityIdArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetIdpTokenArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  idpToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInviteFromIdArgs = {
  inviteId: Scalars['String']['input'];
};


export type QueryGetInviteInformationArgs = {
  InviteInformationInput: InviteInformationInput;
};


export type QueryGetInviteLinkInfoArgs = {
  inviteLinkId: Scalars['String']['input'];
};


export type QueryGetInvitesForCommunityArgs = {
  communityId: Scalars['String']['input'];
  filters: InviteFilter;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvitesForEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetLiveEventsByIdArgs = {
  liveEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMessagesForChatConversationArgs = {
  getMessageDto: GetMessageDto;
};


export type QueryGetNotificationPreferencesArgs = {
  input: GetNotificationPreferencesInput;
};


export type QueryGetOrCreateBotChatGroupArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrCreateChatGroupArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  opponentId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrCreateCommunitiesForInstitutionArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetOrCreateUniversityChatGroupArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRandomAmbassadorsArgs = {
  getRandomAmbassadorsInput: GetRandomAmbassadorsInput;
};


export type QueryGetRecommendedConversationsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetRecommendedUsersArgs = {
  communityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchingCriterion?: InputMaybe<MatchingCriteriaEnum>;
  pagination?: InputMaybe<OffsetPagination>;
};


export type QueryGetRecordingArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetRecordingFailuresByChannelIdArgs = {
  data: GetRecordingFailureIdsArgs;
};


export type QueryGetRecordingFailuresByEventIdArgs = {
  data: GetRecordingFailureIdsArgs;
};


export type QueryGetRecordingListArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecordingUploadingCountArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};


export type QueryGetTodoByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTodosForUniversityArgs = {
  filters?: InputMaybe<GetTodosFilterDto>;
  universityId: Scalars['String']['input'];
};


export type QueryGetTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  notificationToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTokenForEnterpriseViewArgs = {
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUniversitiesByFeatureFlagArgs = {
  featureFlag: Scalars['String']['input'];
};


export type QueryGetUniversityAssistantConfigArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserByIdsArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserReportsArgs = {
  getUserReportsDTO: GetUserReportsDto;
};


export type QueryGetUsersCommunityConversationsArgs = {
  communityId: Scalars['String']['input'];
  offsetPagination?: InputMaybe<OffsetPagination>;
};


export type QueryGetUsersCommunityPrivateConversationsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGlobalAlertsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHasContentArgs = {
  universityContentInput: UniversityContentInput;
};


export type QueryHelloCommunityServiceArgs = {
  throwError?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHobsonsConnectIntegrationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInboxPromptQuestionByQuestionIdArgs = {
  questionId: Scalars['ObjectId']['input'];
};


export type QueryInboxPromptQuestionsArgs = {
  inboxPromptInput: InboxPromptInput;
};


export type QueryInterventionMessageListArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsUserInDirectMessagesArgs = {
  liveEventSlug: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryLatestExportedReportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  openDayId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAdminRecommendationsArgs = {
  listAdminRecommendationInput: ListAdminRecommendationInput;
  pagination: GraphQlOffsetPaginationInput;
};


export type QueryListArchivedCommunitiesForAnInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryListBuddyApplicantConversationsArgs = {
  activeBuddies?: InputMaybe<Scalars['Boolean']['input']>;
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCommunitiesForAnInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryListMentorApplicantConversationsArgs = {
  activeMentors?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUniversityAssistantConversationsArgs = {
  listUniversityAssistantConversationsInput: ListUniversityAssistantConversationsInput;
};


export type QueryListUniversityKnowledgeBaseSourcesArgs = {
  knowledgeBaseSourceQueryInput: KnowledgeBaseSourceQueryInput;
};


export type QueryListUniversityKnowledgeBaseSourcesByUrlPatternArgs = {
  knowledgeBaseSourcesListInput: KnowledgeBaseSourcesListInput;
};


export type QueryLiveEventArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveEventLandingPageArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveEventsArgs = {
  viewFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveFeedArgs = {
  liveFeedId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveSessionArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryLiveSessionsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  eventPageId?: InputMaybe<Scalars['ObjectId']['input']>;
  orderBy?: InputMaybe<OrderByLiveSessionsInput>;
  pagination: PaginationInput;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryMarketplaceArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceApplicantChatGroupsCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceApplicantCountriesArgs = {
  createdAfter?: InputMaybe<Scalars['IsoDateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['IsoDateTime']['input']>;
  degreeCategoryFilter?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug: Scalars['String']['input'];
};


export type QueryMarketplaceApplicantDegreeCategoriesArgs = {
  countryFilter?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['IsoDateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['IsoDateTime']['input']>;
  marketplaceSlug: Scalars['String']['input'];
};


export type QueryMarketplaceApplicantsCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceInboxArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorCountriesArgs = {
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorDegreeCategoriesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryRank?: InputMaybe<Scalars['Int']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  parentDegreeCategory?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorListArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySeed?: InputMaybe<Scalars['Int']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorRegionsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorUniversitiesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplacesArgs = {
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketplacesCountArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceSnippetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUniversitiesSlugsArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUniversityCountriesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUnreadMessageCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorApplicantChatGroupCountArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMentorApplicantChatGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMentorCountArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorEngagementMetricsArgs = {
  id: Scalars['String']['input'];
};


export type QueryMentorInboxArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
};


export type QueryMentorInterestsArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorIntroMessageArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorInviteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorInviteCountArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorListArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  filterIncompleteProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorModulesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorPostsArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorResponseTimeArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorSocietiesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorTimeSpentArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagesArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offsetId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyAgendaArgs = {
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  filterBySavedSessions?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  rangeDate?: InputMaybe<RangeDateInput>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryMyLiveEventDirectMessagingArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyLiveEventFeedsArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyUniversityDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyUniversityLinkArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDayArgs = {
  openDayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDaysArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDaysWithViewFilterArgs = {
  viewFilter: Scalars['String']['input'];
};


export type QueryOrganisationArgs = {
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  organisationType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutboxArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageMentorsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaginatedApplicantInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  universityId: Scalars['String']['input'];
};


export type QueryPopularSessionArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectChatSummaryArgs = {
  prospectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectChatSummaryV2Args = {
  prospectId: Scalars['String']['input'];
};


export type QueryProspectStageStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPublicLiveEventsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicMentorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicMentorIntroMessageArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicStaffCountArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryRecordingArgs = {
  data: QueryRecordingArgs;
};


export type QueryQueryUniversityIndexingArgs = {
  UniversityScrapeIndexingQueryInput: UniversityScrapeIndexingQueryInput;
};


export type QueryRandomBuddyArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRandomDefaultQuestionsArgs = {
  limit: Scalars['LimitedInt']['input'];
  mentor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRandomMentorArgs = {
  degreeId?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  sameCountryAsUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug: Scalars['String']['input'];
};


export type QueryRandomMentorsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  universitySlug: Scalars['String']['input'];
};


export type QueryRequestedPublicGroupsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryResearchTimeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResearchTimeLogArgs = {
  fromTime?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUniversityKnowledgeBaseArgs = {
  limit: Scalars['Float']['input'];
  searchTerm: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type QuerySequenceFilterMentorListArgs = {
  ambassadorSearch?: InputMaybe<Scalars['String']['input']>;
  applyDegreeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  degreeTypesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  domesticOrInternational?: InputMaybe<DomesticOrInternational>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderByCriteria?: InputMaybe<Array<InputMaybe<Array<InputMaybe<MentorOrderCriteria>>>>>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  sequenceFilter?: InputMaybe<Array<InputMaybe<MentorFilterInputField>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySharableConversationLinkArgs = {
  conversationMetaData: ConversationMetaDataDto;
};


export type QuerySignupsOverTimeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySingleInstanceOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaffContactByUniversityIdArgs = {
  staffContactByUniversityIdInput: StaffContactByUniversityIdInput;
};


export type QuerySubTopicsArgs = {
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTimeTakenArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopDegreesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopDomesticRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopicArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicStatisticsArgs = {
  dateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTopSignupsByCountryArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopSignupsByDegreeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopSignupsByStateArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTotalSignupsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTriggerDegreeExportArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerMentorExportArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  timeSpentFromDate?: InputMaybe<Scalars['String']['input']>;
  timeSpentToDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerProspectExportEmailArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTriggerReportExportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  openDayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerTopicStatisticsExportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryUniApplicantSignUpsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniApplicantSignUpsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniChatGroupsArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniChatGroupsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniConversionRateArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniConversionRateBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniMessagesArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniMessagesPerChatGroupArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniResponseTimeArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniResponseTimeBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesPerChatGroupArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesPerChatGroupBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniTimeSpentArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniTimeSpentBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniUniqueVisitsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniUniqueVisitsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityAlertsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityBlockReportsArgs = {
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<ResolvedEnum>;
  triggeredFrom?: InputMaybe<TriggeredFromEnum>;
};


export type QueryUniversityBlockReportsCountArgs = {
  resolved?: InputMaybe<ResolvedEnum>;
  triggeredFrom?: InputMaybe<TriggeredFromEnum>;
};


export type QueryUniversityBlogPostsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUniversityBlogPostsCountArgs = {
  status?: InputMaybe<BlogStatus>;
};


export type QueryUniversityInboxArgs = {
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUniversityMentorArgs = {
  id: Scalars['String']['input'];
};


export type QueryUniversityQuestionByIdArgs = {
  universityQuestionByIdInput: UniversityQuestionByIdInput;
};


export type QueryUniversityQuestionsArgs = {
  universityQuestionInput: UniversityQuestionInput;
};


export type QueryUniversitySnippetsArgs = {
  popCardAlign?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityUsersArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingExternalEventsArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingLiveEventsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserChatGroupsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPartialSearchArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPartialSearchMultipleFieldsArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTimeSpentBreakdownArgs = {
  fromTime?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifyCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVirtualEventArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventAttendeesArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventProspectReportArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  pagination: PaginationInput;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  universityId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventsByUniversityIdsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  pagination: PaginationInput;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  universityIds: Array<Scalars['ObjectId']['input']>;
};

export type QueryRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type QueryRecordingResponse = {
  __typename?: 'QueryRecordingResponse';
  recording?: Maybe<RecordingModel>;
};

export type QuestionField = {
  __typename?: 'QuestionField';
  questionId?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type RandomMentorsListField = {
  __typename?: 'RandomMentorsListField';
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
};

export type RangeDateInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Reaction = {
  __typename?: 'Reaction';
  reaction: Scalars['String']['output'];
  reactionUnicode: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
};

export type ReactionDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  reaction: Scalars['String']['input'];
  reactionUnicode: Scalars['String']['input'];
};

export type ReadChatMutation = {
  __typename?: 'ReadChatMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  batchId: Scalars['ObjectId']['output'];
  contentId: Scalars['ObjectId']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  source: RecommendationSource;
  title: Scalars['String']['output'];
  type: RecommendationResourceTypeEnum;
  url: Scalars['String']['output'];
};

export type RecommendationResourceType = {
  __typename?: 'RecommendationResourceType';
  displayName: Scalars['String']['output'];
  name: RecommendationResourceTypeEnum;
};

export enum RecommendationResourceTypeEnum {
  Ambassador = 'AMBASSADOR',
  Article = 'ARTICLE',
  Blog = 'BLOG',
  Community = 'COMMUNITY',
  Event = 'EVENT',
  InPersonEvent = 'IN_PERSON_EVENT',
  Newsletter = 'NEWSLETTER',
  Other = 'OTHER',
  UniversityWebpage = 'UNIVERSITY_WEBPAGE',
  Video = 'VIDEO'
}

export enum RecommendationSource {
  Admin = 'ADMIN',
  ApiRandom = 'API_RANDOM'
}

export type RecordingConsent = {
  __typename?: 'RecordingConsent';
  channelId: Scalars['ObjectId']['output'];
  id: Scalars['ObjectId']['output'];
  time: Scalars['DateTime']['output'];
  universityId: Scalars['ObjectId']['output'];
};

export type RecordingDownloadResponse = {
  __typename?: 'RecordingDownloadResponse';
  url: Scalars['String']['output'];
};

export type RecordingFailureArgs = {
  channelId: Scalars['ObjectId']['input'];
  eventId: Scalars['ObjectId']['input'];
};

export type RecordingFailureId = {
  __typename?: 'RecordingFailureId';
  id: Scalars['ObjectId']['output'];
};

export type RecordingFailureResponse = {
  __typename?: 'RecordingFailureResponse';
  success: Scalars['Boolean']['output'];
};

export type RecordingListResponse = {
  __typename?: 'RecordingListResponse';
  files: Array<VideoFile>;
};

export type RecordingModel = {
  __typename?: 'RecordingModel';
  channelId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  layoutMode: Scalars['Float']['output'];
  layoutStatus: Scalars['String']['output'];
  recordingStatus: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type RecordingResponse = {
  __typename?: 'RecordingResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecordingUploadingResponse = {
  __typename?: 'RecordingUploadingResponse';
  count: Scalars['Float']['output'];
};

export type RecordUserActivityMutation = {
  __typename?: 'RecordUserActivityMutation';
  newActivity?: Maybe<ActivityField>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type RegisterToLiveEvent = {
  __typename?: 'RegisterToLiveEvent';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectRequestedPublicGroupInput = {
  id: Scalars['String']['input'];
};

export type RemoveApplicantInsightInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type RemoveBuddyInvitesMutation = {
  __typename?: 'RemoveBuddyInvitesMutation';
  successfulInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
};

export type RemoveDeviceMutation = {
  __typename?: 'RemoveDeviceMutation';
  result?: Maybe<Scalars['String']['output']>;
};

export type RemoveMembersFromCommunityInputDto = {
  communityId: Scalars['String']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds: Array<Scalars['String']['input']>;
};

export type RemoveMentorInvitesMutation = {
  __typename?: 'RemoveMentorInvitesMutation';
  mentorInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
};

export type ReplyInputField = {
  messageCreated?: InputMaybe<Scalars['DateTime']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  senderAccountRole?: InputMaybe<Scalars['String']['input']>;
  senderFirstName?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type ReplyMessage = {
  __typename?: 'ReplyMessage';
  id: Scalars['ObjectId']['output'];
};

export type ReplyMessageDto = {
  id: Scalars['ObjectId']['input'];
};

export type ReplyOutputField = {
  __typename?: 'ReplyOutputField';
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  messageCreated?: Maybe<Scalars['DateTime']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  originalMessageText?: Maybe<Scalars['String']['output']>;
  senderAccountRole?: Maybe<Scalars['String']['output']>;
  senderFirstName?: Maybe<Scalars['String']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
};

export type ReportAnalytics = {
  __typename?: 'ReportAnalytics';
  id: Scalars['ObjectId']['output'];
  reportLink?: Maybe<Scalars['String']['output']>;
  reportStatus: Scalars['String']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type RequestAnalyticsExportMutation = {
  __typename?: 'RequestAnalyticsExportMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type RequestedPublicGroup = {
  __typename?: 'RequestedPublicGroup';
  community: Community;
  conversation: ChatConversation;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestedBy: UserField;
  resolvedBy: UserField;
  status: PublicGroupStatus;
  title: Scalars['String']['output'];
};

export type RequestPasswordResetMutation = {
  __typename?: 'RequestPasswordResetMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestPasswordSetMutation = {
  __typename?: 'RequestPasswordSetMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestToChangeEmailAddressMutation = {
  __typename?: 'RequestToChangeEmailAddressMutation';
  success: Scalars['Boolean']['output'];
};

export type RequestToDeleteAccountMutation = {
  __typename?: 'RequestToDeleteAccountMutation';
  success: Scalars['Boolean']['output'];
};

export type ResearchTimeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  logDate?: InputMaybe<Scalars['String']['input']>;
  timeSpentSeconds?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchTimeLogResult = {
  __typename?: 'ResearchTimeLogResult';
  id?: Maybe<Scalars['Int']['output']>;
  timeSpentSeconds?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResearchTimeResult = {
  __typename?: 'ResearchTimeResult';
  description?: Maybe<Scalars['String']['output']>;
  logDate?: Maybe<Scalars['String']['output']>;
  timeSpentSeconds?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordMobileMutation = {
  __typename?: 'ResetPasswordMobileMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordMutationV2 = {
  __typename?: 'ResetPasswordMutationV2';
  error?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ResolvedEnum {
  All = 'ALL',
  False = 'FALSE',
  True = 'TRUE'
}

export type ResolveMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type ResolveUniversityChatsMutation = {
  __typename?: 'ResolveUniversityChatsMutation';
  count?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
};

export type RichContentDto = {
  attachments?: InputMaybe<Array<AttachmentDto>>;
  giphy?: InputMaybe<GifDto>;
  images?: InputMaybe<Array<ImageDto>>;
  poll?: InputMaybe<PollDto>;
  reply?: InputMaybe<ReplyMessageDto>;
};

export type RichContentInputField = {
  reply?: InputMaybe<ReplyInputField>;
};

export type RichContentOutputField = {
  __typename?: 'RichContentOutputField';
  reply?: Maybe<ReplyOutputField>;
};

export type RichMessageContent = {
  __typename?: 'RichMessageContent';
  attachments?: Maybe<Array<Attachment>>;
  dynamicMessage?: Maybe<DynamicMessageTemplate>;
  giphy?: Maybe<Giphy>;
  images?: Maybe<Array<Image>>;
  poll?: Maybe<Poll>;
  reply?: Maybe<ChatMessage>;
  systemMessages?: Maybe<Array<SystemMessage>>;
};

export enum RootUrlEnum {
  AbraUrl = 'ABRA_URL',
  AmbassadorDashboardUrl = 'AMBASSADOR_DASHBOARD_URL',
  CommunityUrl = 'COMMUNITY_URL',
  HorseaUrl = 'HORSEA_URL',
  OnixUrl = 'ONIX_URL',
  RapidashUrl = 'RAPIDASH_URL'
}

export type RunManageCommandMutation = {
  __typename?: 'RunManageCommandMutation';
  output?: Maybe<OutputField>;
};

export type SatisfactionSurveyDto = {
  communityId: Scalars['String']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  universitySlug: Scalars['String']['input'];
};

export type SatisfactionSurveyEntity = {
  __typename?: 'SatisfactionSurveyEntity';
  communityId: Scalars['String']['output'];
  universitySlug: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SaveAppliedUsersInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
  userIds: Array<Scalars['ObjectId']['input']>;
};

export type SaveAppliedUsersModel = {
  __typename?: 'SaveAppliedUsersModel';
  saved: Scalars['Boolean']['output'];
};

export type SaveAssistantConversationEmailLeadInput = {
  conversationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  ubConsent: Scalars['Boolean']['input'];
  universityId: Scalars['String']['input'];
};

export type SaveAssistantConversationFeedbackInput = {
  /** The conversation to rate */
  conversationId: Scalars['String']['input'];
  /** Rating from 1-5 on the quality of the conversation */
  rating: Scalars['Float']['input'];
  /** Optional free text for the conversation feedback */
  text?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type SaveUniversityQuestionAnswerInput = {
  answers: Array<UniversityQuestionAnswerInputItem>;
  context: UniversityQuestionContextInput;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type SaveVisitedRecommendationInput = {
  batchId: Scalars['ObjectId']['input'];
  contentId: Scalars['ObjectId']['input'];
};

export enum ScraperJobStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Started = 'STARTED',
  Stopped = 'STOPPED'
}

export enum ScraperTaskStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Skipped = 'SKIPPED',
  Started = 'STARTED'
}

/** Defines scope for the starting point scrape */
export enum ScrapeScope {
  ScopeFull = 'SCOPE_FULL',
  ScopePartial = 'SCOPE_PARTIAL'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SendAssistantMessageInput = {
  conversationId: Scalars['String']['input'];
  input: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type SendCommunityVerificationCode = {
  __typename?: 'SendCommunityVerificationCode';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum SenderRole {
  Assistant = 'ASSISTANT',
  Function = 'FUNCTION',
  System = 'SYSTEM',
  Tool = 'TOOL',
  User = 'USER'
}

export type SendFeedMessageMutation = {
  __typename?: 'SendFeedMessageMutation';
  message?: Maybe<MessageField>;
};

export type SendLiveEventMessageMutation = {
  __typename?: 'SendLiveEventMessageMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  message?: Maybe<MessageField>;
};

export type SendMessageMutation = {
  __typename?: 'SendMessageMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  message?: Maybe<MessageField>;
};

export type SendOpenDayProspectReport = {
  __typename?: 'SendOpenDayProspectReport';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendResetPasswordEmail = {
  __typename?: 'SendResetPasswordEmail';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendVerificationCode = {
  __typename?: 'SendVerificationCode';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SequenceFilterMentorListField = {
  __typename?: 'SequenceFilterMentorListField';
  countries?: Maybe<Array<Maybe<CountryField>>>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  filters?: Maybe<Array<Maybe<MentorFilterField>>>;
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  mentorSeed?: Maybe<Scalars['Int']['output']>;
  validCombination?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionAnalytics = {
  __typename?: 'SessionAnalytics';
  id: Scalars['ObjectId']['output'];
  liveSessionId: Scalars['ObjectId']['output'];
  session?: Maybe<LiveSession>;
  sessionAttendees: SessionAttendees;
  sessionMessagesSent: Scalars['Float']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type SessionAttendeeAnalytics = {
  __typename?: 'SessionAttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  liveSessionId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type SessionAttendeeData = {
  accountRole: Scalars['String']['input'];
  liveSessionId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type SessionAttendees = {
  __typename?: 'SessionAttendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type SessionData = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  /** the name of the event */
  name: Scalars['String']['input'];
  presenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  savedByUserIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  sessionImageUrl: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type SetActiveBlogTopicsMutation = {
  __typename?: 'SetActiveBlogTopicsMutation';
  blogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
};

export type SetAllNotificationsReadMutation = {
  __typename?: 'SetAllNotificationsReadMutation';
  notifications?: Maybe<Array<Maybe<NotificationField>>>;
};

export type SetArchivedContentBriefMutation = {
  __typename?: 'SetArchivedContentBriefMutation';
  contentBrief?: Maybe<ContentBriefField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SetArchivedDegreeLevelMutation = {
  __typename?: 'SetArchivedDegreeLevelMutation';
  degreeLevel?: Maybe<DegreeLevelField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SetArchivedYearOfStudyMutation = {
  __typename?: 'SetArchivedYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
  yearOfStudy?: Maybe<YearOfStudyField>;
};

export type SetBuddiesListFilters = {
  __typename?: 'SetBuddiesListFilters';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetChatGroupLabelsMutation = {
  __typename?: 'SetChatGroupLabelsMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type SetDeviceTokenDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken: Scalars['String']['input'];
  system: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SetMentorFieldLabelMutation = {
  __typename?: 'SetMentorFieldLabelMutation';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetMentorFieldOrderMutation = {
  __typename?: 'SetMentorFieldOrderMutation';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetMentorListFilterSelection = {
  __typename?: 'SetMentorListFilterSelection';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetOnlineMutation = {
  __typename?: 'SetOnlineMutation';
  online?: Maybe<Scalars['Boolean']['output']>;
};

export type SetResolveChatGroupMutation = {
  __typename?: 'SetResolveChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type SettingsDto = {
  allowDirectChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowExternalEventsIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  allowGifs?: InputMaybe<Scalars['Boolean']['input']>;
  allowImages?: InputMaybe<Scalars['Boolean']['input']>;
  allowNewsFeed?: InputMaybe<Scalars['Boolean']['input']>;
  allowPrivateGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsObjectType = {
  __typename?: 'SettingsObjectType';
  allowDirectChat: Scalars['Boolean']['output'];
  allowExternalEventsIntegration: Scalars['Boolean']['output'];
  allowGifs?: Maybe<Scalars['Boolean']['output']>;
  allowImages: Scalars['Boolean']['output'];
  allowNewsFeed: Scalars['Boolean']['output'];
  allowPrivateGroups: Scalars['Boolean']['output'];
};

export type SetUserInterestsInput = {
  interestIds: Array<Scalars['String']['input']>;
};

export type SetWillReplyMutation = {
  __typename?: 'SetWillReplyMutation';
  chatGroupAux?: Maybe<ChatGroupAuxiliaryField>;
};

export type ShowMentorInMarketplaceMutation = {
  __typename?: 'ShowMentorInMarketplaceMutation';
  mentor?: Maybe<MentorField>;
};

export type SignedS3PostFields = {
  __typename?: 'SignedS3POSTFields';
  fields?: Maybe<PostFields>;
  fileName?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SignedS3UrlField = {
  __typename?: 'SignedS3URLField';
  mediaUrl?: Maybe<Scalars['String']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type SignUpsCount = {
  __typename?: 'SignUpsCount';
  totalSignups?: Maybe<Scalars['Int']['output']>;
};

export type SingleChoiceAttributeField = CustomAttributeField & {
  __typename?: 'SingleChoiceAttributeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SingleChoiceValueField = CustomAttributeValueField & {
  __typename?: 'SingleChoiceValueField';
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  option?: Maybe<CustomAttributeOptionField>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SourceInputField = {
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SourceMetadataField = {
  data?: InputMaybe<Scalars['JSONString']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SourceTrackingParamsField = {
  __typename?: 'SourceTrackingParamsField';
  ubCampaign?: Maybe<Scalars['String']['output']>;
  ubContent?: Maybe<Scalars['String']['output']>;
  ubMedium?: Maybe<Scalars['String']['output']>;
  ubSource?: Maybe<Scalars['String']['output']>;
};

export type StaffBuddycardSnippetField = {
  __typename?: 'StaffBuddycardSnippetField';
  departmentSnippet?: Maybe<Array<Maybe<DepartmentSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type StaffChatUserField = ChatUserField & {
  __typename?: 'StaffChatUserField';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffFieldsChatUserField>;
};


export type StaffChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffContactByUniversityIdInput = {
  universityId: Scalars['String']['input'];
};

export type StaffContactInput = {
  contact: Scalars['String']['input'];
  description: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type StaffContactOutput = {
  __typename?: 'StaffContactOutput';
  contact: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffField = {
  __typename?: 'StaffField';
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
};


export type StaffFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffFieldsChatUserField = {
  __typename?: 'StaffFieldsChatUserField';
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffPopcardSnippetField = {
  __typename?: 'StaffPopcardSnippetField';
  departmentSnippet?: Maybe<Array<Maybe<DepartmentSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type StaffProfileInformation = {
  __typename?: 'StaffProfileInformation';
  accountRole: Buddies;
  bio: Scalars['String']['output'];
  department: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  role: Scalars['String']['output'];
  universityId?: Maybe<Scalars['String']['output']>;
};

export type StaffUserField = {
  __typename?: 'StaffUserField';
  bio?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffUserFieldsField = {
  __typename?: 'StaffUserFieldsField';
  bio?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffUserListField = {
  __typename?: 'StaffUserListField';
  count?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<StaffField>>>;
};

export type StartRecordingArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type StateStatField = {
  __typename?: 'StateStatField';
  count?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StopRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type SubTopicField = {
  __typename?: 'SubTopicField';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<TopicField>;
};

export type SubTopicStatField = {
  __typename?: 'SubTopicStatField';
  messageCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type SubTopicStatisticField = {
  __typename?: 'SubTopicStatisticField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SuggestionField = {
  __typename?: 'SuggestionField';
  canonicalQuestions?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  topSubTopic?: Maybe<TopSubTopicField>;
  topSubTopics?: Maybe<Array<Maybe<TopSubTopicField>>>;
};

export type SwitchUniversitiesField = {
  __typename?: 'SwitchUniversitiesField';
  universities?: Maybe<Array<Maybe<SwitchUniversityListField>>>;
};

export type SwitchUniversityField = {
  __typename?: 'SwitchUniversityField';
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  whiteLogo?: Maybe<Scalars['String']['output']>;
};

export type SwitchUniversityListField = {
  __typename?: 'SwitchUniversityListField';
  university?: Maybe<SwitchUniversityField>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type SystemMessage = {
  __typename?: 'SystemMessage';
  createdAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  messageType: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sender: Scalars['String']['output'];
};

export type Tag = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TagField = {
  __typename?: 'TagField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TargetAudienceDto = {
  id: Scalars['String']['input'];
  type: TodoTargetAudienceType;
};

export type TemplateDataUnion = TransferredChatAmboSide | TransferredChatIntroMessage | TransferredChatProspectSide;

export type TextInLocale = {
  __typename?: 'TextInLocale';
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TextInLocaleInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTakenField = {
  __typename?: 'TimeTakenField';
  totalTime?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum TodoAction {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE'
}

export type TodosEntity = {
  __typename?: 'TodosEntity';
  createdBy: Scalars['String']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  status: TodoStatus;
  targetAudience: Array<TodoTargetAudience>;
  title: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
};

export enum TodoStatus {
  Deleted = 'deleted',
  Published = 'published',
  Unpublished = 'unpublished'
}

export type TodoTargetAudience = Community | Region;

export enum TodoTargetAudienceType {
  Community = 'community',
  Region = 'region'
}

export type ToggleCrmIntegrationSync = {
  __typename?: 'ToggleCrmIntegrationSync';
  integration?: Maybe<CrmIntegrationField>;
};

export type ToggleCustomAttributeCrmSyncMutation = {
  __typename?: 'ToggleCustomAttributeCrmSyncMutation';
  customAttributeNewSyncStatus?: Maybe<CrmFieldSyncStatus>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ToggleDegreesActiveMutation = {
  __typename?: 'ToggleDegreesActiveMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type ToggleFeatureAvailabilityMutation = {
  __typename?: 'ToggleFeatureAvailabilityMutation';
  university?: Maybe<UniversityField>;
};

export type ToolCall = {
  __typename?: 'ToolCall';
  function: ToolCallFunction;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ToolCallFunction = {
  __typename?: 'ToolCallFunction';
  arguments: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TopCountryField = {
  __typename?: 'TopCountryField';
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type TopDegreeField = {
  __typename?: 'TopDegreeField';
  count?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
};

export type TopDomesticRegionField = {
  __typename?: 'TopDomesticRegionField';
  count?: Maybe<Scalars['Int']['output']>;
  domesticRegion?: Maybe<Scalars['String']['output']>;
};

export type TopicField = {
  __typename?: 'TopicField';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicField>>>;
};

export type TopicSnippetField = {
  __typename?: 'TopicSnippetField';
  snippet?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<BlogTopicField>;
};

export type TopicsStatField = {
  __typename?: 'TopicsStatField';
  messageCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicStatField>>>;
};

export type TopicStatisticField = {
  __typename?: 'TopicStatisticField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicStatisticField>>>;
};

export type TopRegionField = {
  __typename?: 'TopRegionField';
  count?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type TopSubTopicField = {
  __typename?: 'TopSubTopicField';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  topic?: Maybe<TopTopicField>;
};

export type TopTopicField = {
  __typename?: 'TopTopicField';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
};

export type TrackLiveEventMutation = {
  __typename?: 'TrackLiveEventMutation';
  liveEvent?: Maybe<LiveEventField>;
};

export type TrackOpenDayMutation = {
  __typename?: 'TrackOpenDayMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TransferApplicantChat = {
  __typename?: 'TransferApplicantChat';
  chatGroup?: Maybe<ChatGroupField>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
};

export type TransferredChatAmboSide = {
  __typename?: 'TransferredChatAmboSide';
  prospect?: Maybe<UserField>;
};

export type TransferredChatIntroMessage = {
  __typename?: 'TransferredChatIntroMessage';
  ambassador?: Maybe<UserField>;
};

export type TransferredChatProspectSide = {
  __typename?: 'TransferredChatProspectSide';
  ambassador?: Maybe<UserField>;
  conversation?: Maybe<ChatConversation>;
};

export type TransferTarget = {
  entityId: Scalars['String']['input'];
  entityType: TransferTargetType;
};

export type TransferTargetDto = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum TransferTargetType {
  University = 'UNIVERSITY',
  User = 'USER'
}

export type TrendingTopicsField = {
  __typename?: 'TrendingTopicsField';
  aggregatedCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<TopicsStatField>>>;
};

export enum TriggeredFromEnum {
  All = 'ALL',
  Chat = 'CHAT',
  Community = 'COMMUNITY'
}

export type UniversityAssistantConfiguration = {
  __typename?: 'UniversityAssistantConfiguration';
  /** university event url */
  eventUrls?: Maybe<Array<UniversityAssistantConfigurationEventUrls>>;
  /** Extra context to be added to prompt */
  promptContext?: Maybe<Scalars['String']['output']>;
  /** university scrape urls to ignore */
  scrapeIgnoreUrls?: Maybe<Array<UniversityAssistantScrapeIgnoreUrls>>;
  /** university scrape starting point scope */
  scrapeScope?: Maybe<ScrapeScope>;
  /** university scrape starting point */
  scrapeStartingPoint?: Maybe<Scalars['String']['output']>;
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationEventInput = {
  /** A description of the url */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A universityId */
  universityId: Scalars['String']['input'];
  /** A url to a universities event page */
  url: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationEventOutput = {
  __typename?: 'UniversityAssistantConfigurationEventOutput';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** A universityId */
  universityId: Scalars['String']['output'];
  /** A url to a universities event page */
  url: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationEventUrls = {
  __typename?: 'UniversityAssistantConfigurationEventUrls';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** A url to a universities event page */
  url: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationPromptContextInput = {
  /** Extra context to be added to prompt */
  promptContext: Scalars['String']['input'];
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationPromptContextOutput = {
  __typename?: 'UniversityAssistantConfigurationPromptContextOutput';
  /** Extra context to be added to prompt */
  promptContext: Scalars['String']['output'];
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationScrapeIgnoreUrlsInput = {
  /** Scrape ignore urls */
  scrapeIgnoreUrls: Array<UniversityAssistantScrapeIgnoreUrlsInput>;
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationScrapeIgnoreUrlsOutput = {
  __typename?: 'UniversityAssistantConfigurationScrapeIgnoreUrlsOutput';
  /** Scrape ignore urls */
  scrapeIgnoreUrls: Array<UniversityAssistantScrapeIgnoreUrls>;
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationScrapeStartPointInput = {
  /** A description of the url */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Scrape starting point scope */
  scrapeScope?: InputMaybe<ScrapeScope>;
  /** Scrape starting point */
  scrapeStartingPoint: Scalars['String']['input'];
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationScrapeStartPointOutput = {
  __typename?: 'UniversityAssistantConfigurationScrapeStartPointOutput';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** university scrape starting point scope */
  scrapeScope?: Maybe<ScrapeScope>;
  /** Scrape starting point */
  scrapeStartingPoint: Scalars['String']['output'];
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConversation = {
  __typename?: 'UniversityAssistantConversation';
  conversationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UniversityAssistantScrapeIgnoreUrls = {
  __typename?: 'UniversityAssistantScrapeIgnoreUrls';
  /** A boolean to determine whether to ignore subpages of an ignored url */
  ignoreSubpages: Scalars['Boolean']['output'];
  /** A url to ignore when scraping a university website */
  url: Scalars['String']['output'];
};

export type UniversityAssistantScrapeIgnoreUrlsInput = {
  /** A boolean to determine whether to ignore subpages of an ignored url */
  ignoreSubpages: Scalars['Boolean']['input'];
  /** A url to ignore when scraping a university website */
  url: Scalars['String']['input'];
};

export type UniversityBlockReportField = {
  __typename?: 'UniversityBlockReportField';
  blocked?: Maybe<ApplicantField>;
  blocker?: Maybe<AnyUserField>;
  chatGroup?: Maybe<ChatGroupField>;
  comment?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<ChatConversation>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  triggeredFrom?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type UniversityBlockUsersMutation = {
  __typename?: 'UniversityBlockUsersMutation';
  count?: Maybe<Scalars['String']['output']>;
};

export type UniversityBlogPostsField = {
  __typename?: 'UniversityBlogPostsField';
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  blogPosts?: Maybe<Array<Maybe<BlogPostField>>>;
};

export type UniversityChatInboxField = InboxItemInterface & {
  __typename?: 'UniversityChatInboxField';
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  university?: Maybe<InboxUniversityField>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type UniversityConfigField = {
  __typename?: 'UniversityConfigField';
  features?: Maybe<Array<Maybe<UniversityFeatureField>>>;
  featuresWithUniversityControl?: Maybe<Array<Maybe<UniversityFeatureField>>>;
};

export type UniversityContent = {
  __typename?: 'UniversityContent';
  hasContent: Scalars['Boolean']['output'];
};

export type UniversityContentInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type UniversityFeatureField = {
  __typename?: 'UniversityFeatureField';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enabledByUnibuddy?: Maybe<Scalars['Boolean']['output']>;
  enabledByUniversity?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<FeatureField>;
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  universityCanToggleFeature?: Maybe<Scalars['Boolean']['output']>;
};

export type UniversityField = {
  __typename?: 'UniversityField';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowWelcomeMessageCustomization?: Maybe<Scalars['Boolean']['output']>;
  allowWelcomeMessageCustomizationStaff?: Maybe<Scalars['Boolean']['output']>;
  buddiesListFilters?: Maybe<Array<Maybe<BuddiesListFilterField>>>;
  chatboxUrl?: Maybe<Scalars['String']['output']>;
  churned?: Maybe<Scalars['Boolean']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  config?: Maybe<UniversityConfigField>;
  country?: Maybe<CountryField>;
  customAttribute?: Maybe<CustomAttributeField>;
  customAttributeOptions?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeField>>>;
  customChatBubbleTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  customMarketingConsentText?: Maybe<Scalars['String']['output']>;
  customMarketingConsentTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  customPreSignupText?: Maybe<Scalars['String']['output']>;
  customPreSignupTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  defaultProspectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  defaultProspectWelcomeMessageStaff?: Maybe<Scalars['String']['output']>;
  degreeTypeOrder?: Maybe<Array<Maybe<DegreeTypeOrderField>>>;
  domesticRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  entries?: Maybe<EntriesField>;
  id?: Maybe<Scalars['String']['output']>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  isFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeatureReadOnly?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isReadyToLaunch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Removed because CRM sync toggle is on CRM graph */
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  launchDate?: Maybe<Scalars['String']['output']>;
  localePreference?: Maybe<Locale>;
  logo?: Maybe<Scalars['String']['output']>;
  marketplaces?: Maybe<Array<Maybe<UniversityMarketplaceField>>>;
  mentorFieldLabels?: Maybe<Array<Maybe<MentorFieldCustomLabel>>>;
  mentorFieldOrder?: Maybe<Array<Maybe<MentorFieldOrderField>>>;
  mentorListFilters?: Maybe<Array<Maybe<MentorListFilterChoice>>>;
  mentorMessagesCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  /** @deprecated Removed because unoptimized */
  onlineMentorAvatars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organisation?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whiteLogo?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
  widgetUrls?: Maybe<Array<Maybe<WidgetUrlField>>>;
};


export type UniversityFieldCustomAttributeArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldCustomAttributeOptionsArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldIsFeatureEnabledArgs = {
  feature?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldIsFeatureReadOnlyArgs = {
  feature?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldWidgetUrlsArgs = {
  selectedLocale?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityInboxField = {
  __typename?: 'UniversityInboxField';
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
};

export type UniversityInterestedDto = {
  name: Scalars['String']['input'];
};

export type UniversityInterestedEntity = {
  __typename?: 'UniversityInterestedEntity';
  name: Scalars['String']['output'];
};

export type UniversityMarketplaceField = {
  __typename?: 'UniversityMarketplaceField';
  allowProspectDataAccess?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  marketingOptInWording?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tncWording?: Maybe<Scalars['String']['output']>;
  universityMarketplaceId?: Maybe<Scalars['String']['output']>;
};

export type UniversityMarketplaceInput = {
  allowProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  marketingOptInWording?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  tncWording?: InputMaybe<Scalars['String']['input']>;
  universityMarketplaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityOutput = {
  __typename?: 'UniversityOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type UniversityQuestion = {
  __typename?: 'UniversityQuestion';
  active: Scalars['Boolean']['output'];
  answers: Array<UniversityQuestionAnswer>;
  contexts: Array<UniversityQuestionContext>;
  id: Scalars['ObjectId']['output'];
  isMultipleAnswersAllowed: Scalars['Boolean']['output'];
  options?: Maybe<Array<UniversityQuestionOption>>;
  text: Scalars['String']['output'];
  type: UniversityQuestionType;
};


export type UniversityQuestionAnswersArgs = {
  universityQuestionAnswerInput: UniversityQuestionAnswerInput;
};

export type UniversityQuestionAnswer = {
  __typename?: 'UniversityQuestionAnswer';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  context?: Maybe<UniversityQuestionContext>;
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type UniversityQuestionAnswerInput = {
  context: UniversityQuestionContextInput;
  universityId: Scalars['ObjectId']['input'];
};

export type UniversityQuestionAnswerInputItem = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  text: Scalars['String']['input'];
};

export type UniversityQuestionByIdInput = {
  context: UniversityQuestionContextInput;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityQuestionContext = {
  __typename?: 'UniversityQuestionContext';
  id?: Maybe<Scalars['ObjectId']['output']>;
  type: Scalars['String']['output'];
};

export type UniversityQuestionContextInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  type: Scalars['String']['input'];
};

export type UniversityQuestionInput = {
  context: UniversityQuestionContextInput;
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityQuestionOption = {
  __typename?: 'UniversityQuestionOption';
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export enum UniversityQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT'
}

export type UniversityScrapeIndexingOutput = {
  __typename?: 'UniversityScrapeIndexingOutput';
  createdAt: Scalars['DateTime']['output'];
  jobStatus: ScraperJobStatus;
  taskCompletedCount: Scalars['Float']['output'];
  taskInFlightCount: Scalars['Float']['output'];
  taskQueuedCount: Scalars['Float']['output'];
  tasks: Array<UniversityScrapeTask>;
  universityId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UniversityScrapeIndexingQueryInput = {
  httpStatus?: InputMaybe<Scalars['Float']['input']>;
  jobId: Scalars['String']['input'];
  requestDurationEquality?: InputMaybe<Scalars['String']['input']>;
  requestDurationMs?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortByDir?: InputMaybe<Scalars['String']['input']>;
  taskStatus?: InputMaybe<ScraperTaskStatus>;
  universityId: Scalars['String']['input'];
};

export type UniversityScrapeInput = {
  universityId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** For scraping a list of urls, will only visit the urls defined in the 'urls' field */
export type UniversityScrapeManualInput = {
  /** The universities home page */
  rootUrl: Scalars['String']['input'];
  /** id of the university */
  universityId: Scalars['String']['input'];
  /** List of urls to scrape */
  urls: Array<Scalars['String']['input']>;
};

export type UniversityScrapeOutput = {
  __typename?: 'UniversityScrapeOutput';
  created: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  jobStatus: ScraperJobStatus;
  rootUrl: Scalars['String']['output'];
  started: Scalars['Boolean']['output'];
  universityId: Scalars['String']['output'];
};

export type UniversityScrapeStopOutput = {
  __typename?: 'UniversityScrapeStopOutput';
  created: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  jobStatus: ScraperJobStatus;
  rootUrl: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
};

export type UniversityScrapeTask = {
  __typename?: 'UniversityScrapeTask';
  created: Scalars['DateTime']['output'];
  depth: Scalars['Float']['output'];
  error: Scalars['String']['output'];
  httpStatus: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  requestDurationMs: Scalars['Float']['output'];
  rootUrl: Scalars['String']['output'];
  taskStatus: ScraperTaskStatus;
  universityId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type UniversitySnippetField = {
  __typename?: 'UniversitySnippetField';
  blogcardSnippets?: Maybe<BlogcardSnippetField>;
  carouselWidgetSnippets?: Maybe<CarouselSnippetField>;
  courseWidgetSnippets?: Maybe<CourseSnippetField>;
  embeddedEventSnippet?: Maybe<EmbeddedEventSnippetField>;
  error?: Maybe<Scalars['String']['output']>;
  mentorcardExternalSnippets?: Maybe<MentorcardSnippetField>;
  mentorcardInternalSnippets?: Maybe<MentorcardSnippetField>;
  popcardSnippets?: Maybe<PopcardSnippetField>;
  staffBuddycardExternalSnippet?: Maybe<StaffBuddycardSnippetField>;
  staffBuddycardInternalSnippet?: Maybe<StaffBuddycardSnippetField>;
  staffPopcardSnippet?: Maybe<StaffPopcardSnippetField>;
  university?: Maybe<UniversityField>;
  widgetSnippet?: Maybe<WidgetSnippetField>;
};

export type UniversityStopCrawlInput = {
  jobId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type UniversityUserField = {
  __typename?: 'UniversityUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  id?: Maybe<Scalars['String']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UniversityUserPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type UniversityUserPreferencesField = {
  __typename?: 'UniversityUserPreferencesField';
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UnpinMessageDto = {
  conversationId: Scalars['String']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type UnpinMessageMutation = {
  __typename?: 'UnpinMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnreadCountField = {
  __typename?: 'UnreadCountField';
  count?: Maybe<Scalars['Int']['output']>;
};

export type UnreadMessageCountField = {
  __typename?: 'UnreadMessageCountField';
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateApplicantMutation = {
  __typename?: 'UpdateApplicantMutation';
  error?: Maybe<Scalars['String']['output']>;
  me?: Maybe<MeField>;
};

export type UpdateApplicantPreferencesMutation = {
  __typename?: 'UpdateApplicantPreferencesMutation';
  me?: Maybe<MeField>;
};

export type UpdateCanonicalQuestion = {
  __typename?: 'UpdateCanonicalQuestion';
  canonicalQuestion?: Maybe<CanonicalQuestionField>;
};

export type UpdateChatRoomInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCommunityApplicantSignupSourceMutation = {
  __typename?: 'UpdateCommunityApplicantSignupSourceMutation';
  me?: Maybe<MeField>;
};

export type UpdateDirectMessagingMembersForLiveEventMutation = {
  __typename?: 'UpdateDirectMessagingMembersForLiveEventMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type UpdatedResults = {
  __typename?: 'UpdatedResults';
  acknowledged: Scalars['Boolean']['output'];
  matchedCount: Scalars['Float']['output'];
  modifiedCount: Scalars['Float']['output'];
  upsertedCount: Scalars['Float']['output'];
  upsertedId: Scalars['String']['output'];
};

export type UpdateEventPageInput = {
  description: Scalars['String']['input'];
  /** the name of the page */
  name: Scalars['String']['input'];
  pageImageUrl: Scalars['String']['input'];
};

export type UpdateExternalContentInput = {
  description: Scalars['String']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  externalContentImageUrl: Scalars['String']['input'];
  externalContentUrl: Scalars['String']['input'];
  /** the name of the external content */
  name: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFaqAnswer = {
  __typename?: 'UpdateFaqAnswer';
  faqAnswer?: Maybe<FaqAnswerField>;
};

export type UpdateHobsonsConnectIntegration = {
  __typename?: 'UpdateHobsonsConnectIntegration';
  integration?: Maybe<CampusManagementConnectIntegrationField>;
};

export type UpdateIntegrationFieldMapping = {
  __typename?: 'UpdateIntegrationFieldMapping';
  integration?: Maybe<CrmIntegrationField>;
};

export type UpdateLiveEventFeedSessionDataMutation = {
  __typename?: 'UpdateLiveEventFeedSessionDataMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLiveSessionAnyUserInput = {
  addSavedByUserId?: InputMaybe<Scalars['ObjectId']['input']>;
  removeSavedByUserId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type UpdateLiveSessionInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  /** the name of the event */
  name: Scalars['String']['input'];
  presenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sessionImageUrl: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type UpdateManyUserMutation = {
  __typename?: 'UpdateManyUserMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMarketplaceApplicantMutation = {
  __typename?: 'UpdateMarketplaceApplicantMutation';
  me?: Maybe<MeField>;
};

export type UpdateMarketplaceApplicantUniversityLinkMutation = {
  __typename?: 'UpdateMarketplaceApplicantUniversityLinkMutation';
  me?: Maybe<MeField>;
};

export type UpdateMarketplaceMutation = {
  __typename?: 'UpdateMarketplaceMutation';
  marketplace?: Maybe<MarketplaceField>;
};

export type UpdateMentorMutation = {
  __typename?: 'UpdateMentorMutation';
  me?: Maybe<MeField>;
};

export type UpdateMentorPreferences = {
  __typename?: 'UpdateMentorPreferences';
  preferences?: Maybe<MentorPreferencesField>;
};

export type UpdateMyUniversityLinkMutation = {
  __typename?: 'UpdateMyUniversityLinkMutation';
  me?: Maybe<MeField>;
};

export type UpdateNotificationPreferenceInput = {
  /** Whether the notification is enabled. */
  enabled: Scalars['Boolean']['input'];
  /** The delivery method. */
  method: NotificationMethod;
  /** The unique slug for the preference. */
  preferenceSlug: Scalars['String']['input'];
};

export type UpdatePostStatusMutation = {
  __typename?: 'UpdatePostStatusMutation';
  blogPost?: Maybe<BlogPostField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type UpdateRecordingLayoutArgs = {
  channelId: Scalars['String']['input'];
  mode: Scalars['Int']['input'];
  screenShareUid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchTimeMutation = {
  __typename?: 'UpdateResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStaffContactInput = {
  contact: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type UpdateStaffMutation = {
  __typename?: 'UpdateStaffMutation';
  me?: Maybe<MeField>;
};

export type UpdateSubTopicMutation = {
  __typename?: 'UpdateSubTopicMutation';
  subTopic?: Maybe<SubTopicField>;
};

export type UpdateTagMutation = {
  __typename?: 'UpdateTagMutation';
  tag?: Maybe<TagField>;
};

export type UpdateTopicMutation = {
  __typename?: 'UpdateTopicMutation';
  topic?: Maybe<TopicField>;
};

export type UpdateUniversityBlockReportMutation = {
  __typename?: 'UpdateUniversityBlockReportMutation';
  universityBlockReport?: Maybe<UniversityBlockReportField>;
};

export type UpdateUniversityConfigMutation = {
  __typename?: 'UpdateUniversityConfigMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityConfiguration?: Maybe<CrmServiceUniversityConfig>;
};

export type UpdateUniversityUserMutation = {
  __typename?: 'UpdateUniversityUserMutation';
  error?: Maybe<Scalars['String']['output']>;
  me?: Maybe<MeField>;
};

export type UpdateUniversityUserPreferencesMutation = {
  __typename?: 'UpdateUniversityUserPreferencesMutation';
  me?: Maybe<MeField>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<UserField>;
};

export type UpdateUserPreferences = {
  __typename?: 'UpdateUserPreferences';
  preferences?: Maybe<UserPreferencesField>;
};

export type UpdateUserProfile = {
  areaOfStudy?: InputMaybe<Array<Scalars['String']['input']>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<Array<Scalars['String']['input']>>;
  housing?: InputMaybe<HousingInput>;
  interests?: InputMaybe<Array<InterestInput>>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVirtualEventInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  /** the name of the event */
  title: Scalars['String']['input'];
};

export type UserCustomAttributesFilterField = {
  __typename?: 'UserCustomAttributesFilterField';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserDecisionStageInput = {
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  decisionStageReason?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['ObjectId']['input'];
};

export type UserDecisionStageOutput = {
  __typename?: 'UserDecisionStageOutput';
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  decisionStageReason?: Maybe<Scalars['String']['output']>;
  notInterestedReason?: Maybe<NotInterestedReasonEnum>;
  userId: Scalars['ObjectId']['output'];
};

export type UserDegreeField = {
  __typename?: 'UserDegreeField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserDirectoryResult = {
  __typename?: 'UserDirectoryResult';
  result: Array<UserField>;
  totalUsers: Scalars['Float']['output'];
};

export type UserField = {
  __typename?: 'UserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blockedByMentors?: Maybe<Array<Maybe<BlockerField>>>;
  blockedByUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  communities?: Maybe<Array<Community>>;
  communityProfile?: Maybe<UserProfile>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  hasUnansweredConversation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests: Array<Interest>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  resolvedUnansweredConversations?: Maybe<Scalars['Boolean']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  smudged?: Maybe<Scalars['Boolean']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
  stageOneComplete?: Maybe<Scalars['Boolean']['output']>;
  stageTwoComplete?: Maybe<Scalars['Boolean']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};


export type UserFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserIdsListField = {
  __typename?: 'UserIdsListField';
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserInterest = {
  __typename?: 'UserInterest';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type UserListField = {
  __typename?: 'UserListField';
  count?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<UserField>>>;
};

export type UserLocalePreference = {
  __typename?: 'UserLocalePreference';
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserLocalePreferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotInterestedStageInput = {
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  decisionStageReason?: InputMaybe<Scalars['String']['input']>;
  notInterestedReason: NotInterestedReasonEnum;
  universityId: Scalars['ObjectId']['input'];
};

export type UserPartialSearchFields = {
  __typename?: 'UserPartialSearchFields';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  concatenatedFields?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type UserPermissionsListField = {
  __typename?: 'UserPermissionsListField';
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserPreferencesField = {
  __typename?: 'UserPreferencesField';
  id?: Maybe<Scalars['String']['output']>;
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  areaOfStudy?: Maybe<Array<DegreeField>>;
  badges?: Maybe<Array<Scalars['String']['output']>>;
  bio?: Maybe<Scalars['String']['output']>;
  communities?: Maybe<Array<Scalars['String']['output']>>;
  housing?: Maybe<HousingObject>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<InterestObject>>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserRecommendation = {
  __typename?: 'UserRecommendation';
  currentUser: UserField;
  matches: Array<MatchedUser>;
  totalMatches: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UserReport = {
  __typename?: 'UserReport';
  actionTaken?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Community>;
  creationTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  moderationTime?: Maybe<Scalars['DateTime']['output']>;
  moderator?: Maybe<UserField>;
  moderatorComment?: Maybe<Scalars['String']['output']>;
  modificationTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  reportee: UserField;
  reporter: UserField;
  reporterComment: Scalars['String']['output'];
  reporterReason: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  university: UniversityField;
};

export type UserReportModeratorInputDto = {
  actionTaken?: InputMaybe<Scalars['String']['input']>;
  moderatorComment: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
  userReportId: Scalars['ObjectID']['input'];
};

export type UserReportUserInputDto = {
  communityId?: InputMaybe<Scalars['ObjectID']['input']>;
  product: Product;
  reporteeId: Scalars['ObjectID']['input'];
  reporterComment: Scalars['String']['input'];
  reporterReason: Scalars['String']['input'];
  universityId: Scalars['ObjectID']['input'];
};

export type UsersTimeSpentData = {
  __typename?: 'UsersTimeSpentData';
  userCount?: Maybe<Scalars['Int']['output']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userTimeStats?: Maybe<Array<Maybe<UserTimeSpentStatsField>>>;
};

export type UserTimeSheetExportField = {
  __typename?: 'UserTimeSheetExportField';
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type UserTimeSpentBreakdown = {
  __typename?: 'UserTimeSpentBreakdown';
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export type UserTimeSpentStatsField = {
  __typename?: 'UserTimeSpentStatsField';
  active?: Maybe<Scalars['Boolean']['output']>;
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<UserDegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fromTime?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
  toTime?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VerifyAccount = {
  __typename?: 'VerifyAccount';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyCodeField = {
  __typename?: 'VerifyCodeField';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoContent = {
  __typename?: 'VideoContent';
  id: Scalars['ID']['output'];
  status: VideoStatus;
  type: VideoTypeEnum;
  url: VideoUrl;
};

export type VideoFile = {
  __typename?: 'VideoFile';
  end?: Maybe<Scalars['DateTime']['output']>;
  fileIndex: Scalars['Float']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  recordingNumber: Scalars['Float']['output'];
  sid: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  splitNumber?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type VideoSession = {
  coverS3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type VideoSessionField = {
  __typename?: 'VideoSessionField';
  coverS3Url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type VideoSessionToUpdateField = {
  coverS3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum VideoStatus {
  Error = 'ERROR',
  PresignedUrlGenerated = 'PRESIGNED_URL_GENERATED',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export enum VideoTypeEnum {
  Short = 'SHORT'
}

export type VideoUploadLink = {
  __typename?: 'VideoUploadLink';
  fields: Array<VideoUploadPresignedFields>;
  id: Scalars['ID']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type VideoUploadLinkInput = {
  type: VideoTypeEnum;
  universityId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type VideoUploadPresignedFields = {
  __typename?: 'VideoUploadPresignedFields';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VideoUrl = {
  __typename?: 'VideoUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type ViewBlogMutation = {
  __typename?: 'ViewBlogMutation';
  post?: Maybe<BlogPostField>;
};

export type VirtualEvent = {
  __typename?: 'VirtualEvent';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ObjectId']['output'];
  imageUrl: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  /** the name of the event */
  title: Scalars['String']['output'];
  university: UniversityField;
};

export type WidgetConversationDto = {
  ambassadorId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type WidgetSnippetField = {
  __typename?: 'WidgetSnippetField';
  description?: Maybe<DescriptionField>;
  embeddedEventSnippet?: Maybe<EmbeddedEventSnippetField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type WidgetUrlField = {
  __typename?: 'WidgetUrlField';
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WidgetUrlsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WillReplyField = {
  __typename?: 'WillReplyField';
  created?: Maybe<Scalars['String']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  mobileAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type YearOfStudyField = {
  __typename?: 'YearOfStudyField';
  archived?: Maybe<Scalars['Boolean']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};

export type UniversityFullFragment = { __typename?: 'UniversityField', id?: string | null, name?: string | null, nickname?: string | null, slug?: string | null, logo?: string | null, squareLogo?: string | null, isEnterprise?: boolean | null, whiteLogo?: string | null, widgetUrl?: string | null, colour?: string | null, launchDate?: string | null, privacyPolicyUrl?: string | null, customMarketingConsentText?: string | null, customPreSignupText?: string | null, widgetUrls?: Array<{ __typename?: 'WidgetUrlField', locale?: string | null, name?: string | null, url?: string | null } | null> | null, customMarketingConsentTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customPreSignupTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customChatBubbleTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, entries?: { __typename?: 'EntriesField', active?: boolean | null, entryMonths?: Array<number | null> | null } | null, degreeTypeOrder?: Array<{ __typename?: 'DegreeTypeOrderField', type?: DegreeType | null, order?: number | null } | null> | null, mentorFieldOrder?: Array<{ __typename?: 'MentorFieldOrderField', field?: string | null, order?: number | null } | null> | null, mentorFieldLabels?: Array<{ __typename?: 'MentorFieldCustomLabel', key?: string | null, customLabel?: string | null } | null> | null, config?: { __typename?: 'UniversityConfigField', features?: Array<{ __typename?: 'UniversityFeatureField', enabled?: boolean | null, isReadOnly?: boolean | null, feature?: { __typename?: 'FeatureField', name?: string | null } | null } | null> | null } | null };

export type ProspectStageMutationMutationVariables = Exact<{
  universityId: Scalars['ObjectId']['input'];
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  decisionStageReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProspectStageMutationMutation = { __typename?: 'Mutation', saveUserDecisionStage: { __typename?: 'UserDecisionStageOutput', userId: any } };

export type CurrentUserDecisionStageQueryVariables = Exact<{
  universityId: Scalars['ObjectId']['input'];
}>;


export type CurrentUserDecisionStageQuery = { __typename?: 'Query', currentUserDecisionStage: { __typename?: 'CurrentDecisionStageOutput', decisionStage?: DecisionStageEnum | null, updated?: any | null } };

export type GetUniversityQuestionQueryQueryVariables = Exact<{
  universityQuestionInput: UniversityQuestionInput;
  universityQuestionAnswerInput: UniversityQuestionAnswerInput;
}>;


export type GetUniversityQuestionQueryQuery = { __typename?: 'Query', universityQuestions: Array<{ __typename?: 'UniversityQuestion', id: any, text: string, active: boolean, type: UniversityQuestionType, options?: Array<{ __typename?: 'UniversityQuestionOption', id: any, text: string, active: boolean }> | null, answers: Array<{ __typename?: 'UniversityQuestionAnswer', text: string, id: any, answeredAt?: any | null }> }> };

export type AnswerUniversityQuestionMutationMutationVariables = Exact<{
  saveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
}>;


export type AnswerUniversityQuestionMutationMutation = { __typename?: 'Mutation', saveUniversityQuestionAnswer: Array<{ __typename?: 'UniversityQuestionAnswer', id: any, text: string }> };

export type GetChatConversationIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetChatConversationIdQueryQuery = { __typename?: 'Query', getChatConversation: { __typename?: 'ChatConversation', id: string, sourceId?: string | null } };

export type GetChatConversationFromLegacyIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetChatConversationFromLegacyIdQueryQuery = { __typename?: 'Query', getChatConversationFromLegacyId?: { __typename?: 'ChatConversation', id: string, sourceId?: string | null } | null };

export type GetOrCreateWidgetConversationMutationVariables = Exact<{
  widgetConversationDto: WidgetConversationDto;
}>;


export type GetOrCreateWidgetConversationMutation = { __typename?: 'Mutation', getOrCreateWidgetConversation: { __typename?: 'ChatConversation', id: string } };

export type SendConversationMessageMutationVariables = Exact<{
  messageDto: MessageDto;
}>;


export type SendConversationMessageMutation = { __typename?: 'Mutation', sendConversationMessage: { __typename?: 'ChatMessage', id: string, text: string, created: any, resolved: boolean, deleted: boolean, isSenderBlocked?: boolean | null, sender: { __typename?: 'UserField', id?: string | null }, richContent?: { __typename?: 'RichMessageContent', systemMessages?: Array<{ __typename?: 'SystemMessage', message: string }> | null } | null } };

export type GetChatConversationMessagesQueryVariables = Exact<{
  getMessageDto: GetMessageDto;
}>;


export type GetChatConversationMessagesQuery = { __typename?: 'Query', getChatConversationMessages: { __typename?: 'PaginatedChatMessages', hasMore: boolean, messages: Array<{ __typename?: 'ChatMessage', id: string, created: any, text: string, deleted: boolean, isSenderBlocked?: boolean | null, sender: { __typename?: 'UserField', id?: string | null }, richContent?: { __typename?: 'RichMessageContent', dynamicMessage?: { __typename?: 'DynamicMessageTemplate', templateId: string } | null } | null }> } };

export type GetChatGroupByIdQueryQueryVariables = Exact<{
  chatGroupId: Scalars['String']['input'];
}>;


export type GetChatGroupByIdQueryQuery = { __typename?: 'Query', chatGroupById?: { __typename?: 'ChatGroupField', id?: string | null, opponent?: { __typename?: 'AnyChatUserField', id?: string | null, firstName?: string | null, inboxInfoOne?: string | null, countryCode?: string | null, inboxInfoTwo?: string | null, isEnterprise?: boolean | null, headlineInfo?: string | null, profilePhoto?: string | null, accountRole?: string | null, isOnline?: boolean | null, degreeLevel?: string | null, degrees?: Array<{ __typename?: 'MentorDegreeField', degreeType?: DegreeType | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null } | null> | null } | null, creationSource?: { __typename?: 'CreationSource', id?: string | null, slug?: string | null, type?: string | null, name?: string | null } | null } | null };

export type GetConversationWithAmbassadorQueryVariables = Exact<{
  ambassadorId: Scalars['String']['input'];
}>;


export type GetConversationWithAmbassadorQuery = { __typename?: 'Query', getConversationWithAmbassador?: { __typename?: 'ChatConversation', id: string } | null };

export type BlogPostDetailQueryQueryVariables = Exact<{
  postId?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlogPostDetailQueryQuery = { __typename?: 'Query', post?: { __typename?: 'BlogPostField', id?: string | null, title?: string | null, body?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, created?: string | null, modified?: string | null, readingTime?: number | null, numberOfViews?: number | null, status?: BlogStatus | null, flaggedByUser?: boolean | null, shareUrl?: string | null, videoContent?: { __typename?: 'VideoContent', id: string, status: VideoStatus, type: VideoTypeEnum, url: { __typename?: 'VideoUrl', url?: string | null } } | null, topic?: { __typename?: 'BlogTopicField', id?: string | null, name?: string | null } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, accountRole?: string | null, active?: boolean | null, archived?: boolean | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, widgetUrl?: string | null } | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null } | null } | null } | null };

export type ContentListPageQueryQueryVariables = Exact<{
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContentListPageQueryQuery = { __typename?: 'Query', allPostsInfo?: { __typename?: 'AllPostsField', blogPostsCount?: number | null, blogPostsTopics?: Array<string | null> | null, blogPostsAuthors?: Array<string | null> | null, blogPosts?: Array<{ __typename?: 'BlogPostField', id?: string | null, title?: string | null, status?: BlogStatus | null, body?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, numberOfViews?: number | null, readingTime?: number | null, created?: string | null, modified?: string | null, ogShareUrl?: string | null, shareUrl?: string | null, flaggedByUser?: boolean | null, videoContent?: { __typename?: 'VideoContent', id: string, status: VideoStatus, type: VideoTypeEnum, url: { __typename?: 'VideoUrl', url?: string | null } } | null, topic?: { __typename?: 'BlogTopicField', id?: string | null, name?: string | null } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, active?: boolean | null, archived?: boolean | null, accountRole?: string | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null } | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null } | null } | null } | null> | null, blogPostsDegrees?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null } | null> | null } | null };

export type ContentPostDetailsFragmentFragment = { __typename?: 'BlogPostField', id?: string | null, title?: string | null, status?: BlogStatus | null, body?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, numberOfViews?: number | null, readingTime?: number | null, created?: string | null, modified?: string | null, ogShareUrl?: string | null, shareUrl?: string | null, flaggedByUser?: boolean | null, videoContent?: { __typename?: 'VideoContent', id: string, status: VideoStatus, type: VideoTypeEnum, url: { __typename?: 'VideoUrl', url?: string | null } } | null, topic?: { __typename?: 'BlogTopicField', id?: string | null, name?: string | null } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, active?: boolean | null, archived?: boolean | null, accountRole?: string | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null } | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null } | null } | null };

export type GetContentTopicsQueryQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetContentTopicsQueryQuery = { __typename?: 'Query', blogTopics?: Array<{ __typename?: 'BlogTopicField', id?: string | null, name?: string | null } | null> | null };

export type ViewBlogMutationMutationVariables = Exact<{
  blogId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewBlogMutationMutation = { __typename?: 'Mutation', viewBlog?: { __typename?: 'ViewBlogMutation', post?: { __typename?: 'BlogPostField', numberOfViews?: number | null } | null } | null };

export type UniversityQuestionsWithAnswersQueryQueryVariables = Exact<{
  universityQuestionInput: UniversityQuestionInput;
  universityQuestionAnswerInput: UniversityQuestionAnswerInput;
}>;


export type UniversityQuestionsWithAnswersQueryQuery = { __typename?: 'Query', universityQuestions: Array<{ __typename?: 'UniversityQuestion', id: any, answers: Array<{ __typename?: 'UniversityQuestionAnswer', text: string }> }> };

export type GetRandomAmbassadorsQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
}>;


export type GetRandomAmbassadorsQuery = { __typename?: 'Query', sequenceFilterMentorList?: { __typename?: 'SequenceFilterMentorListField', mentors?: Array<{ __typename?: 'PublicMentorField', id?: string | null, firstName?: string | null, profilePhoto?: string | null } | null> | null } | null };

export type BlogPostPreviewFragmentFragment = { __typename?: 'BlogPostField', id?: string | null, title?: string | null, body?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, videoContent?: { __typename?: 'VideoContent', id: string, url: { __typename?: 'VideoUrl', url?: string | null } } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, archived?: boolean | null, profilePhoto?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null } | null };

export type BlogPostsQueryQueryVariables = Exact<{
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlogPostsQueryQuery = { __typename?: 'Query', allPostsInfo?: { __typename?: 'AllPostsField', blogPosts?: Array<{ __typename?: 'BlogPostField', id?: string | null, title?: string | null, body?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, videoContent?: { __typename?: 'VideoContent', id: string, url: { __typename?: 'VideoUrl', url?: string | null } } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, archived?: boolean | null, profilePhoto?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type SequenceFilterMentorListQueryQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  sequenceFilter?: InputMaybe<Array<InputMaybe<MentorFilterInputField>> | InputMaybe<MentorFilterInputField>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
  applyDegreeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  isDegreeTypesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  domesticOrInternational?: InputMaybe<DomesticOrInternational>;
}>;


export type SequenceFilterMentorListQueryQuery = { __typename?: 'Query', sequenceFilterMentorList?: { __typename?: 'SequenceFilterMentorListField', mentorSeed?: number | null, mentors?: Array<{ __typename?: 'PublicMentorField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, lastSeen?: string | null, year?: string | null, pastQualification?: string | null, placeName?: string | null, shortBio?: string | null, bio?: string | null, degreeLevel?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, degrees?: Array<{ __typename?: 'MentorDegreeField', degreeType?: DegreeType | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null } | null> | null, languages?: Array<{ __typename?: 'LanguageField', id?: string | null, name?: string | null } | null> | null, favouriteModules?: Array<{ __typename?: 'MentorModuleField', id?: string | null, name?: string | null } | null> | null, interests?: Array<{ __typename?: 'MentorInterestField', id?: string | null, name?: string | null } | null> | null, societies?: Array<{ __typename?: 'MentorSocietyField', id?: string | null, name?: string | null } | null> | null, customAttributes?: Array<{ __typename?: 'DateValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null } | null } | { __typename?: 'OpenTextFieldValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null } | null } | { __typename?: 'SingleChoiceValueField', value?: string | null, option?: { __typename?: 'CustomAttributeOptionField', id?: string | null, value?: string | null } | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null } | null } | null> | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null } | null } | null> | null, filters?: Array<{ __typename?: 'MentorFilterField', id?: string | null, label?: string | null, options?: Array<{ __typename?: 'MentorFilterOptionField', id?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type GenerateRecommendationsMutationVariables = Exact<{
  universityId: Scalars['ObjectId']['input'];
  batchSize: Scalars['Int']['input'];
  countryId?: InputMaybe<Scalars['ObjectId']['input']>;
  domesticRegionId?: InputMaybe<Scalars['ObjectId']['input']>;
  degreeLevelId?: InputMaybe<Scalars['ObjectId']['input']>;
  areaOfStudyIds?: InputMaybe<Array<Scalars['ObjectId']['input']> | Scalars['ObjectId']['input']>;
  expectedEntry?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GenerateRecommendationsMutation = { __typename?: 'Mutation', generateRecommendations: Array<{ __typename?: 'Recommendation', id: any, contentId: any, batchId: any, title: string, description: string, url: string, type: RecommendationResourceTypeEnum }> };

export type SaveVisitedRecommendationMutationVariables = Exact<{
  contentId: Scalars['ObjectId']['input'];
  batchId: Scalars['ObjectId']['input'];
}>;


export type SaveVisitedRecommendationMutation = { __typename?: 'Mutation', saveVisitedRecommendation: { __typename?: 'Recommendation', id: any, contentId: any, batchId: any, title: string, description: string, url: string, type: RecommendationResourceTypeEnum } };

export type NotInterestedStageMutationMutationVariables = Exact<{
  universityId: Scalars['ObjectId']['input'];
  decisionStage: DecisionStageEnum;
  prospectStageLocation: DecisionStageLocationEnum;
  notInterestedReason: NotInterestedReasonEnum;
}>;


export type NotInterestedStageMutationMutation = { __typename?: 'Mutation', saveNotInterestedStage: { __typename?: 'UserDecisionStageOutput', userId: any } };

export type GetCountriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQueryQuery = { __typename?: 'Query', allCountries?: Array<{ __typename?: 'CountryField', id?: string | null, name?: string | null } | null> | null };

export type UpdateApplicantAgeVerificationMutationVariables = Exact<{
  ageVerificationInfo: AgeVerificationInfoInputField;
}>;


export type UpdateApplicantAgeVerificationMutation = { __typename?: 'Mutation', updateApplicant?: { __typename?: 'UpdateApplicantMutation', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', id?: string | null, email?: string | null } | null } | null } | null };

export type GetUniversityProviderQueryQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniversityProviderQueryQuery = { __typename?: 'Query', university?: { __typename?: 'UniversityField', mentorMessagesCount?: number | null, id?: string | null, name?: string | null, nickname?: string | null, slug?: string | null, logo?: string | null, squareLogo?: string | null, isEnterprise?: boolean | null, whiteLogo?: string | null, widgetUrl?: string | null, colour?: string | null, launchDate?: string | null, privacyPolicyUrl?: string | null, customMarketingConsentText?: string | null, customPreSignupText?: string | null, customAttributes?: Array<{ __typename?: 'BaseCustomAttributeField', id?: string | null, type?: string | null, name?: string | null, active?: boolean | null, required?: boolean | null, options?: Array<{ __typename?: 'CustomAttributeOptionField', id?: string | null, value?: string | null } | null> | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, type?: string | null, name?: string | null, active?: boolean | null, required?: boolean | null, options?: Array<{ __typename?: 'CustomAttributeOptionField', id?: string | null, value?: string | null } | null> | null } | null> | null, widgetUrls?: Array<{ __typename?: 'WidgetUrlField', locale?: string | null, name?: string | null, url?: string | null } | null> | null, customMarketingConsentTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customPreSignupTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customChatBubbleTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, entries?: { __typename?: 'EntriesField', active?: boolean | null, entryMonths?: Array<number | null> | null } | null, degreeTypeOrder?: Array<{ __typename?: 'DegreeTypeOrderField', type?: DegreeType | null, order?: number | null } | null> | null, mentorFieldOrder?: Array<{ __typename?: 'MentorFieldOrderField', field?: string | null, order?: number | null } | null> | null, mentorFieldLabels?: Array<{ __typename?: 'MentorFieldCustomLabel', key?: string | null, customLabel?: string | null } | null> | null, config?: { __typename?: 'UniversityConfigField', features?: Array<{ __typename?: 'UniversityFeatureField', enabled?: boolean | null, isReadOnly?: boolean | null, feature?: { __typename?: 'FeatureField', name?: string | null } | null } | null> | null } | null } | null };

export type RandomMentorListQueryQueryVariables = Exact<{
  universitySlug: Scalars['String']['input'];
  sequenceFilter?: InputMaybe<Array<InputMaybe<MentorFilterInputField>> | InputMaybe<MentorFilterInputField>>;
  applyDegreeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  domesticOrInternational?: InputMaybe<DomesticOrInternational>;
  ubLang?: InputMaybe<Scalars['String']['input']>;
}>;


export type RandomMentorListQueryQuery = { __typename?: 'Query', university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, nickname?: string | null, slug?: string | null, logo?: string | null, squareLogo?: string | null, isEnterprise?: boolean | null, whiteLogo?: string | null, widgetUrl?: string | null, colour?: string | null, launchDate?: string | null, privacyPolicyUrl?: string | null, customMarketingConsentText?: string | null, customPreSignupText?: string | null, universityWidgetUrls?: Array<{ __typename?: 'WidgetUrlField', url?: string | null } | null> | null, widgetUrls?: Array<{ __typename?: 'WidgetUrlField', locale?: string | null, name?: string | null, url?: string | null } | null> | null, customMarketingConsentTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customPreSignupTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, customChatBubbleTextInLocales?: Array<{ __typename?: 'TextInLocale', locale?: string | null, name?: string | null, text?: string | null } | null> | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, entries?: { __typename?: 'EntriesField', active?: boolean | null, entryMonths?: Array<number | null> | null } | null, degreeTypeOrder?: Array<{ __typename?: 'DegreeTypeOrderField', type?: DegreeType | null, order?: number | null } | null> | null, mentorFieldOrder?: Array<{ __typename?: 'MentorFieldOrderField', field?: string | null, order?: number | null } | null> | null, mentorFieldLabels?: Array<{ __typename?: 'MentorFieldCustomLabel', key?: string | null, customLabel?: string | null } | null> | null, config?: { __typename?: 'UniversityConfigField', features?: Array<{ __typename?: 'UniversityFeatureField', enabled?: boolean | null, isReadOnly?: boolean | null, feature?: { __typename?: 'FeatureField', name?: string | null } | null } | null> | null } | null } | null, sequenceFilterMentorList?: { __typename?: 'SequenceFilterMentorListField', mentors?: Array<{ __typename?: 'PublicMentorField', id?: string | null, profilePhoto?: string | null, firstName?: string | null, lastSeen?: string | null, degreeLevel?: string | null, placeName?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', code?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', code?: string | null } | null } | null } | null> | null } | null };
